import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	DateTime: { input: string; output: string };
	JSON: { input: any; output: any };
	LowercaseString: { input: string; output: string };
	Password: { input: string; output: string };
	PhoneNumber: { input: string; output: string };
	join__FieldSet: { input: string; output: string };
	link__Import: { input: string; output: string };
};

export type ActivateTrainingPlanInput = {
	trainingPlanId: Scalars['ID']['input'];
};

export type AddUserToDepartmentInput = {
	departmentId: Scalars['ID']['input'];
	organizationUserId: Scalars['ID']['input'];
	role: OrganizationRoleEnum;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type AddUserToTeamInput = {
	organizationUserId: Scalars['ID']['input'];
	role: OrganizationRoleEnum;
	teamId: Scalars['ID']['input'];
	title?: InputMaybe<Scalars['String']['input']>;
};

export type AddWorkoutsToPlanInput = {
	trainingPlanId: Scalars['ID']['input'];
	workoutIds: Array<Scalars['ID']['input']>;
};

export enum AddressType {
	Billing = 'BILLING',
	Branch = 'BRANCH',
	Headquarters = 'HEADQUARTERS',
	Other = 'OTHER',
	Shipping = 'SHIPPING',
}

export type AddressValidationResult = {
	__typename?: 'AddressValidationResult';
	errors: Array<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
	warnings: Array<Scalars['String']['output']>;
};

export type AdminNewsletterSubscriber = Base & {
	__typename?: 'AdminNewsletterSubscriber';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	firstName?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	lastName?: Maybe<Scalars['String']['output']>;
	status: AdminNewsletterSubscriberStatusEnum;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminNewsletterSubscriberPage = {
	__typename?: 'AdminNewsletterSubscriberPage';
	data: Array<AdminNewsletterSubscriber>;
	pageInfo: PageInfo;
};

export enum AdminNewsletterSubscriberStatusEnum {
	Active = 'ACTIVE',
	Unsubscribed = 'UNSUBSCRIBED',
}

export type AdminSystemSetting = {
	__typename?: 'AdminSystemSetting';
	createdAt: Scalars['DateTime']['output'];
	id: Scalars['ID']['output'];
	minAppVersionAndroid?: Maybe<Scalars['String']['output']>;
	minAppVersionIOS?: Maybe<Scalars['String']['output']>;
	updatedAt: Scalars['DateTime']['output'];
};

export type AdminUser = Base & {
	__typename?: 'AdminUser';
	authenticationUser?: Maybe<AuthenticationUser>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastName: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type AdminUserPage = {
	__typename?: 'AdminUserPage';
	data: Array<AdminUser>;
	pageInfo: PageInfo;
};

export type AppVersionCheckResponse = {
	__typename?: 'AppVersionCheckResponse';
	minVersion?: Maybe<Scalars['String']['output']>;
	updateRequired: Scalars['Boolean']['output'];
};

export type AssignPermissionsToRoleInput = {
	permissionIds: Array<Scalars['ID']['input']>;
	roleId: Scalars['ID']['input'];
};

export enum AttendeeResponseStatusEnum {
	Accepted = 'ACCEPTED',
	Declined = 'DECLINED',
	Pending = 'PENDING',
	Tentative = 'TENTATIVE',
}

export type AudioData = {
	__typename?: 'AudioData';
	duration: Scalars['Int']['output'];
	fileId?: Maybe<Scalars['String']['output']>;
	mediaUrls: Array<MediaUrl>;
	url?: Maybe<Scalars['String']['output']>;
};

export enum AuthRoleEnum {
	Admin = 'ADMIN',
	Organization = 'ORGANIZATION',
	User = 'USER',
}

export type AuthenticationToken = Base & {
	__typename?: 'AuthenticationToken';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	secret?: Maybe<Scalars['String']['output']>;
	token: Scalars['String']['output'];
	type: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	user?: Maybe<AuthenticationUser>;
	userId: Scalars['ID']['output'];
};

export enum AuthenticationTokenTypeEnum {
	Login = 'LOGIN',
	Refresh = 'REFRESH',
	Register = 'REGISTER',
	ResetPassword = 'RESET_PASSWORD',
	Validation = 'VALIDATION',
}

export type AuthenticationUser = Base & {
	__typename?: 'AuthenticationUser';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	emailAuthTag?: Maybe<Scalars['String']['output']>;
	emailIv?: Maybe<Scalars['String']['output']>;
	encryptedEmail?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isMigrated: Scalars['Boolean']['output'];
	isPremium: Scalars['Boolean']['output'];
	language: Scalars['String']['output'];
	lastActive?: Maybe<Scalars['DateTime']['output']>;
	lockReason?: Maybe<Scalars['String']['output']>;
	lockedAt?: Maybe<Scalars['DateTime']['output']>;
	metadata?: Maybe<AuthenticationUserMetadata>;
	mfaBypassedAt?: Maybe<Scalars['DateTime']['output']>;
	mfaEnabled: Scalars['Boolean']['output'];
	mfaMethod?: Maybe<MfaMethodEnum>;
	organizationUser?: Maybe<OrganizationUser>;
	premiumApprovedAt?: Maybe<Scalars['DateTime']['output']>;
	premiumRequestedAt?: Maybe<Scalars['DateTime']['output']>;
	role: AuthRoleEnum;
	status: StatusEnum;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	user?: Maybe<User>;
};

export type AuthenticationUserInput = {
	email: Scalars['String']['input'];
};

export type AuthenticationUserMetadata = {
	__typename?: 'AuthenticationUserMetadata';
	organizationId?: Maybe<Scalars['ID']['output']>;
};

export type AuthenticationUserPage = {
	__typename?: 'AuthenticationUserPage';
	data: Array<AuthenticationUser>;
	pageInfo: PageInfo;
};

export type AuthenticationUserUpdateInput = {
	email?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	language?: InputMaybe<Scalars['String']['input']>;
	role?: InputMaybe<AuthRoleEnum>;
};

export type AuthorizationPermission = Base & {
	__typename?: 'AuthorizationPermission';
	action?: Maybe<AuthorizationPermissionAction>;
	authorizationRolePermissions?: Maybe<Array<AuthorizationRolePermission>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	resource?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AuthorizationPermissionAction {
	Create = 'CREATE',
	Delete = 'DELETE',
	Read = 'READ',
	Update = 'UPDATE',
}

export type AuthorizationRole = Base & {
	__typename?: 'AuthorizationRole';
	authorizationRolePermissions?: Maybe<Array<AuthorizationRolePermission>>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	scope: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorizationRoleCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	permissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AuthorizationRolePage = {
	__typename?: 'AuthorizationRolePage';
	data?: Maybe<Array<AuthorizationRole>>;
	pageInfo: PageInfo;
};

export type AuthorizationRolePermission = Base & {
	__typename?: 'AuthorizationRolePermission';
	authorizationPermission?: Maybe<AuthorizationPermission>;
	authorizationPermissionId: Scalars['ID']['output'];
	authorizationRoleId: Scalars['ID']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorizationRoleUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorizationUserRole = Base & {
	__typename?: 'AuthorizationUserRole';
	authorizationRole?: Maybe<AuthorizationRole>;
	authorizationRoleId: Scalars['ID']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	resourceId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type AuthorizationUserRolePage = {
	__typename?: 'AuthorizationUserRolePage';
	data?: Maybe<Array<AuthorizationUserRole>>;
	pageInfo: PageInfo;
};

export type BackupCodesResponse = {
	__typename?: 'BackupCodesResponse';
	backupCodes: Array<Scalars['String']['output']>;
	message: Scalars['String']['output'];
};

export type Base = {
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum BookingStatusEnum {
	Canceled = 'CANCELED',
	Completed = 'COMPLETED',
	Confirmed = 'CONFIRMED',
	NoShow = 'NO_SHOW',
	Pending = 'PENDING',
	Rescheduled = 'RESCHEDULED',
}

export type BreathingData = {
	__typename?: 'BreathingData';
	exhale: Scalars['Int']['output'];
	exhaleHold: Scalars['Int']['output'];
	inhale: Scalars['Int']['output'];
	inhaleHold: Scalars['Int']['output'];
	instructions?: Maybe<Scalars['JSON']['output']>;
	mediaUrl?: Maybe<Scalars['String']['output']>;
	mediaUrls: Array<MediaUrl>;
};

export type BulkAddUsersToDepartmentInput = {
	departmentId: Scalars['ID']['input'];
	users: Array<DepartmentUserInput>;
};

export type BulkAddUsersToTeamInput = {
	teamId: Scalars['ID']['input'];
	users: Array<TeamUserInput>;
};

export type BusinessRegistration = {
	__typename?: 'BusinessRegistration';
	number: Scalars['String']['output'];
	type: Scalars['String']['output'];
	verified?: Maybe<Scalars['Boolean']['output']>;
	verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessRegistrationInput = {
	number: Scalars['String']['input'];
	type: Scalars['String']['input'];
};

export type CvrAddress = {
	__typename?: 'CVRAddress';
	city: Scalars['String']['output'];
	country: Scalars['String']['output'];
	street: Scalars['String']['output'];
	zipcode: Scalars['String']['output'];
};

export type CvrCompanyInfo = {
	__typename?: 'CVRCompanyInfo';
	active: Scalars['Boolean']['output'];
	address: CvrAddress;
	email?: Maybe<Scalars['String']['output']>;
	employees?: Maybe<Scalars['String']['output']>;
	industryCode?: Maybe<Scalars['Int']['output']>;
	industryDescription?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	phone?: Maybe<Scalars['String']['output']>;
	startDate?: Maybe<Scalars['String']['output']>;
	vat: Scalars['String']['output'];
};

export type CvrValidationResult = {
	__typename?: 'CVRValidationResult';
	companyInfo?: Maybe<CvrCompanyInfo>;
	error?: Maybe<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
};

export enum CalendarEventStatusEnum {
	Canceled = 'CANCELED',
	Completed = 'COMPLETED',
	Scheduled = 'SCHEDULED',
}

export enum CalendarEventTypeEnum {
	BlockedTime = 'BLOCKED_TIME',
	Booking = 'BOOKING',
	Holiday = 'HOLIDAY',
	Meeting = 'MEETING',
	Organization = 'ORGANIZATION',
	Personal = 'PERSONAL',
}

export type CreateAdminUserInput = {
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
};

export type CreateExerciseInput = {
	durationMax?: InputMaybe<Scalars['Int']['input']>;
	durationMin?: InputMaybe<Scalars['Int']['input']>;
	groupId?: InputMaybe<Scalars['Int']['input']>;
	sortOrder: Scalars['Int']['input'];
	translations: Array<ExerciseTranslationInput>;
	typeData: Scalars['JSON']['input'];
};

export type CreateManyAuthorizationUserRoleInput = {
	authorizationRoleIds: Array<Scalars['ID']['input']>;
	userId: Scalars['ID']['input'];
};

export type CreateTrainingPlanInput = {
	categoryIds: Array<Scalars['ID']['input']>;
	duration: TrainingPlanDuration;
	isAllCategories: Scalars['Boolean']['input'];
};

export type CreateUserInput = {
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
};

export type CreateWellBeingSurveyResponseInput = {
	answers: Scalars['JSON']['input'];
};

export type CreateWorkoutInput = {
	categoryId: Scalars['ID']['input'];
	durationMax?: InputMaybe<Scalars['Int']['input']>;
	durationMin?: InputMaybe<Scalars['Int']['input']>;
	exercises: Array<CreateExerciseInput>;
	frequency: Scalars['Int']['input'];
	frequencyPeriod: FrequencyPeriodEnum;
	intensity: WorkoutIntensityEnum;
	isPremium?: InputMaybe<Scalars['Boolean']['input']>;
	translations: Array<WorkoutTranslationInput>;
	type: ExerciseTypeEnum;
};

export enum CurrencyEnum {
	Aed = 'AED',
	Ars = 'ARS',
	Aud = 'AUD',
	Bgn = 'BGN',
	Brl = 'BRL',
	Cad = 'CAD',
	Chf = 'CHF',
	Clp = 'CLP',
	Cny = 'CNY',
	Cop = 'COP',
	Czk = 'CZK',
	Dkk = 'DKK',
	Egp = 'EGP',
	Eur = 'EUR',
	Gbp = 'GBP',
	Hkd = 'HKD',
	Hrk = 'HRK',
	Huf = 'HUF',
	Idr = 'IDR',
	Ils = 'ILS',
	Inr = 'INR',
	Isk = 'ISK',
	Jpy = 'JPY',
	Krw = 'KRW',
	Mxn = 'MXN',
	Myr = 'MYR',
	Nok = 'NOK',
	Nzd = 'NZD',
	Pen = 'PEN',
	Php = 'PHP',
	Pln = 'PLN',
	Ron = 'RON',
	Sar = 'SAR',
	Sek = 'SEK',
	Sgd = 'SGD',
	Thb = 'THB',
	Try = 'TRY',
	Usd = 'USD',
	Vnd = 'VND',
	Zar = 'ZAR',
}

export type DateRangeInput = {
	endDate?: InputMaybe<Scalars['String']['input']>;
	startDate: Scalars['String']['input'];
};

export enum DayOfWeekEnum {
	Friday = 'FRIDAY',
	Monday = 'MONDAY',
	Saturday = 'SATURDAY',
	Sunday = 'SUNDAY',
	Thursday = 'THURSDAY',
	Tuesday = 'TUESDAY',
	Wednesday = 'WEDNESDAY',
}

export type DeleteInput = {
	id: Scalars['ID']['input'];
};

export type DeleteManyAdminNewsletterSubscriberResponse = {
	__typename?: 'DeleteManyAdminNewsletterSubscriberResponse';
	deleted: Scalars['Int']['output'];
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type DeleteManyAuthorizationUserRoleInput = {
	authorizationRoleIds: Array<Scalars['ID']['input']>;
	userId: Scalars['ID']['input'];
};

export type DeleteManyInput = {
	ids: Array<Scalars['ID']['input']>;
};

export type DepartmentUserInput = {
	organizationUserId: Scalars['ID']['input'];
	role: OrganizationRoleEnum;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadUrlResponse = {
	__typename?: 'DownloadUrlResponse';
	downloadUrl: Scalars['String']['output'];
	errors?: Maybe<Array<ResponseError>>;
	expiresAt: Scalars['DateTime']['output'];
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type Enable2FaAfterSignupInput = {
	mfaMethod: MfaMethodEnum;
	userId: Scalars['ID']['input'];
};

export type Exercise = Base & {
	__typename?: 'Exercise';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description: Scalars['String']['output'];
	durationMax?: Maybe<Scalars['Int']['output']>;
	durationMin?: Maybe<Scalars['Int']['output']>;
	groupId?: Maybe<Scalars['Int']['output']>;
	id: Scalars['ID']['output'];
	isActive: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	sortOrder: Scalars['Int']['output'];
	tips: Array<Scalars['String']['output']>;
	translations: Array<ExerciseTranslation>;
	typeData: ExerciseTypeData;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	workoutId: Scalars['ID']['output'];
};

export type ExerciseAnswer = {
	__typename?: 'ExerciseAnswer';
	answer: Scalars['String']['output'];
	exerciseId: Scalars['ID']['output'];
	inputIndex: Scalars['Int']['output'];
	question: Scalars['String']['output'];
};

export type ExerciseAnswerInput = {
	answer: Scalars['String']['input'];
	exerciseId: Scalars['ID']['input'];
	inputIndex: Scalars['Int']['input'];
	question: Scalars['String']['input'];
};

export type ExerciseImage = {
	__typename?: 'ExerciseImage';
	exerciseId: Scalars['ID']['output'];
	imageUrls: Array<Scalars['String']['output']>;
};

export type ExerciseImageInput = {
	exerciseId: Scalars['ID']['input'];
	imageUrls: Array<Scalars['String']['input']>;
};

export type ExerciseTranslation = {
	__typename?: 'ExerciseTranslation';
	description: Scalars['String']['output'];
	language: Scalars['String']['output'];
	name: Scalars['String']['output'];
	tips: Array<Scalars['String']['output']>;
};

export type ExerciseTranslationInput = {
	description: Scalars['String']['input'];
	language: Scalars['String']['input'];
	name: Scalars['String']['input'];
	tips: Array<Scalars['String']['input']>;
};

export type ExerciseTypeData =
	AudioData | BreathingData | ImageUploadData | ReflectionInputData | VideoData;

export enum ExerciseTypeEnum {
	Audio = 'AUDIO',
	Breathing = 'BREATHING',
	ImageUpload = 'IMAGE_UPLOAD',
	ReflectionInput = 'REFLECTION_INPUT',
	Video = 'VIDEO',
}

export type FileInput = {
	fileType?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	url: Scalars['String']['input'];
};

export enum FileTypeEnum {
	Csv = 'CSV',
	Excel = 'EXCEL',
	Font = 'FONT',
	Image = 'IMAGE',
	Pdf = 'PDF',
	Video = 'VIDEO',
}

export enum FrequencyPeriodEnum {
	Daily = 'DAILY',
	Monthly = 'MONTHLY',
	Weekly = 'WEEKLY',
	Yearly = 'YEARLY',
}

export type GenerateMediaUploadInput = {
	exerciseType: ExerciseTypeEnum;
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	language?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateUploadUrlInput = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
	fileType: Scalars['String']['input'];
	organizationUserId: Scalars['ID']['input'];
};

export type GetAllAdminAuthenticationUserInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	premiumStatus?: InputMaybe<PremiumStatusFilter>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllAdminNewsletterSubscriberInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<AdminNewsletterSubscriberStatusEnum>;
};

export type GetAllAdminUserInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	premiumStatusFilter?: InputMaybe<PremiumStatusFilter>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllAuthorizationRoleInput = {
	excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	scope?: InputMaybe<Scalars['String']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllAuthorizationUserRoleInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
	userId: Scalars['ID']['input'];
};

export type GetAllLoggingAuditLogInput = {
	dateRange?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	referenceId?: InputMaybe<Scalars['ID']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
	userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAllLoggingLoginLogInput = {
	dateRange?: InputMaybe<DateRangeInput>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	referenceId?: InputMaybe<Scalars['ID']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
	userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAllOrganizationDepartmentInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	parentDepartmentId?: InputMaybe<Scalars['ID']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllOrganizationDepartmentUserInput = {
	departmentId?: InputMaybe<Scalars['ID']['input']>;
	order?: InputMaybe<OrderInput>;
	organizationUserId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	role?: InputMaybe<OrganizationRoleEnum>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllOrganizationInput = {
	countryCode?: InputMaybe<Scalars['String']['input']>;
	industry?: InputMaybe<OrganizationIndustryEnum>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllOrganizationTeamInput = {
	departmentId?: InputMaybe<Scalars['ID']['input']>;
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllOrganizationTeamUserInput = {
	order?: InputMaybe<OrderInput>;
	organizationUserId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	role?: InputMaybe<OrganizationRoleEnum>;
	search?: InputMaybe<Scalars['String']['input']>;
	teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAllOrganizationUserInput = {
	order?: InputMaybe<OrderInput>;
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllUserAuthenticationUserInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	premiumStatusFilter?: InputMaybe<PremiumStatusFilter>;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllUserInput = {
	loginStatusFilter?: InputMaybe<LoginStatusFilter>;
	mfaBypassFilter?: InputMaybe<MfaBypassFilter>;
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	premiumStatusFilter?: InputMaybe<PremiumStatusFilter>;
	search?: InputMaybe<Scalars['String']['input']>;
	signupStatusFilter?: InputMaybe<SignupStatusFilter>;
};

export type GetDownloadUrlInput = {
	organizationUserId: Scalars['ID']['input'];
};

export type GetMyAuthorizationUserRoleInput = {
	order?: InputMaybe<OrderInput>;
	pagination: PaginationInput;
	search?: InputMaybe<Scalars['String']['input']>;
};

export type GraphQlContext = {
	__typename?: 'GraphQLContext';
	exp?: Maybe<Scalars['String']['output']>;
	iat?: Maybe<Scalars['String']['output']>;
	sub?: Maybe<Scalars['String']['output']>;
};

export type GroupedWorkoutCompletion = {
	__typename?: 'GroupedWorkoutCompletion';
	completions: Array<WorkoutCompletion>;
	monthYear: Scalars['String']['output'];
};

export type HierarchyEntity = OrganizationDepartment | OrganizationTeam;

export enum HierarchyEntityTypeEnum {
	Department = 'DEPARTMENT',
	Team = 'TEAM',
}

export type HierarchySortOrderUpdate = {
	entityId: Scalars['ID']['input'];
	entityType: HierarchyEntityTypeEnum;
	sortOrder: Scalars['Int']['input'];
};

export type HierarchyUser = {
	__typename?: 'HierarchyUser';
	organizationUserId: Scalars['ID']['output'];
	role: OrganizationRoleEnum;
	title?: Maybe<Scalars['String']['output']>;
};

export type ImageUploadData = {
	__typename?: 'ImageUploadData';
	maxImages: Scalars['Int']['output'];
	minImages: Scalars['Int']['output'];
};

export type LocalizationAddressFormat = {
	__typename?: 'LocalizationAddressFormat';
	postalCodeLabel: Scalars['String']['output'];
	stateLabel?: Maybe<Scalars['String']['output']>;
	stateRequired: Scalars['Boolean']['output'];
};

export type LocalizationBusinessRegistrationType = {
	__typename?: 'LocalizationBusinessRegistrationType';
	code: Scalars['String']['output'];
	helpText?: Maybe<Scalars['String']['output']>;
	isRequired: Scalars['Boolean']['output'];
	label: Scalars['String']['output'];
	placeholder?: Maybe<Scalars['String']['output']>;
	vatDerivationPattern?: Maybe<Scalars['String']['output']>;
};

export type LocalizationCountry = {
	__typename?: 'LocalizationCountry';
	addressFormat: LocalizationAddressFormat;
	code: Scalars['String']['output'];
	currency?: Maybe<Scalars['String']['output']>;
	defaultMeasurementSystem?: Maybe<MeasurementSystemEnum>;
	defaultTimezone?: Maybe<Scalars['String']['output']>;
	hasStates: Scalars['Boolean']['output'];
	isEU: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	nativeName?: Maybe<Scalars['String']['output']>;
	phonePrefix?: Maybe<Scalars['String']['output']>;
	registrations: Array<LocalizationBusinessRegistrationType>;
	states: Array<LocalizationState>;
};

export type LocalizationDefaults = {
	__typename?: 'LocalizationDefaults';
	countryCode: Scalars['String']['output'];
	currency: CurrencyEnum;
	measurementSystem: MeasurementSystemEnum;
	timezone: Scalars['String']['output'];
};

export type LocalizationOrganizationSetting = Base & {
	__typename?: 'LocalizationOrganizationSetting';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	offset: Scalars['String']['output'];
	organizationId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocalizationState = {
	__typename?: 'LocalizationState';
	code: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type LocalizationTimezone = {
	__typename?: 'LocalizationTimezone';
	name: Scalars['String']['output'];
	offset: Scalars['String']['output'];
};

export type LoggingAuditLog = Base & {
	__typename?: 'LoggingAuditLog';
	action?: Maybe<Scalars['String']['output']>;
	changes?: Maybe<Scalars['JSON']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	metadata?: Maybe<Scalars['JSON']['output']>;
	organizationId?: Maybe<Scalars['ID']['output']>;
	resource?: Maybe<Scalars['String']['output']>;
	resourceId?: Maybe<Scalars['ID']['output']>;
	serviceName?: Maybe<Scalars['String']['output']>;
	status?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId?: Maybe<Scalars['ID']['output']>;
};

export type LoggingAuditLogPage = {
	__typename?: 'LoggingAuditLogPage';
	data: Array<LoggingAuditLog>;
	pageInfo: PageInfo;
};

export type LoggingLoginLog = Base & {
	__typename?: 'LoggingLoginLog';
	browser: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	failureReason?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	ipAddress: Scalars['String']['output'];
	method: Scalars['String']['output'];
	os: Scalars['String']['output'];
	referenceId: Scalars['ID']['output'];
	serviceId: Scalars['String']['output'];
	status: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	user?: Maybe<AuthenticationUser>;
	userAgent: Scalars['String']['output'];
	userId: Scalars['ID']['output'];
};

export type LoggingLoginLogPage = {
	__typename?: 'LoggingLoginLogPage';
	data: Array<LoggingLoginLog>;
	pageInfo: PageInfo;
};

export type LoginInput = {
	authKey: Scalars['String']['input'];
	authSecret: Scalars['String']['input'];
};

export enum LoginLockReason {
	AccountPermanentlyLocked = 'AccountPermanentlyLocked',
	AccountTemporarilyLocked = 'AccountTemporarilyLocked',
	TooManyAttemptsFromThisIp = 'TooManyAttemptsFromThisIP',
}

export type LoginResponse = {
	__typename?: 'LoginResponse';
	backupCodes?: Maybe<Array<Scalars['String']['output']>>;
	isMigrated: Scalars['Boolean']['output'];
	mfaMethod?: Maybe<MfaMethodEnum>;
	mfaRequired: Scalars['Boolean']['output'];
	role: AuthRoleEnum;
	supportsBackupCodes: Scalars['Boolean']['output'];
	token: Scalars['String']['output'];
	userId: Scalars['ID']['output'];
};

export enum LoginStatusFilter {
	All = 'ALL',
	HasLoggedIn = 'HAS_LOGGED_IN',
	NeverLoggedIn = 'NEVER_LOGGED_IN',
}

export type LoginValidateInput = {
	role?: InputMaybe<Array<AuthRoleEnum>>;
	token: Scalars['String']['input'];
};

export type LoginValidateResponse = {
	__typename?: 'LoginValidateResponse';
	refreshToken: Scalars['String']['output'];
	token: Scalars['String']['output'];
	user: AuthenticationUser;
};

export type LoginWithBackupCodeInput = {
	backupCode: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type LogoutInput = {
	refreshToken: Scalars['String']['input'];
	token: Scalars['String']['input'];
};

export enum MeasurementSystemEnum {
	Imperial = 'IMPERIAL',
	Metric = 'METRIC',
}

export type MediaUploadUrlResponse = {
	__typename?: 'MediaUploadUrlResponse';
	blobUrl: Scalars['String']['output'];
	expiresAt: Scalars['DateTime']['output'];
	fileId: Scalars['String']['output'];
	uploadUrl: Scalars['String']['output'];
};

export type MediaUrl = {
	__typename?: 'MediaUrl';
	fileId?: Maybe<Scalars['String']['output']>;
	language: Scalars['String']['output'];
	url: Scalars['String']['output'];
};

export type MessageResponse = {
	__typename?: 'MessageResponse';
	errors?: Maybe<Array<ResponseError>>;
	message: Scalars['String']['output'];
	messageKey?: Maybe<Scalars['String']['output']>;
	referenceKey?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export enum MessageType {
	File = 'file',
	System = 'system',
	Text = 'text',
}

export enum MfaBypassFilter {
	All = 'ALL',
	Bypassed = 'BYPASSED',
	NotBypassed = 'NOT_BYPASSED',
}

export enum MfaMethodEnum {
	Authenticator = 'Authenticator',
	Email = 'Email',
}

export type MigrationResponse = {
	__typename?: 'MigrationResponse';
	jobId?: Maybe<Scalars['String']['output']>;
	message: Scalars['String']['output'];
	migrationStatus: MigrationStatusEnum;
	success: Scalars['Boolean']['output'];
};

export enum MigrationStatusEnum {
	Completed = 'COMPLETED',
	Failed = 'FAILED',
	InProgress = 'IN_PROGRESS',
	None = 'NONE',
}

export type MultipleDeleteResponse = {
	__typename?: 'MultipleDeleteResponse';
	deleted?: Maybe<Scalars['Int']['output']>;
	failed?: Maybe<Scalars['Int']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
	__typename?: 'Mutation';
	activateTrainingPlan: TrainingPlan;
	addUserToDepartment: MessageResponse;
	addUserToTeam: MessageResponse;
	/** Add workout to favorites */
	addWorkoutToFavorites: Scalars['Boolean']['output'];
	addWorkoutsToPlan: TrainingPlan;
	approveManyPremiumAccess: MessageResponse;
	approvePremiumAccess: AuthenticationUser;
	archiveTrainingPlan: TrainingPlan;
	assignPermissionsToRole: MessageResponse;
	bulkAddUsersToDepartment: MessageResponse;
	bulkAddUsersToTeam: MessageResponse;
	/** Bulk update workout sort order */
	bulkUpdateWorkoutSortOrder: Scalars['Boolean']['output'];
	bypassManyMigrated2FA: MessageResponse;
	bypassMigrated2FA: MessageResponse;
	/** Complete strength profile PDF upload after direct upload to Azure (User only) */
	completeStrengthProfileUpload: User;
	/** Create a new admin user (Admin only) */
	createAdminUser: MessageResponse;
	createAuthorizationRole: MessageResponse;
	createManyAuthorizationUserRole: MessageResponse;
	createOrganization: MessageResponse;
	createOrganizationAddress: OrganizationAddress;
	createOrganizationDepartment: MessageResponse;
	createOrganizationOnboarding: OrganizationOnboardingResponse;
	createOrganizationSignup: RegisterResponse;
	createOrganizationTeam: MessageResponse;
	createOrganizationUser: MessageResponse;
	createTrainingPlan: TrainingPlan;
	/** Create a new user (Admin/System operation) */
	createUser: MessageResponse;
	createUserSignup: RegisterResponse;
	createWellBeingSurveyResponse: WellBeingSurveyResponse;
	/** Create a new workout with exercises */
	createWorkout: Workout;
	deleteAccount: MessageResponse;
	/** Delete an admin user (Admin only) */
	deleteAdminUser: MessageResponse;
	deleteAuthorizationRole: MessageResponse;
	/** Delete selected newsletter subscribers (Admin only) */
	deleteManyAdminNewsletterSubscriber: DeleteManyAdminNewsletterSubscriberResponse;
	/** Delete multiple admin users (Admin only) */
	deleteManyAdminUser: MessageResponse;
	deleteManyAuthorizationRole: MessageResponse;
	deleteManyAuthorizationUserRole: MessageResponse;
	deleteManyOrganization?: Maybe<MessageResponse>;
	deleteManyOrganizationDepartment: MessageResponse;
	deleteManyOrganizationTeam: MessageResponse;
	deleteManyOrganizationUser: MessageResponse;
	/** Delete multiple users (Admin operation) */
	deleteManyUser: MessageResponse;
	/** Delete a media file from Azure Storage */
	deleteMediaFile: Scalars['Boolean']['output'];
	deleteMyOrganization: MessageResponse;
	deleteOrganization?: Maybe<MessageResponse>;
	deleteOrganizationAddress: MessageResponse;
	deleteOrganizationDepartment: MessageResponse;
	deleteOrganizationTeam: MessageResponse;
	deleteOrganizationUser: MessageResponse;
	/** Delete strength profile PDF (User only) */
	deleteStrengthProfile: User;
	deleteTrainingPlan: Scalars['Boolean']['output'];
	/** Delete a user (Admin operation) */
	deleteUser: MessageResponse;
	/** Delete a workout */
	deleteWorkout: Scalars['Boolean']['output'];
	enable2FAAfterSignup: RegisterResponse;
	/** Generate a pre-signed upload URL for media files (audio/video) */
	generateMediaUploadUrl: MediaUploadUrlResponse;
	generateOrganizationUserAvatarUploadUrl: UploadUrlResponse;
	/** Generate presigned URL for strength profile PDF upload (User only) */
	generateStrengthProfileUploadUrl: StrengthProfileUploadUrlResponse;
	login: LoginResponse;
	loginValidate: LoginValidateResponse;
	loginWithBackupCode: MessageResponse;
	logout: MessageResponse;
	passwordReset: MessageResponse;
	passwordResetRequest: Scalars['String']['output'];
	passwordResetValidate: MessageResponse;
	passwordUpdate: MessageResponse;
	recordWorkoutCompletion: WorkoutCompletion;
	refreshToken: LoginValidateResponse;
	refreshUserToken: UpdateLanguageResponse;
	regenerateBackupCodes: BackupCodesResponse;
	register: RegisterResponse;
	/** Register or update push notification token (User only) */
	registerPushToken: User;
	rejectManyPremiumAccess: MessageResponse;
	rejectPremiumAccess: AuthenticationUser;
	removePermissionsFromRole: MessageResponse;
	removeUserFromDepartment: MessageResponse;
	removeUserFromTeam: MessageResponse;
	/** Remove workout from favorites */
	removeWorkoutFromFavorites: Scalars['Boolean']['output'];
	requestEmailChange: MessageResponse;
	requestPremiumAccess: AuthenticationUser;
	resendEmailMfaCode: MessageResponse;
	resendPasswordResetRequest: Scalars['String']['output'];
	/** Resubscribe to the newsletter (public) */
	resubscribeAdminNewsletterSubscriber: UnsubscribeAdminNewsletterSubscriberResponse;
	/** Retry failed migration for current user (User only) */
	retryUserMigration: MigrationResponse;
	root?: Maybe<Scalars['String']['output']>;
	/** Send an email (template HTML via SendGrid) to the selected subscribers (Admin only) */
	sendAdminNewsletterEmail: SendAdminNewsletterEmailResponse;
	sendMigratedUser2FACode: MessageResponse;
	/** Trigger on-demand Firebase data migration for current user (User only) */
	triggerUserMigration: MigrationResponse;
	unlockAuthenticationUser: MessageResponse;
	/** Unsubscribe from the newsletter (public) */
	unsubscribeAdminNewsletterSubscriber: UnsubscribeAdminNewsletterSubscriberResponse;
	/** Update an admin user (Admin only) */
	updateAdminUser: MessageResponse;
	updateAuthorizationRole: MessageResponse;
	updateDepartmentUserRole: MessageResponse;
	updateHierarchySortOrder: MessageResponse;
	updateLanguage: UpdateLanguageResponse;
	updateOrganization: MessageResponse;
	updateOrganizationAddress: OrganizationAddress;
	updateOrganizationApprovalAndMargin: MessageResponse;
	updateOrganizationDepartment: MessageResponse;
	updateOrganizationSetting: MessageResponse;
	updateOrganizationTeam: MessageResponse;
	updateOrganizationUser: MessageResponse;
	updateSystemSettings: MessageResponse;
	updateTeamUserRole: MessageResponse;
	/** Update translations for multiple languages */
	updateTranslation: Array<Translation>;
	/** Update a user (User only - own profile) */
	updateUser: MessageResponse;
	updateUserProfile: AuthenticationUser;
	updateWellBeingSurveyQuestionTranslations: Scalars['Boolean']['output'];
	/** Update an existing workout */
	updateWorkout: Workout;
	/** Update a workout category */
	updateWorkoutCategory: WorkoutCategory;
	updateWorkoutSchedule: TrainingPlan;
	/** Upload newsletter subscribers from a CSV list (Admin only) */
	uploadAdminNewsletterSubscribers: UploadAdminNewsletterSubscribersResponse;
	/** Upload strength profile PDF (User only) - Legacy base64 upload */
	uploadStrengthProfile: User;
	validateAuthenticationToken: AuthenticationToken;
	verifyAuthenticatorMfa: LoginResponse;
	verifyAuthenticatorSetup: LoginResponse;
	verifyEmailChange: AuthenticationUser;
	verifyEmailMfa: LoginResponse;
	verifyEmailSignup: LoginResponse;
	verifyMigratedUser2FAAndSetPassword: LoginResponse;
};

export type MutationActivateTrainingPlanArgs = {
	input: ActivateTrainingPlanInput;
};

export type MutationAddUserToDepartmentArgs = {
	input: AddUserToDepartmentInput;
};

export type MutationAddUserToTeamArgs = {
	input: AddUserToTeamInput;
};

export type MutationAddWorkoutToFavoritesArgs = {
	workoutId: Scalars['ID']['input'];
};

export type MutationAddWorkoutsToPlanArgs = {
	input: AddWorkoutsToPlanInput;
};

export type MutationApproveManyPremiumAccessArgs = {
	userIds: Array<Scalars['ID']['input']>;
};

export type MutationApprovePremiumAccessArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationArchiveTrainingPlanArgs = {
	id: Scalars['ID']['input'];
};

export type MutationAssignPermissionsToRoleArgs = {
	input: AssignPermissionsToRoleInput;
};

export type MutationBulkAddUsersToDepartmentArgs = {
	input: BulkAddUsersToDepartmentInput;
};

export type MutationBulkAddUsersToTeamArgs = {
	input: BulkAddUsersToTeamInput;
};

export type MutationBulkUpdateWorkoutSortOrderArgs = {
	input: Array<WorkoutSortOrderInput>;
};

export type MutationBypassManyMigrated2FaArgs = {
	userIds: Array<Scalars['ID']['input']>;
};

export type MutationBypassMigrated2FaArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationCompleteStrengthProfileUploadArgs = {
	blobUrl: Scalars['String']['input'];
};

export type MutationCreateAdminUserArgs = {
	input: CreateAdminUserInput;
};

export type MutationCreateAuthorizationRoleArgs = {
	input: AuthorizationRoleCreateInput;
};

export type MutationCreateManyAuthorizationUserRoleArgs = {
	input: CreateManyAuthorizationUserRoleInput;
};

export type MutationCreateOrganizationArgs = {
	input: OrganizationCreateInput;
};

export type MutationCreateOrganizationAddressArgs = {
	input: OrganizationAddressInput;
	organizationId: Scalars['ID']['input'];
};

export type MutationCreateOrganizationDepartmentArgs = {
	input: OrganizationDepartmentCreateInput;
};

export type MutationCreateOrganizationOnboardingArgs = {
	input: OrganizationOnboardingInput;
};

export type MutationCreateOrganizationSignupArgs = {
	input: OrganizationSignupInput;
};

export type MutationCreateOrganizationTeamArgs = {
	input: OrganizationTeamCreateInput;
};

export type MutationCreateOrganizationUserArgs = {
	input: OrganizationUserCreateInput;
};

export type MutationCreateTrainingPlanArgs = {
	input: CreateTrainingPlanInput;
};

export type MutationCreateUserArgs = {
	input: CreateUserInput;
};

export type MutationCreateUserSignupArgs = {
	input: UserSignupInput;
};

export type MutationCreateWellBeingSurveyResponseArgs = {
	input: CreateWellBeingSurveyResponseInput;
};

export type MutationCreateWorkoutArgs = {
	input: CreateWorkoutInput;
};

export type MutationDeleteAdminUserArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteAuthorizationRoleArgs = {
	input: DeleteInput;
};

export type MutationDeleteManyAdminNewsletterSubscriberArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyAdminUserArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyAuthorizationRoleArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyAuthorizationUserRoleArgs = {
	input: DeleteManyAuthorizationUserRoleInput;
};

export type MutationDeleteManyOrganizationArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyOrganizationDepartmentArgs = {
	ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteManyOrganizationTeamArgs = {
	ids: Array<Scalars['ID']['input']>;
};

export type MutationDeleteManyOrganizationUserArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteManyUserArgs = {
	input: DeleteManyInput;
};

export type MutationDeleteMediaFileArgs = {
	blobUrl: Scalars['String']['input'];
};

export type MutationDeleteOrganizationArgs = {
	input: DeleteInput;
};

export type MutationDeleteOrganizationAddressArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationDepartmentArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationTeamArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationUserArgs = {
	input: DeleteInput;
};

export type MutationDeleteTrainingPlanArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteUserArgs = {
	id: Scalars['ID']['input'];
};

export type MutationDeleteWorkoutArgs = {
	id: Scalars['ID']['input'];
};

export type MutationEnable2FaAfterSignupArgs = {
	input: Enable2FaAfterSignupInput;
};

export type MutationGenerateMediaUploadUrlArgs = {
	input: GenerateMediaUploadInput;
};

export type MutationGenerateOrganizationUserAvatarUploadUrlArgs = {
	input: GenerateUploadUrlInput;
};

export type MutationGenerateStrengthProfileUploadUrlArgs = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Int']['input'];
};

export type MutationLoginArgs = {
	input: LoginInput;
};

export type MutationLoginValidateArgs = {
	input: LoginValidateInput;
};

export type MutationLoginWithBackupCodeArgs = {
	input: LoginWithBackupCodeInput;
};

export type MutationLogoutArgs = {
	input: LogoutInput;
};

export type MutationPasswordResetArgs = {
	input: PasswordResetInput;
};

export type MutationPasswordResetRequestArgs = {
	input: PasswordResetRequestInput;
};

export type MutationPasswordResetValidateArgs = {
	input: PasswordResetValidateInput;
};

export type MutationPasswordUpdateArgs = {
	input: PasswordUpdateInput;
};

export type MutationRecordWorkoutCompletionArgs = {
	input: RecordWorkoutCompletionInput;
};

export type MutationRefreshTokenArgs = {
	token: Scalars['String']['input'];
};

export type MutationRegenerateBackupCodesArgs = {
	input: RegenerateBackupCodesInput;
};

export type MutationRegisterArgs = {
	input: RegisterInput;
};

export type MutationRegisterPushTokenArgs = {
	token: Scalars['String']['input'];
};

export type MutationRejectManyPremiumAccessArgs = {
	userIds: Array<Scalars['ID']['input']>;
};

export type MutationRejectPremiumAccessArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationRemovePermissionsFromRoleArgs = {
	input: RemovePermissionsFromRoleInput;
};

export type MutationRemoveUserFromDepartmentArgs = {
	departmentId: Scalars['ID']['input'];
	organizationUserId: Scalars['ID']['input'];
};

export type MutationRemoveUserFromTeamArgs = {
	organizationUserId: Scalars['ID']['input'];
	teamId: Scalars['ID']['input'];
};

export type MutationRemoveWorkoutFromFavoritesArgs = {
	workoutId: Scalars['ID']['input'];
};

export type MutationRequestEmailChangeArgs = {
	newEmail: Scalars['String']['input'];
};

export type MutationResendEmailMfaCodeArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationResendPasswordResetRequestArgs = {
	input: PasswordResetRequestInput;
};

export type MutationResubscribeAdminNewsletterSubscriberArgs = {
	email: Scalars['String']['input'];
};

export type MutationSendAdminNewsletterEmailArgs = {
	input: SendAdminNewsletterEmailInput;
};

export type MutationSendMigratedUser2FaCodeArgs = {
	input: SendMigratedUser2FaCodeInput;
};

export type MutationUnlockAuthenticationUserArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationUnsubscribeAdminNewsletterSubscriberArgs = {
	email: Scalars['String']['input'];
};

export type MutationUpdateAdminUserArgs = {
	id: Scalars['ID']['input'];
	input: UpdateAdminUserInput;
};

export type MutationUpdateAuthorizationRoleArgs = {
	input: AuthorizationRoleUpdateInput;
};

export type MutationUpdateDepartmentUserRoleArgs = {
	input: UpdateDepartmentUserRoleInput;
};

export type MutationUpdateHierarchySortOrderArgs = {
	input: UpdateHierarchySortOrderInput;
};

export type MutationUpdateLanguageArgs = {
	language: Scalars['String']['input'];
};

export type MutationUpdateOrganizationArgs = {
	input: OrganizationUpdateInput;
};

export type MutationUpdateOrganizationAddressArgs = {
	id: Scalars['ID']['input'];
	input: OrganizationAddressInput;
};

export type MutationUpdateOrganizationApprovalAndMarginArgs = {
	input: UpdateOrganizationApprovalAndMarginInput;
};

export type MutationUpdateOrganizationDepartmentArgs = {
	input: OrganizationDepartmentUpdateInput;
};

export type MutationUpdateOrganizationSettingArgs = {
	input: OrganizationSettingUpdateInput;
};

export type MutationUpdateOrganizationTeamArgs = {
	input: OrganizationTeamUpdateInput;
};

export type MutationUpdateOrganizationUserArgs = {
	input: OrganizationUserUpdateInput;
};

export type MutationUpdateSystemSettingsArgs = {
	input: UpdateSystemSettingInput;
};

export type MutationUpdateTeamUserRoleArgs = {
	input: UpdateTeamUserRoleInput;
};

export type MutationUpdateTranslationArgs = {
	input: UpdateTranslationInput;
};

export type MutationUpdateUserArgs = {
	id: Scalars['ID']['input'];
	input: UpdateUserInput;
};

export type MutationUpdateUserProfileArgs = {
	input: UpdateUserProfileInput;
};

export type MutationUpdateWellBeingSurveyQuestionTranslationsArgs = {
	input: UpdateWellBeingSurveyTranslationsInput;
};

export type MutationUpdateWorkoutArgs = {
	id: Scalars['ID']['input'];
	input: UpdateWorkoutInput;
};

export type MutationUpdateWorkoutCategoryArgs = {
	input: UpdateWorkoutCategoryInput;
};

export type MutationUpdateWorkoutScheduleArgs = {
	input: UpdateWorkoutScheduleInput;
};

export type MutationUploadAdminNewsletterSubscribersArgs = {
	input: Array<UploadAdminNewsletterSubscriberInput>;
};

export type MutationUploadStrengthProfileArgs = {
	input: FileInput;
};

export type MutationValidateAuthenticationTokenArgs = {
	token: Scalars['String']['input'];
};

export type MutationVerifyAuthenticatorMfaArgs = {
	input: VerifyAuthenticatorMfaInput;
};

export type MutationVerifyAuthenticatorSetupArgs = {
	input: VerifyAuthenticatorSetupInput;
};

export type MutationVerifyEmailChangeArgs = {
	code: Scalars['String']['input'];
};

export type MutationVerifyEmailMfaArgs = {
	input: VerifyEmailMfaInput;
};

export type MutationVerifyEmailSignupArgs = {
	input: VerifyEmailSignupInput;
};

export type MutationVerifyMigratedUser2FaAndSetPasswordArgs = {
	input: VerifyMigratedUser2FaAndSetPasswordInput;
};

export type OrderInput = {
	direction: OrderTypes;
	field: Scalars['String']['input'];
};

export enum OrderTypes {
	Asc = 'ASC',
	Desc = 'DESC',
}

export type Organization = Base & {
	__typename?: 'Organization';
	addresses?: Maybe<Array<OrganizationAddress>>;
	businessRegistrations?: Maybe<Array<BusinessRegistration>>;
	countryCode?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	industry?: Maybe<OrganizationIndustryEnum>;
	logo?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	onboarded: Scalars['Boolean']['output'];
	organizationSetting?: Maybe<OrganizationSetting>;
	organizationUsers?: Maybe<Array<OrganizationUser>>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAddress = Base & {
	__typename?: 'OrganizationAddress';
	addressLine1: Scalars['String']['output'];
	addressLine2?: Maybe<Scalars['String']['output']>;
	addressType: AddressType;
	city: Scalars['String']['output'];
	countryCode: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	googlePlaceId?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	isPrimary: Scalars['Boolean']['output'];
	latitude?: Maybe<Scalars['Float']['output']>;
	longitude?: Maybe<Scalars['Float']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	postalCode: Scalars['String']['output'];
	stateCode?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationAddressInput = {
	addressLine1: Scalars['String']['input'];
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	addressType?: InputMaybe<AddressType>;
	city: Scalars['String']['input'];
	countryCode: Scalars['String']['input'];
	googlePlaceId?: InputMaybe<Scalars['String']['input']>;
	isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
	latitude?: InputMaybe<Scalars['Float']['input']>;
	longitude?: InputMaybe<Scalars['Float']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	postalCode: Scalars['String']['input'];
	stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationApprovalAndMargin = {
	__typename?: 'OrganizationApprovalAndMargin';
	defaultApproval: Scalars['Boolean']['output'];
	defaultMargin: Scalars['Float']['output'];
	organizationId: Scalars['ID']['output'];
};

export type OrganizationCreateInput = {
	businessRegistrations?: InputMaybe<Array<BusinessRegistrationInput>>;
	countryCode: Scalars['String']['input'];
	industry?: InputMaybe<OrganizationIndustryEnum>;
	name: Scalars['String']['input'];
	users?: InputMaybe<Array<UserInput>>;
	websiteUrl: Scalars['String']['input'];
};

export type OrganizationDepartment = Base & {
	__typename?: 'OrganizationDepartment';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	level: Scalars['Int']['output'];
	name: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	parentDepartment?: Maybe<OrganizationDepartment>;
	parentDepartmentId?: Maybe<Scalars['ID']['output']>;
	subDepartments?: Maybe<Array<OrganizationDepartment>>;
	teams?: Maybe<Array<OrganizationTeam>>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	users?: Maybe<Array<OrganizationDepartmentUser>>;
};

export type OrganizationDepartmentCreateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	organizationId: Scalars['ID']['input'];
	parentDepartmentId?: InputMaybe<Scalars['ID']['input']>;
	teams?: InputMaybe<Array<OrganizationTeamCreateNestedInput>>;
	users?: InputMaybe<Array<OrganizationDepartmentUserCreateInput>>;
};

export type OrganizationDepartmentPage = {
	__typename?: 'OrganizationDepartmentPage';
	data: Array<OrganizationDepartment>;
	pageInfo: PageInfo;
};

export type OrganizationDepartmentUpdateInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
	parentDepartmentId?: InputMaybe<Scalars['ID']['input']>;
	teams?: InputMaybe<Array<OrganizationTeamCreateNestedInput>>;
	users?: InputMaybe<Array<OrganizationDepartmentUserCreateInput>>;
};

export type OrganizationDepartmentUser = Base & {
	__typename?: 'OrganizationDepartmentUser';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	department?: Maybe<OrganizationDepartment>;
	departmentId: Scalars['ID']['output'];
	id: Scalars['ID']['output'];
	organizationUser?: Maybe<OrganizationUser>;
	organizationUserId: Scalars['ID']['output'];
	role: OrganizationRoleEnum;
	title?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationDepartmentUserCreateInput = {
	organizationUserId: Scalars['ID']['input'];
	role: OrganizationRoleEnum;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationDepartmentUserPage = {
	__typename?: 'OrganizationDepartmentUserPage';
	data: Array<OrganizationDepartmentUser>;
	pageInfo: PageInfo;
};

export type OrganizationHierarchyNode = {
	__typename?: 'OrganizationHierarchyNode';
	children?: Maybe<Array<OrganizationHierarchyNode>>;
	entity: HierarchyEntity;
	entityId: Scalars['ID']['output'];
	entityType: HierarchyEntityTypeEnum;
	id: Scalars['ID']['output'];
	level: Scalars['Int']['output'];
	parentId?: Maybe<Scalars['ID']['output']>;
	path: Scalars['String']['output'];
	sortOrder: Scalars['Int']['output'];
	users?: Maybe<Array<HierarchyUser>>;
};

export type OrganizationHierarchyResponse = {
	__typename?: 'OrganizationHierarchyResponse';
	hierarchy: Array<OrganizationHierarchyNode>;
	organization: Organization;
	totalDepartments: Scalars['Int']['output'];
	totalTeams: Scalars['Int']['output'];
	totalUsers: Scalars['Int']['output'];
};

export enum OrganizationIndustryEnum {
	Agriculture = 'AGRICULTURE',
	Construction = 'CONSTRUCTION',
	Consulting = 'CONSULTING',
	Energy = 'ENERGY',
	Finance = 'FINANCE',
	Healthcare = 'HEALTHCARE',
	Logistics = 'LOGISTICS',
	Manufacturing = 'MANUFACTURING',
	Other = 'OTHER',
	Retail = 'RETAIL',
	Shipping = 'SHIPPING',
	Technology = 'TECHNOLOGY',
	Transportation = 'TRANSPORTATION',
}

export enum OrganizationLocationEnum {
	Africa = 'AFRICA',
	Asia = 'ASIA',
	Australia = 'AUSTRALIA',
	Europe = 'EUROPE',
	Global = 'GLOBAL',
	NorthernEurope = 'NORTHERN_EUROPE',
	NorthAmerica = 'NORTH_AMERICA',
	SouthAmerica = 'SOUTH_AMERICA',
}

export type OrganizationOnboardingInput = {
	organizationId: Scalars['ID']['input'];
};

export type OrganizationOnboardingResponse = {
	__typename?: 'OrganizationOnboardingResponse';
	message: Scalars['String']['output'];
	organizationId: Scalars['ID']['output'];
	success: Scalars['Boolean']['output'];
};

export type OrganizationPage = {
	__typename?: 'OrganizationPage';
	data: Array<Organization>;
	pageInfo: PageInfo;
};

export type OrganizationResponse = {
	__typename?: 'OrganizationResponse';
	data?: Maybe<Organization>;
	message: Scalars['String']['output'];
	messageKey: Scalars['String']['output'];
	success: Scalars['Boolean']['output'];
};

export enum OrganizationRoleEnum {
	CoLeader = 'CO_LEADER',
	Leader = 'LEADER',
	Member = 'MEMBER',
}

export type OrganizationSetting = Base & {
	__typename?: 'OrganizationSetting';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	currency?: Maybe<CurrencyEnum>;
	id: Scalars['ID']['output'];
	measurementSystem: MeasurementSystemEnum;
	organizationId: Scalars['ID']['output'];
	timezone: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationSettingUpdateInput = {
	currency: CurrencyEnum;
	id: Scalars['ID']['input'];
	measurementSystem: MeasurementSystemEnum;
	timezone: Scalars['String']['input'];
};

export type OrganizationSettingsInput = {
	currency?: InputMaybe<CurrencyEnum>;
	measurementSystem?: InputMaybe<MeasurementSystemEnum>;
	timezone?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSignupInput = {
	address?: InputMaybe<SignupAddressInput>;
	businessRegistrations?: InputMaybe<Array<BusinessRegistrationInput>>;
	countryCode: Scalars['String']['input'];
	currency: CurrencyEnum;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	industry?: InputMaybe<OrganizationIndustryEnum>;
	jobPosition: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	measurementSystem: MeasurementSystemEnum;
	mfaMethod: MfaMethodEnum;
	organizationName: Scalars['String']['input'];
	password: Scalars['String']['input'];
	role: AuthRoleEnum;
	timezone: Scalars['ID']['input'];
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationTeam = Base & {
	__typename?: 'OrganizationTeam';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	department?: Maybe<OrganizationDepartment>;
	departmentId?: Maybe<Scalars['ID']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	users?: Maybe<Array<OrganizationTeamUser>>;
};

export type OrganizationTeamCreateInput = {
	departmentId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	organizationId: Scalars['ID']['input'];
	users?: InputMaybe<Array<OrganizationTeamUserCreateInput>>;
};

export type OrganizationTeamCreateNestedInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	name: Scalars['String']['input'];
	users?: InputMaybe<Array<OrganizationTeamUserCreateInput>>;
};

export type OrganizationTeamPage = {
	__typename?: 'OrganizationTeamPage';
	data: Array<OrganizationTeam>;
	pageInfo: PageInfo;
};

export type OrganizationTeamUpdateInput = {
	departmentId?: InputMaybe<Scalars['ID']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	name?: InputMaybe<Scalars['String']['input']>;
	users?: InputMaybe<Array<OrganizationTeamUserCreateInput>>;
};

export type OrganizationTeamUser = Base & {
	__typename?: 'OrganizationTeamUser';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	organizationUser?: Maybe<OrganizationUser>;
	organizationUserId: Scalars['ID']['output'];
	role: OrganizationRoleEnum;
	team?: Maybe<OrganizationTeam>;
	teamId: Scalars['ID']['output'];
	title?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationTeamUserCreateInput = {
	organizationUserId: Scalars['ID']['input'];
	role: OrganizationRoleEnum;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationTeamUserPage = {
	__typename?: 'OrganizationTeamUserPage';
	data: Array<OrganizationTeamUser>;
	pageInfo: PageInfo;
};

export type OrganizationUpdateInput = {
	businessRegistrations?: InputMaybe<Array<BusinessRegistrationInput>>;
	countryCode?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	industry?: InputMaybe<OrganizationIndustryEnum>;
	name?: InputMaybe<Scalars['String']['input']>;
	settings?: InputMaybe<OrganizationSettingsInput>;
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUser = Base & {
	__typename?: 'OrganizationUser';
	authenticationUser?: Maybe<AuthenticationUser>;
	authorizationUserRoles?: Maybe<Array<Maybe<AuthorizationUserRole>>>;
	avatar?: Maybe<Scalars['String']['output']>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	jobPosition?: Maybe<Scalars['String']['output']>;
	lastName: Scalars['String']['output'];
	organization?: Maybe<Organization>;
	organizationId: Scalars['ID']['output'];
	roles?: Maybe<Array<Scalars['ID']['output']>>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type OrganizationUserCreateInput = {
	avatar?: InputMaybe<FileInput>;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	invitationMethod: OrganizationUserInvitationMethodEnum;
	jobPosition?: InputMaybe<Scalars['String']['input']>;
	lastName: Scalars['String']['input'];
	organizationId?: InputMaybe<Scalars['ID']['input']>;
	roles?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum OrganizationUserInvitationMethodEnum {
	Manual = 'MANUAL',
	System = 'SYSTEM',
}

export type OrganizationUserPage = {
	__typename?: 'OrganizationUserPage';
	data?: Maybe<Array<OrganizationUser>>;
	errors?: Maybe<Array<ResponseError>>;
	pageInfo?: Maybe<PageInfo>;
};

export type OrganizationUserUpdateInput = {
	avatar?: InputMaybe<FileInput>;
	firstName?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	jobPosition?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
};

export type PageInfo = {
	__typename?: 'PageInfo';
	currentPage: Scalars['Int']['output'];
	hasNextPage: Scalars['Boolean']['output'];
	hasPreviousPage: Scalars['Boolean']['output'];
	totalCount: Scalars['Int']['output'];
	totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
	currentPage: Scalars['Int']['input'];
	limit: Scalars['Int']['input'];
};

export type PasswordResetInput = {
	password: Scalars['Password']['input'];
	token: Scalars['String']['input'];
};

export type PasswordResetRequestInput = {
	authKey: Scalars['String']['input'];
};

export type PasswordResetValidateInput = {
	code: Scalars['String']['input'];
	token: Scalars['String']['input'];
};

export type PasswordUpdateInput = {
	newPassword: Scalars['Password']['input'];
	oldPassword: Scalars['Password']['input'];
	userId: Scalars['ID']['input'];
};

export type PhoneInput = {
	code: Scalars['String']['input'];
	number: Scalars['String']['input'];
	schema: Scalars['String']['input'];
};

export type PlaceAutocompleteResult = {
	__typename?: 'PlaceAutocompleteResult';
	description: Scalars['String']['output'];
	mainText: Scalars['String']['output'];
	placeId: Scalars['String']['output'];
	secondaryText: Scalars['String']['output'];
};

export type PlaceDetails = {
	__typename?: 'PlaceDetails';
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	countryCode?: Maybe<Scalars['String']['output']>;
	formattedAddress: Scalars['String']['output'];
	latitude?: Maybe<Scalars['Float']['output']>;
	longitude?: Maybe<Scalars['Float']['output']>;
	placeId: Scalars['String']['output'];
	postalCode?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
	stateCode?: Maybe<Scalars['String']['output']>;
	streetName?: Maybe<Scalars['String']['output']>;
	streetNumber?: Maybe<Scalars['String']['output']>;
	timezone?: Maybe<Scalars['String']['output']>;
};

export enum PremiumStatusFilter {
	All = 'ALL',
	Approved = 'APPROVED',
	NotRequested = 'NOT_REQUESTED',
	Pending = 'PENDING',
}

export type Query = {
	__typename?: 'Query';
	addressAutocomplete: Array<PlaceAutocompleteResult>;
	canTakeWellBeingSurvey: Scalars['Boolean']['output'];
	checkAppVersion: AppVersionCheckResponse;
	formatVATNumber: Scalars['String']['output'];
	generateVATFromRegistration?: Maybe<Scalars['String']['output']>;
	getActiveTrainingPlan?: Maybe<TrainingPlan>;
	/** Get a single admin user by ID (Admin only) */
	getAdminUser?: Maybe<AdminUser>;
	getAllAdminAuthenticationUser: AuthenticationUserPage;
	/** Get newsletter subscribers with pagination (Admin only) */
	getAllAdminNewsletterSubscriber: AdminNewsletterSubscriberPage;
	/** Get all admin users with pagination (Admin only) */
	getAllAdminUser: AdminUserPage;
	getAllAuthorizationRole?: Maybe<AuthorizationRolePage>;
	getAllAuthorizationUserRole?: Maybe<AuthorizationUserRolePage>;
	getAllLocalizationCountries: Array<LocalizationCountry>;
	getAllLocalizationTimezones?: Maybe<Array<LocalizationTimezone>>;
	getAllLoggingAuditLog?: Maybe<LoggingAuditLogPage>;
	getAllLoggingLoginLog?: Maybe<LoggingLoginLogPage>;
	getAllOrganization: OrganizationPage;
	getAllOrganizationDepartment: OrganizationDepartmentPage;
	getAllOrganizationDepartmentUser: OrganizationDepartmentUserPage;
	getAllOrganizationTeam: OrganizationTeamPage;
	getAllOrganizationTeamUser: OrganizationTeamUserPage;
	getAllOrganizationUser?: Maybe<OrganizationUserPage>;
	/** Get all translations. Language is optional - defaults to user's language from context */
	getAllTranslations: Array<Translation>;
	getAllUserAuthenticationUser: AuthenticationUserPage;
	/** Get all users with pagination (Admin only) */
	getAllUsers: UserPage;
	getAllWellBeingSurveyQuestionsWithTranslations: Array<WellBeingSurveyQuestionWithTranslations>;
	/** Get all workout categories ordered by sortOrder */
	getAllWorkoutCategories: Array<WorkoutCategory>;
	/** Get all workouts with optional filters */
	getAllWorkouts: Array<Workout>;
	getAuthenticationUser: AuthenticationUser;
	getAuthorizationRole?: Maybe<AuthorizationRole>;
	getAuthorizationRoleByName?: Maybe<AuthorizationRole>;
	getDepartmentLeaders: Array<OrganizationDepartmentUser>;
	getEntityHierarchy?: Maybe<OrganizationHierarchyNode>;
	getLatestWellBeingSurveyResponse?: Maybe<WellBeingSurveyResponse>;
	getLocalizationCountry: LocalizationCountry;
	getLocalizationDefaults: LocalizationDefaults;
	getLocalizationOrganizationSetting?: Maybe<LocalizationOrganizationSetting>;
	getLocalizationStates: Array<LocalizationState>;
	/** Get current admin user's profile (Admin only) */
	getMyAdminProfile?: Maybe<AdminUser>;
	getMyAuthorizationUserRole?: Maybe<AuthorizationUserRolePage>;
	/** Get current user's profile (User only) */
	getMyUserProfile?: Maybe<User>;
	getOrganization?: Maybe<Organization>;
	getOrganizationAddresses: Array<OrganizationAddress>;
	getOrganizationApprovalAndMargin?: Maybe<OrganizationApprovalAndMargin>;
	getOrganizationDepartment?: Maybe<OrganizationDepartment>;
	getOrganizationDepartmentHierarchy: Array<OrganizationDepartment>;
	getOrganizationDepartmentUser?: Maybe<OrganizationDepartmentUser>;
	getOrganizationHierarchy: OrganizationHierarchyResponse;
	getOrganizationSetting?: Maybe<OrganizationSetting>;
	getOrganizationTeam?: Maybe<OrganizationTeam>;
	getOrganizationTeamUser?: Maybe<OrganizationTeamUser>;
	getOrganizationUser?: Maybe<OrganizationUser>;
	getOrganizationUserAvatarDownloadUrl: DownloadUrlResponse;
	getPlaceDetails?: Maybe<PlaceDetails>;
	getSupportedLanguages: Array<SupportedLanguage>;
	getSystemSettings?: Maybe<AdminSystemSetting>;
	getTeamLeaders: Array<OrganizationTeamUser>;
	getTrainingPlan?: Maybe<TrainingPlan>;
	getTrainingPlanCompletionCategories: Array<WorkoutCategory>;
	getTrainingPlansWithCompletions: Array<TrainingPlan>;
	/** Get translations by keys. Language is optional - defaults to user's language from context. Public for unauthenticated screens. */
	getTranslations: Array<Translation>;
	/** Get a single user by ID (User only) */
	getUser?: Maybe<User>;
	getUserHierarchy: UserHierarchyResponse;
	getUserTrainingPlans: Array<TrainingPlan>;
	getUserWellBeingSurveyResponses: Array<WellBeingSurveyResponse>;
	getUserWorkoutCompletions: Array<WorkoutCompletion>;
	getUserWorkoutCompletionsGrouped: WorkoutCompletionConnection;
	getVATFormat?: Maybe<Scalars['String']['output']>;
	getWellBeingSurveyQuestions: Array<WellBeingSurveyQuestion>;
	/** Get a single workout by ID */
	getWorkout?: Maybe<Workout>;
	/** Get a single workout category by ID */
	getWorkoutCategory?: Maybe<WorkoutCategory>;
	getWorkoutCompletion?: Maybe<WorkoutCompletion>;
	getWorkoutCompletions: Array<WorkoutCompletion>;
	isEUCountry: Scalars['Boolean']['output'];
	remainingBackupCodes: Scalars['Int']['output'];
	root?: Maybe<Scalars['String']['output']>;
	validateAddress: AddressValidationResult;
	validateBusinessRegistration: ValidationResult;
	validateCVR: CvrValidationResult;
	validateVAT: VatValidationResult;
};

export type QueryAddressAutocompleteArgs = {
	countryCode?: InputMaybe<Scalars['String']['input']>;
	input: Scalars['String']['input'];
	sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckAppVersionArgs = {
	platform: Scalars['String']['input'];
	version: Scalars['String']['input'];
};

export type QueryFormatVatNumberArgs = {
	countryCode: Scalars['String']['input'];
	rawNumber: Scalars['String']['input'];
};

export type QueryGenerateVatFromRegistrationArgs = {
	countryCode: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
};

export type QueryGetAdminUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetAllAdminAuthenticationUserArgs = {
	input: GetAllAdminAuthenticationUserInput;
};

export type QueryGetAllAdminNewsletterSubscriberArgs = {
	input: GetAllAdminNewsletterSubscriberInput;
};

export type QueryGetAllAdminUserArgs = {
	input: GetAllAdminUserInput;
};

export type QueryGetAllAuthorizationRoleArgs = {
	input: GetAllAuthorizationRoleInput;
};

export type QueryGetAllAuthorizationUserRoleArgs = {
	input: GetAllAuthorizationUserRoleInput;
};

export type QueryGetAllLoggingAuditLogArgs = {
	input: GetAllLoggingAuditLogInput;
};

export type QueryGetAllLoggingLoginLogArgs = {
	input: GetAllLoggingLoginLogInput;
};

export type QueryGetAllOrganizationArgs = {
	input: GetAllOrganizationInput;
};

export type QueryGetAllOrganizationDepartmentArgs = {
	input: GetAllOrganizationDepartmentInput;
};

export type QueryGetAllOrganizationDepartmentUserArgs = {
	input: GetAllOrganizationDepartmentUserInput;
};

export type QueryGetAllOrganizationTeamArgs = {
	input: GetAllOrganizationTeamInput;
};

export type QueryGetAllOrganizationTeamUserArgs = {
	input: GetAllOrganizationTeamUserInput;
};

export type QueryGetAllOrganizationUserArgs = {
	input: GetAllOrganizationUserInput;
};

export type QueryGetAllTranslationsArgs = {
	language?: InputMaybe<Scalars['String']['input']>;
	search?: InputMaybe<Scalars['String']['input']>;
	sortBy?: InputMaybe<Scalars['String']['input']>;
	sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAllUserAuthenticationUserArgs = {
	input: GetAllUserAuthenticationUserInput;
};

export type QueryGetAllUsersArgs = {
	input: GetAllUserInput;
};

export type QueryGetAllWorkoutsArgs = {
	categoryId?: InputMaybe<Scalars['ID']['input']>;
	filter?: InputMaybe<WorkoutFilterInput>;
};

export type QueryGetAuthenticationUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetAuthorizationRoleArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetAuthorizationRoleByNameArgs = {
	name: Scalars['String']['input'];
};

export type QueryGetDepartmentLeadersArgs = {
	departmentId: Scalars['ID']['input'];
};

export type QueryGetEntityHierarchyArgs = {
	entityId: Scalars['ID']['input'];
	entityType: HierarchyEntityTypeEnum;
	organizationId: Scalars['ID']['input'];
};

export type QueryGetLocalizationCountryArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryGetLocalizationDefaultsArgs = {
	placeId: Scalars['String']['input'];
};

export type QueryGetLocalizationOrganizationSettingArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetLocalizationStatesArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryGetMyAuthorizationUserRoleArgs = {
	input: GetMyAuthorizationUserRoleInput;
};

export type QueryGetOrganizationArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationAddressesArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationApprovalAndMarginArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationDepartmentArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationDepartmentHierarchyArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationDepartmentUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationHierarchyArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationSettingArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationTeamArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationTeamUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetOrganizationUserArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryGetOrganizationUserAvatarDownloadUrlArgs = {
	input: GetDownloadUrlInput;
};

export type QueryGetPlaceDetailsArgs = {
	placeId: Scalars['String']['input'];
	sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTeamLeadersArgs = {
	teamId: Scalars['ID']['input'];
};

export type QueryGetTrainingPlanArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetTranslationsArgs = {
	keys?: InputMaybe<Array<Scalars['String']['input']>>;
	language?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetUserArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetUserHierarchyArgs = {
	organizationId: Scalars['ID']['input'];
	organizationUserId: Scalars['ID']['input'];
};

export type QueryGetUserWorkoutCompletionsArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryGetUserWorkoutCompletionsGroupedArgs = {
	cursor?: InputMaybe<Scalars['String']['input']>;
	inTrainingPlan?: InputMaybe<Scalars['Boolean']['input']>;
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetVatFormatArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryGetWorkoutArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetWorkoutCategoryArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetWorkoutCompletionArgs = {
	id: Scalars['ID']['input'];
};

export type QueryGetWorkoutCompletionsArgs = {
	workoutId: Scalars['ID']['input'];
};

export type QueryIsEuCountryArgs = {
	countryCode: Scalars['String']['input'];
};

export type QueryRemainingBackupCodesArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryValidateAddressArgs = {
	placeId: Scalars['String']['input'];
};

export type QueryValidateBusinessRegistrationArgs = {
	countryCode: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
};

export type QueryValidateCvrArgs = {
	cvrNumber: Scalars['String']['input'];
};

export type QueryValidateVatArgs = {
	countryCode?: InputMaybe<Scalars['String']['input']>;
	vatNumber: Scalars['String']['input'];
};

export type RecordWorkoutCompletionInput = {
	answers?: InputMaybe<Array<ExerciseAnswerInput>>;
	images?: InputMaybe<Array<ExerciseImageInput>>;
	trainingPlanWorkoutId?: InputMaybe<Scalars['ID']['input']>;
	workoutId: Scalars['ID']['input'];
};

export type ReflectionInput = {
	__typename?: 'ReflectionInput';
	placeholder: Scalars['String']['output'];
	title: Scalars['String']['output'];
	translations: Array<ReflectionInputTranslation>;
};

export type ReflectionInputData = {
	__typename?: 'ReflectionInputData';
	inputs: Array<ReflectionInput>;
};

export type ReflectionInputTranslation = {
	__typename?: 'ReflectionInputTranslation';
	language: Scalars['String']['output'];
	placeholder: Scalars['String']['output'];
	title: Scalars['String']['output'];
};

export type RegenerateBackupCodesInput = {
	mfaToken: Scalars['String']['input'];
	password: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type RegisterInput = {
	mfaMethod: MfaMethodEnum;
	password: Scalars['String']['input'];
	token: Scalars['String']['input'];
};

export type RegisterResponse = {
	__typename?: 'RegisterResponse';
	qrCodeDataURL?: Maybe<Scalars['String']['output']>;
	userId?: Maybe<Scalars['ID']['output']>;
};

export type RemovePermissionsFromRoleInput = {
	permissionIds: Array<Scalars['ID']['input']>;
	roleId: Scalars['ID']['input'];
};

export type ResponseError = {
	__typename?: 'ResponseError';
	code?: Maybe<Scalars['String']['output']>;
	details?: Maybe<Scalars['String']['output']>;
	field?: Maybe<Scalars['String']['output']>;
	index?: Maybe<Scalars['Int']['output']>;
	message: Scalars['String']['output'];
};

export type SendAdminNewsletterEmailInput = {
	profileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	sendToAll?: InputMaybe<Scalars['Boolean']['input']>;
	subject: Scalars['String']['input'];
	templateId: Scalars['String']['input'];
};

export type SendAdminNewsletterEmailResponse = {
	__typename?: 'SendAdminNewsletterEmailResponse';
	failed: Scalars['Int']['output'];
	message?: Maybe<Scalars['String']['output']>;
	sent: Scalars['Int']['output'];
	success: Scalars['Boolean']['output'];
};

export type SendMigratedUser2FaCodeInput = {
	userId: Scalars['ID']['input'];
};

export type SignupAddressInput = {
	addressLine1: Scalars['String']['input'];
	addressLine2?: InputMaybe<Scalars['String']['input']>;
	city: Scalars['String']['input'];
	countryCode: Scalars['String']['input'];
	googlePlaceId?: InputMaybe<Scalars['String']['input']>;
	latitude?: InputMaybe<Scalars['Float']['input']>;
	longitude?: InputMaybe<Scalars['Float']['input']>;
	postalCode: Scalars['String']['input'];
	stateCode?: InputMaybe<Scalars['String']['input']>;
};

export enum SignupStatusFilter {
	All = 'ALL',
	Completed = 'COMPLETED',
	Pending = 'PENDING',
}

export enum StatusEnum {
	Canceled = 'CANCELED',
	Completed = 'COMPLETED',
	Pending = 'PENDING',
}

export type StrengthProfileUploadUrlResponse = {
	__typename?: 'StrengthProfileUploadUrlResponse';
	blobUrl?: Maybe<Scalars['String']['output']>;
	errors?: Maybe<Array<ResponseError>>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	fileId?: Maybe<Scalars['String']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
	uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type SupportedLanguage = {
	__typename?: 'SupportedLanguage';
	code: Scalars['String']['output'];
	name: Scalars['String']['output'];
	nativeName: Scalars['String']['output'];
};

export type TeamUserInput = {
	organizationUserId: Scalars['ID']['input'];
	role: OrganizationRoleEnum;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type TrainingPlan = Base & {
	__typename?: 'TrainingPlan';
	categories: Array<TrainingPlanCategory>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	duration: TrainingPlanDuration;
	id: Scalars['ID']['output'];
	isAllCategories: Scalars['Boolean']['output'];
	startDate?: Maybe<Scalars['DateTime']['output']>;
	status: TrainingPlanStatus;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
	weeks: Array<TrainingPlanWeek>;
};

export type TrainingPlanCategory = Base & {
	__typename?: 'TrainingPlanCategory';
	category: WorkoutCategory;
	categoryId: Scalars['ID']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	trainingPlanId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum TrainingPlanDuration {
	EightWeeks = 'EIGHT_WEEKS',
	FourWeeks = 'FOUR_WEEKS',
	OneWeek = 'ONE_WEEK',
	TwelveWeeks = 'TWELVE_WEEKS',
}

export enum TrainingPlanStatus {
	Active = 'ACTIVE',
	Archived = 'ARCHIVED',
	Cancelled = 'CANCELLED',
	Completed = 'COMPLETED',
	Draft = 'DRAFT',
}

export type TrainingPlanWeek = Base & {
	__typename?: 'TrainingPlanWeek';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	trainingPlanId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	weekNumber: Scalars['Int']['output'];
	workouts: Array<TrainingPlanWorkout>;
};

export type TrainingPlanWorkout = Base & {
	__typename?: 'TrainingPlanWorkout';
	completion?: Maybe<TrainingPlanWorkoutCompletion>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	dayOfWeek: Scalars['Int']['output'];
	id: Scalars['ID']['output'];
	sortOrder: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	weekId: Scalars['ID']['output'];
	workout: Workout;
	workoutId: Scalars['ID']['output'];
};

export type TrainingPlanWorkoutCompletion = Base & {
	__typename?: 'TrainingPlanWorkoutCompletion';
	completedAt: Scalars['DateTime']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	trainingPlanWorkoutId: Scalars['ID']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	workoutCompletion: WorkoutCompletion;
	workoutCompletionId: Scalars['ID']['output'];
};

export type Translation = {
	__typename?: 'Translation';
	content: Scalars['String']['output'];
	key: Scalars['String']['output'];
	language: Scalars['String']['output'];
	params?: Maybe<Array<Scalars['String']['output']>>;
};

export type TranslationContentInput = {
	content: Scalars['String']['input'];
	language: Scalars['String']['input'];
};

export type UnsubscribeAdminNewsletterSubscriberResponse = {
	__typename?: 'UnsubscribeAdminNewsletterSubscriberResponse';
	message?: Maybe<Scalars['String']['output']>;
	success: Scalars['Boolean']['output'];
};

export type UpdateAdminUserInput = {
	firstName?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDepartmentUserRoleInput = {
	departmentId: Scalars['ID']['input'];
	organizationUserId: Scalars['ID']['input'];
	role: OrganizationRoleEnum;
	title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHierarchySortOrderInput = {
	organizationId: Scalars['ID']['input'];
	updates: Array<HierarchySortOrderUpdate>;
};

export type UpdateLanguageResponse = {
	__typename?: 'UpdateLanguageResponse';
	success: Scalars['Boolean']['output'];
	token: Scalars['String']['output'];
	user: AuthenticationUser;
};

export type UpdateOrganizationApprovalAndMarginInput = {
	defaultApproval: Scalars['Boolean']['input'];
	defaultMargin: Scalars['Float']['input'];
	organizationId: Scalars['ID']['input'];
};

export type UpdateSystemSettingInput = {
	minAppVersionAndroid?: InputMaybe<Scalars['String']['input']>;
	minAppVersionIOS?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamUserRoleInput = {
	organizationUserId: Scalars['ID']['input'];
	role: OrganizationRoleEnum;
	teamId: Scalars['ID']['input'];
	title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTranslationInput = {
	key: Scalars['String']['input'];
	translations: Array<TranslationContentInput>;
};

export type UpdateUserInput = {
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
};

export type UpdateUserProfileInput = {
	firstName?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWellBeingSurveyTranslationsInput = {
	translations: Array<WellBeingSurveyQuestionTranslationInput>;
};

export type UpdateWorkoutCategoryInput = {
	cardColor?: InputMaybe<Scalars['String']['input']>;
	color: Scalars['String']['input'];
	headerColor?: InputMaybe<Scalars['String']['input']>;
	headerSvg?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
	illustrationSvg?: InputMaybe<Scalars['String']['input']>;
	translations: Array<WorkoutCategoryTranslationInput>;
};

export type UpdateWorkoutInput = {
	categoryId?: InputMaybe<Scalars['ID']['input']>;
	durationMax?: InputMaybe<Scalars['Int']['input']>;
	durationMin?: InputMaybe<Scalars['Int']['input']>;
	exercises?: InputMaybe<Array<CreateExerciseInput>>;
	frequency?: InputMaybe<Scalars['Int']['input']>;
	frequencyPeriod?: InputMaybe<FrequencyPeriodEnum>;
	intensity?: InputMaybe<WorkoutIntensityEnum>;
	isPremium?: InputMaybe<Scalars['Boolean']['input']>;
	translations?: InputMaybe<Array<WorkoutTranslationInput>>;
	type?: InputMaybe<ExerciseTypeEnum>;
};

export type UpdateWorkoutScheduleInput = {
	dayOfWeek: Scalars['Int']['input'];
	trainingPlanWorkoutId: Scalars['ID']['input'];
};

export type UploadAdminNewsletterSubscriberInput = {
	createdAt?: InputMaybe<Scalars['DateTime']['input']>;
	email: Scalars['String']['input'];
	firstName?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UploadAdminNewsletterSubscribersResponse = {
	__typename?: 'UploadAdminNewsletterSubscribersResponse';
	created: Scalars['Int']['output'];
	message?: Maybe<Scalars['String']['output']>;
	skipped: Scalars['Int']['output'];
	success: Scalars['Boolean']['output'];
	updated: Scalars['Int']['output'];
};

export type UploadUrlResponse = {
	__typename?: 'UploadUrlResponse';
	errors?: Maybe<Array<ResponseError>>;
	expiresAt?: Maybe<Scalars['DateTime']['output']>;
	message?: Maybe<Scalars['String']['output']>;
	success?: Maybe<Scalars['Boolean']['output']>;
	uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type User = Base & {
	__typename?: 'User';
	authenticationUser?: Maybe<AuthenticationUser>;
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	firstName: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastMigrationAttempt?: Maybe<Scalars['DateTime']['output']>;
	lastName: Scalars['String']['output'];
	migrationErrorMessage?: Maybe<Scalars['String']['output']>;
	migrationStatus: MigrationStatusEnum;
	pushToken?: Maybe<Scalars['String']['output']>;
	strengthProfilePdfUrl?: Maybe<Scalars['String']['output']>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type UserDepartmentRole = {
	__typename?: 'UserDepartmentRole';
	department: OrganizationDepartment;
	role: OrganizationRoleEnum;
	title?: Maybe<Scalars['String']['output']>;
};

export type UserHierarchyResponse = {
	__typename?: 'UserHierarchyResponse';
	departments: Array<UserDepartmentRole>;
	organizationRole?: Maybe<Scalars['String']['output']>;
	organizationUserId: Scalars['ID']['output'];
	teams: Array<UserTeamRole>;
};

export type UserInput = {
	birthday?: InputMaybe<Scalars['String']['input']>;
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	id?: InputMaybe<Scalars['ID']['input']>;
	image?: InputMaybe<FileInput>;
	lastName: Scalars['String']['input'];
	notes?: InputMaybe<Scalars['String']['input']>;
	phone?: InputMaybe<Scalars['String']['input']>;
};

export type UserPage = {
	__typename?: 'UserPage';
	data: Array<User>;
	pageInfo: PageInfo;
};

export type UserSignupInput = {
	email: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	mfaMethod?: InputMaybe<MfaMethodEnum>;
	password: Scalars['String']['input'];
};

export type UserTeamRole = {
	__typename?: 'UserTeamRole';
	role: OrganizationRoleEnum;
	team: OrganizationTeam;
	title?: Maybe<Scalars['String']['output']>;
};

export type VatAddress = {
	__typename?: 'VATAddress';
	city?: Maybe<Scalars['String']['output']>;
	country: Scalars['String']['output'];
	street?: Maybe<Scalars['String']['output']>;
	zipcode?: Maybe<Scalars['String']['output']>;
};

export type VatCompanyInfo = {
	__typename?: 'VATCompanyInfo';
	active?: Maybe<Scalars['Boolean']['output']>;
	address?: Maybe<VatAddress>;
	name?: Maybe<Scalars['String']['output']>;
	vat: Scalars['String']['output'];
};

export type VatValidationResult = {
	__typename?: 'VATValidationResult';
	companyInfo?: Maybe<VatCompanyInfo>;
	error?: Maybe<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
};

export type ValidationResult = {
	__typename?: 'ValidationResult';
	error?: Maybe<Scalars['String']['output']>;
	valid: Scalars['Boolean']['output'];
};

export type VerifyAuthenticatorMfaInput = {
	isBackupCode?: InputMaybe<Scalars['Boolean']['input']>;
	token: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type VerifyAuthenticatorSetupInput = {
	token: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type VerifyEmailMfaInput = {
	code: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type VerifyEmailSignupInput = {
	code: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type VerifyMigratedUser2FaAndSetPasswordInput = {
	code: Scalars['String']['input'];
	newPassword: Scalars['Password']['input'];
	userId: Scalars['ID']['input'];
};

export type VideoData = {
	__typename?: 'VideoData';
	duration: Scalars['Int']['output'];
	fileId?: Maybe<Scalars['String']['output']>;
	mediaUrls: Array<MediaUrl>;
	url?: Maybe<Scalars['String']['output']>;
};

export type WellBeingSurveyQuestion = Base & {
	__typename?: 'WellBeingSurveyQuestion';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	questionKey: Scalars['String']['output'];
	sortOrder: Scalars['Int']['output'];
	text: Scalars['String']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WellBeingSurveyQuestionTranslation = {
	__typename?: 'WellBeingSurveyQuestionTranslation';
	language: Scalars['String']['output'];
	text: Scalars['String']['output'];
};

export type WellBeingSurveyQuestionTranslationInput = {
	language: Scalars['String']['input'];
	questionId: Scalars['ID']['input'];
	text: Scalars['String']['input'];
};

export type WellBeingSurveyQuestionWithTranslations = Base & {
	__typename?: 'WellBeingSurveyQuestionWithTranslations';
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	questionKey: Scalars['String']['output'];
	sortOrder: Scalars['Int']['output'];
	translations: Array<WellBeingSurveyQuestionTranslation>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WellBeingSurveyResponse = Base & {
	__typename?: 'WellBeingSurveyResponse';
	answers: Scalars['JSON']['output'];
	completedAt: Scalars['DateTime']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	interpretation: Scalars['String']['output'];
	score: Scalars['Int']['output'];
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
};

export type Workout = Base & {
	__typename?: 'Workout';
	about: Scalars['String']['output'];
	category: WorkoutCategory;
	categoryId: Scalars['ID']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	durationMax?: Maybe<Scalars['Int']['output']>;
	durationMin?: Maybe<Scalars['Int']['output']>;
	exercises: Array<Exercise>;
	frequency: Scalars['Int']['output'];
	frequencyPeriod: FrequencyPeriodEnum;
	hasAccess: Scalars['Boolean']['output'];
	id: Scalars['ID']['output'];
	instructions: Scalars['String']['output'];
	intensity: WorkoutIntensityEnum;
	isActive: Scalars['Boolean']['output'];
	isFavorite: Scalars['Boolean']['output'];
	isPremium: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	reflectionMessage: Scalars['String']['output'];
	sortOrder: Scalars['Int']['output'];
	thankYouMessage: Scalars['String']['output'];
	translations: Array<WorkoutTranslation>;
	type: ExerciseTypeEnum;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	why: Scalars['String']['output'];
};

export type WorkoutCategory = Base & {
	__typename?: 'WorkoutCategory';
	cardColor?: Maybe<Scalars['String']['output']>;
	color: Scalars['String']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	headerColor?: Maybe<Scalars['String']['output']>;
	headerSvg?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	illustrationSvg?: Maybe<Scalars['String']['output']>;
	isActive: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	sortOrder: Scalars['Int']['output'];
	translations: Array<WorkoutCategoryTranslation>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkoutCategoryTranslation = {
	__typename?: 'WorkoutCategoryTranslation';
	language: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type WorkoutCategoryTranslationInput = {
	language: Scalars['String']['input'];
	name: Scalars['String']['input'];
};

export type WorkoutCompletion = Base & {
	__typename?: 'WorkoutCompletion';
	answers?: Maybe<Array<ExerciseAnswer>>;
	completedAt: Scalars['DateTime']['output'];
	createdAt?: Maybe<Scalars['DateTime']['output']>;
	id: Scalars['ID']['output'];
	images?: Maybe<Array<ExerciseImage>>;
	updatedAt?: Maybe<Scalars['DateTime']['output']>;
	userId: Scalars['ID']['output'];
	workout?: Maybe<Workout>;
	workoutId: Scalars['ID']['output'];
};

export type WorkoutCompletionConnection = {
	__typename?: 'WorkoutCompletionConnection';
	cursor?: Maybe<Scalars['String']['output']>;
	groups: Array<GroupedWorkoutCompletion>;
	hasMore: Scalars['Boolean']['output'];
};

export type WorkoutFilterInput = {
	categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
	intensities?: InputMaybe<Array<WorkoutIntensityEnum>>;
	notTriedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WorkoutIntensityEnum {
	Casual = 'CASUAL',
	Intensive = 'INTENSIVE',
	Moderate = 'MODERATE',
}

export type WorkoutSortOrderInput = {
	id: Scalars['ID']['input'];
	sortOrder: Scalars['Int']['input'];
};

export type WorkoutTranslation = {
	__typename?: 'WorkoutTranslation';
	about: Scalars['String']['output'];
	instructions: Scalars['String']['output'];
	language: Scalars['String']['output'];
	name: Scalars['String']['output'];
	reflectionMessage: Scalars['String']['output'];
	thankYouMessage: Scalars['String']['output'];
	why: Scalars['String']['output'];
};

export type WorkoutTranslationInput = {
	about: Scalars['String']['input'];
	instructions: Scalars['String']['input'];
	language: Scalars['String']['input'];
	name: Scalars['String']['input'];
	reflectionMessage: Scalars['String']['input'];
	thankYouMessage: Scalars['String']['input'];
	why: Scalars['String']['input'];
};

export enum Join__Graph {
	Admin = 'ADMIN',
	Authentication = 'AUTHENTICATION',
	Authorization = 'AUTHORIZATION',
	Localization = 'LOCALIZATION',
	Logging = 'LOGGING',
	Organization = 'ORGANIZATION',
	User = 'USER',
	Workout = 'WORKOUT',
}

export enum Link__Purpose {
	/** `EXECUTION` features provide metadata necessary for operation execution. */
	Execution = 'EXECUTION',
	/** `SECURITY` features provide metadata necessary to securely resolve fields. */
	Security = 'SECURITY',
}

export type AuthorizationPermissionFragmentFragment = {
	__typename?: 'AuthorizationPermission';
	id: string;
	resource?: string | null;
	action?: AuthorizationPermissionAction | null;
	description?: string | null;
	createdAt?: string | null;
	updatedAt?: string | null;
};

export type AuthorizationRoleFragmentFragment = {
	__typename?: 'AuthorizationRole';
	id: string;
	name: string;
	description?: string | null;
	scope: string;
	createdAt?: string | null;
	updatedAt?: string | null;
	authorizationRolePermissions?: Array<{
		__typename?: 'AuthorizationRolePermission';
		id: string;
		authorizationPermission?: {
			__typename?: 'AuthorizationPermission';
			id: string;
			resource?: string | null;
			action?: AuthorizationPermissionAction | null;
			description?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
		} | null;
	}> | null;
};

export type AuthorizationUserRoleFragmentFragment = {
	__typename?: 'AuthorizationUserRole';
	id: string;
	userId: string;
	authorizationRoleId: string;
	createdAt?: string | null;
	updatedAt?: string | null;
	authorizationRole?: {
		__typename?: 'AuthorizationRole';
		id: string;
		name: string;
		description?: string | null;
		scope: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		authorizationRolePermissions?: Array<{
			__typename?: 'AuthorizationRolePermission';
			id: string;
			authorizationPermission?: {
				__typename?: 'AuthorizationPermission';
				id: string;
				resource?: string | null;
				action?: AuthorizationPermissionAction | null;
				description?: string | null;
				createdAt?: string | null;
				updatedAt?: string | null;
			} | null;
		}> | null;
	} | null;
};

type BaseFragment_AdminNewsletterSubscriber_Fragment = {
	__typename?: 'AdminNewsletterSubscriber';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_AdminUser_Fragment = {
	__typename?: 'AdminUser';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_AuthenticationToken_Fragment = {
	__typename?: 'AuthenticationToken';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_AuthenticationUser_Fragment = {
	__typename?: 'AuthenticationUser';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_AuthorizationPermission_Fragment = {
	__typename?: 'AuthorizationPermission';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_AuthorizationRole_Fragment = {
	__typename?: 'AuthorizationRole';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_AuthorizationRolePermission_Fragment = {
	__typename?: 'AuthorizationRolePermission';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_AuthorizationUserRole_Fragment = {
	__typename?: 'AuthorizationUserRole';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_Exercise_Fragment = {
	__typename?: 'Exercise';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_LocalizationOrganizationSetting_Fragment = {
	__typename?: 'LocalizationOrganizationSetting';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_LoggingAuditLog_Fragment = {
	__typename?: 'LoggingAuditLog';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_LoggingLoginLog_Fragment = {
	__typename?: 'LoggingLoginLog';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_Organization_Fragment = {
	__typename?: 'Organization';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_OrganizationAddress_Fragment = {
	__typename?: 'OrganizationAddress';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_OrganizationDepartment_Fragment = {
	__typename?: 'OrganizationDepartment';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_OrganizationDepartmentUser_Fragment = {
	__typename?: 'OrganizationDepartmentUser';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_OrganizationSetting_Fragment = {
	__typename?: 'OrganizationSetting';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_OrganizationTeam_Fragment = {
	__typename?: 'OrganizationTeam';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_OrganizationTeamUser_Fragment = {
	__typename?: 'OrganizationTeamUser';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_OrganizationUser_Fragment = {
	__typename?: 'OrganizationUser';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_TrainingPlan_Fragment = {
	__typename?: 'TrainingPlan';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_TrainingPlanCategory_Fragment = {
	__typename?: 'TrainingPlanCategory';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_TrainingPlanWeek_Fragment = {
	__typename?: 'TrainingPlanWeek';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_TrainingPlanWorkout_Fragment = {
	__typename?: 'TrainingPlanWorkout';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_TrainingPlanWorkoutCompletion_Fragment = {
	__typename?: 'TrainingPlanWorkoutCompletion';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_User_Fragment = {
	__typename?: 'User';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_WellBeingSurveyQuestion_Fragment = {
	__typename?: 'WellBeingSurveyQuestion';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_WellBeingSurveyQuestionWithTranslations_Fragment = {
	__typename?: 'WellBeingSurveyQuestionWithTranslations';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_WellBeingSurveyResponse_Fragment = {
	__typename?: 'WellBeingSurveyResponse';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_Workout_Fragment = {
	__typename?: 'Workout';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_WorkoutCategory_Fragment = {
	__typename?: 'WorkoutCategory';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

type BaseFragment_WorkoutCompletion_Fragment = {
	__typename?: 'WorkoutCompletion';
	id: string;
	createdAt?: string | null;
	updatedAt?: string | null;
};

export type BaseFragmentFragment =
	| BaseFragment_AdminNewsletterSubscriber_Fragment
	| BaseFragment_AdminUser_Fragment
	| BaseFragment_AuthenticationToken_Fragment
	| BaseFragment_AuthenticationUser_Fragment
	| BaseFragment_AuthorizationPermission_Fragment
	| BaseFragment_AuthorizationRole_Fragment
	| BaseFragment_AuthorizationRolePermission_Fragment
	| BaseFragment_AuthorizationUserRole_Fragment
	| BaseFragment_Exercise_Fragment
	| BaseFragment_LocalizationOrganizationSetting_Fragment
	| BaseFragment_LoggingAuditLog_Fragment
	| BaseFragment_LoggingLoginLog_Fragment
	| BaseFragment_Organization_Fragment
	| BaseFragment_OrganizationAddress_Fragment
	| BaseFragment_OrganizationDepartment_Fragment
	| BaseFragment_OrganizationDepartmentUser_Fragment
	| BaseFragment_OrganizationSetting_Fragment
	| BaseFragment_OrganizationTeam_Fragment
	| BaseFragment_OrganizationTeamUser_Fragment
	| BaseFragment_OrganizationUser_Fragment
	| BaseFragment_TrainingPlan_Fragment
	| BaseFragment_TrainingPlanCategory_Fragment
	| BaseFragment_TrainingPlanWeek_Fragment
	| BaseFragment_TrainingPlanWorkout_Fragment
	| BaseFragment_TrainingPlanWorkoutCompletion_Fragment
	| BaseFragment_User_Fragment
	| BaseFragment_WellBeingSurveyQuestion_Fragment
	| BaseFragment_WellBeingSurveyQuestionWithTranslations_Fragment
	| BaseFragment_WellBeingSurveyResponse_Fragment
	| BaseFragment_Workout_Fragment
	| BaseFragment_WorkoutCategory_Fragment
	| BaseFragment_WorkoutCompletion_Fragment;

export type PageInfoFragmentFragment = {
	__typename?: 'PageInfo';
	totalPages: number;
	currentPage: number;
	totalCount: number;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
};

export type ResponseErrorFragmentFragment = {
	__typename?: 'ResponseError';
	message: string;
	code?: string | null;
	field?: string | null;
	details?: string | null;
};

export type MessageResponseFragmentFragment = {
	__typename?: 'MessageResponse';
	success: boolean;
	message: string;
	referenceKey?: string | null;
	errors?: Array<{
		__typename?: 'ResponseError';
		message: string;
		code?: string | null;
		field?: string | null;
		details?: string | null;
	}> | null;
};

export type CreateAdminUserMutationVariables = Exact<{
	input: CreateAdminUserInput;
}>;

export type CreateAdminUserMutation = {
	__typename?: 'Mutation';
	createAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateAdminUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateAdminUserInput;
}>;

export type UpdateAdminUserMutation = {
	__typename?: 'Mutation';
	updateAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteAdminUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteAdminUserMutation = {
	__typename?: 'Mutation';
	deleteAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteManyAdminUserMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyAdminUserMutation = {
	__typename?: 'Mutation';
	deleteManyAdminUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type ApprovePremiumAccessMutationVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type ApprovePremiumAccessMutation = {
	__typename?: 'Mutation';
	approvePremiumAccess: {
		__typename?: 'AuthenticationUser';
		id: string;
		isPremium: boolean;
		premiumRequestedAt?: string | null;
		premiumApprovedAt?: string | null;
	};
};

export type RejectPremiumAccessMutationVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type RejectPremiumAccessMutation = {
	__typename?: 'Mutation';
	rejectPremiumAccess: {
		__typename?: 'AuthenticationUser';
		id: string;
		isPremium: boolean;
		premiumRequestedAt?: string | null;
		premiumApprovedAt?: string | null;
	};
};

export type ApproveManyPremiumAccessMutationVariables = Exact<{
	userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ApproveManyPremiumAccessMutation = {
	__typename?: 'Mutation';
	approveManyPremiumAccess: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type RejectManyPremiumAccessMutationVariables = Exact<{
	userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RejectManyPremiumAccessMutation = {
	__typename?: 'Mutation';
	rejectManyPremiumAccess: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UploadAdminNewsletterSubscribersMutationVariables = Exact<{
	input: Array<UploadAdminNewsletterSubscriberInput> | UploadAdminNewsletterSubscriberInput;
}>;

export type UploadAdminNewsletterSubscribersMutation = {
	__typename?: 'Mutation';
	uploadAdminNewsletterSubscribers: {
		__typename?: 'UploadAdminNewsletterSubscribersResponse';
		success: boolean;
		message?: string | null;
		created: number;
		updated: number;
		skipped: number;
	};
};

export type SendAdminNewsletterEmailMutationVariables = Exact<{
	input: SendAdminNewsletterEmailInput;
}>;

export type SendAdminNewsletterEmailMutation = {
	__typename?: 'Mutation';
	sendAdminNewsletterEmail: {
		__typename?: 'SendAdminNewsletterEmailResponse';
		success: boolean;
		message?: string | null;
		sent: number;
		failed: number;
	};
};

export type UnsubscribeAdminNewsletterSubscriberMutationVariables = Exact<{
	email: Scalars['String']['input'];
}>;

export type UnsubscribeAdminNewsletterSubscriberMutation = {
	__typename?: 'Mutation';
	unsubscribeAdminNewsletterSubscriber: {
		__typename?: 'UnsubscribeAdminNewsletterSubscriberResponse';
		success: boolean;
		message?: string | null;
	};
};

export type ResubscribeAdminNewsletterSubscriberMutationVariables = Exact<{
	email: Scalars['String']['input'];
}>;

export type ResubscribeAdminNewsletterSubscriberMutation = {
	__typename?: 'Mutation';
	resubscribeAdminNewsletterSubscriber: {
		__typename?: 'UnsubscribeAdminNewsletterSubscriberResponse';
		success: boolean;
		message?: string | null;
	};
};

export type DeleteManyAdminNewsletterSubscriberMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyAdminNewsletterSubscriberMutation = {
	__typename?: 'Mutation';
	deleteManyAdminNewsletterSubscriber: {
		__typename?: 'DeleteManyAdminNewsletterSubscriberResponse';
		success: boolean;
		message?: string | null;
		deleted: number;
	};
};

export type LoginMutationVariables = Exact<{
	input: LoginInput;
}>;

export type LoginMutation = {
	__typename?: 'Mutation';
	login: {
		__typename?: 'LoginResponse';
		token: string;
		userId: string;
		mfaRequired: boolean;
		mfaMethod?: MfaMethodEnum | null;
		role: AuthRoleEnum;
		supportsBackupCodes: boolean;
	};
};

export type LoginValidateMutationVariables = Exact<{
	input: LoginValidateInput;
}>;

export type LoginValidateMutation = {
	__typename?: 'Mutation';
	loginValidate: {
		__typename?: 'LoginValidateResponse';
		token: string;
		refreshToken: string;
		user: {
			__typename?: 'AuthenticationUser';
			id: string;
			role: AuthRoleEnum;
			language: string;
			email?: string | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				organizationId: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					onboarded: boolean;
					organizationSetting?: {
						__typename?: 'OrganizationSetting';
						timezone: string;
						currency?: CurrencyEnum | null;
						measurementSystem: MeasurementSystemEnum;
					} | null;
				} | null;
			} | null;
			user?: {
				__typename?: 'User';
				id: string;
				userId: string;
				firstName: string;
				lastName: string;
			} | null;
		};
	};
};

export type RefreshTokenMutationVariables = Exact<{
	token: Scalars['String']['input'];
}>;

export type RefreshTokenMutation = {
	__typename?: 'Mutation';
	refreshToken: {
		__typename?: 'LoginValidateResponse';
		token: string;
		refreshToken: string;
		user: {
			__typename?: 'AuthenticationUser';
			id: string;
			role: AuthRoleEnum;
			language: string;
			email?: string | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				organizationId: string;
				firstName: string;
				lastName: string;
				organization?: {
					__typename?: 'Organization';
					id: string;
					name: string;
					onboarded: boolean;
					organizationSetting?: {
						__typename?: 'OrganizationSetting';
						timezone: string;
						currency?: CurrencyEnum | null;
						measurementSystem: MeasurementSystemEnum;
					} | null;
				} | null;
			} | null;
			user?: {
				__typename?: 'User';
				id: string;
				userId: string;
				firstName: string;
				lastName: string;
			} | null;
		};
	};
};

export type ValidateAuthenticationTokenMutationVariables = Exact<{
	token: Scalars['String']['input'];
}>;

export type ValidateAuthenticationTokenMutation = {
	__typename?: 'Mutation';
	validateAuthenticationToken: {
		__typename?: 'AuthenticationToken';
		token: string;
		user?: {
			__typename?: 'AuthenticationUser';
			id: string;
			email?: string | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				firstName: string;
				lastName: string;
			} | null;
		} | null;
	};
};

export type RegisterMutationVariables = Exact<{
	input: RegisterInput;
}>;

export type RegisterMutation = {
	__typename?: 'Mutation';
	register: {
		__typename?: 'RegisterResponse';
		userId?: string | null;
		qrCodeDataURL?: string | null;
	};
};

export type UnlockAuthenticationUserMutationVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type UnlockAuthenticationUserMutation = {
	__typename?: 'Mutation';
	unlockAuthenticationUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type BypassMigrated2FaMutationVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type BypassMigrated2FaMutation = {
	__typename?: 'Mutation';
	bypassMigrated2FA: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type BypassManyMigrated2FaMutationVariables = Exact<{
	userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type BypassManyMigrated2FaMutation = {
	__typename?: 'Mutation';
	bypassManyMigrated2FA: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type PasswordResetRequestMutationVariables = Exact<{
	input: PasswordResetRequestInput;
}>;

export type PasswordResetRequestMutation = {
	__typename?: 'Mutation';
	passwordResetRequest: string;
};

export type PasswordResetValidateMutationVariables = Exact<{
	input: PasswordResetValidateInput;
}>;

export type PasswordResetValidateMutation = {
	__typename?: 'Mutation';
	passwordResetValidate: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type PasswordResetMutationVariables = Exact<{
	input: PasswordResetInput;
}>;

export type PasswordResetMutation = {
	__typename?: 'Mutation';
	passwordReset: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type ResendPasswordResetRequestMutationVariables = Exact<{
	input: PasswordResetRequestInput;
}>;

export type ResendPasswordResetRequestMutation = {
	__typename?: 'Mutation';
	resendPasswordResetRequest: string;
};

export type VerifyAuthenticatorSetupMutationVariables = Exact<{
	input: VerifyAuthenticatorSetupInput;
}>;

export type VerifyAuthenticatorSetupMutation = {
	__typename?: 'Mutation';
	verifyAuthenticatorSetup: {
		__typename?: 'LoginResponse';
		token: string;
		userId: string;
		role: AuthRoleEnum;
		backupCodes?: Array<string> | null;
	};
};

export type VerifyEmailMfaMutationVariables = Exact<{
	input: VerifyEmailMfaInput;
}>;

export type VerifyEmailMfaMutation = {
	__typename?: 'Mutation';
	verifyEmailMfa: { __typename?: 'LoginResponse'; token: string; role: AuthRoleEnum };
};

export type ResendEmailMfaCodeMutationVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type ResendEmailMfaCodeMutation = {
	__typename?: 'Mutation';
	resendEmailMfaCode: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type VerifyAuthenticatorMfaMutationVariables = Exact<{
	input: VerifyAuthenticatorMfaInput;
}>;

export type VerifyAuthenticatorMfaMutation = {
	__typename?: 'Mutation';
	verifyAuthenticatorMfa: { __typename?: 'LoginResponse'; token: string; role: AuthRoleEnum };
};

export type LogoutMutationVariables = Exact<{
	input: LogoutInput;
}>;

export type LogoutMutation = {
	__typename?: 'Mutation';
	logout: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type CreateOrganizationSignupMutationVariables = Exact<{
	input: OrganizationSignupInput;
}>;

export type CreateOrganizationSignupMutation = {
	__typename?: 'Mutation';
	createOrganizationSignup: {
		__typename?: 'RegisterResponse';
		userId?: string | null;
		qrCodeDataURL?: string | null;
	};
};

export type CreateUserSignupMutationVariables = Exact<{
	input: UserSignupInput;
}>;

export type CreateUserSignupMutation = {
	__typename?: 'Mutation';
	createUserSignup: {
		__typename?: 'RegisterResponse';
		userId?: string | null;
		qrCodeDataURL?: string | null;
	};
};

export type CreateAuthorizationRoleMutationVariables = Exact<{
	input: AuthorizationRoleCreateInput;
}>;

export type CreateAuthorizationRoleMutation = {
	__typename?: 'Mutation';
	createAuthorizationRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateAuthorizationRoleMutationVariables = Exact<{
	input: AuthorizationRoleUpdateInput;
}>;

export type UpdateAuthorizationRoleMutation = {
	__typename?: 'Mutation';
	updateAuthorizationRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteAuthorizationRoleMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteAuthorizationRoleMutation = {
	__typename?: 'Mutation';
	deleteAuthorizationRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteManyAuthorizationRoleMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyAuthorizationRoleMutation = {
	__typename?: 'Mutation';
	deleteManyAuthorizationRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateManyAuthorizationUserRoleMutationVariables = Exact<{
	input: CreateManyAuthorizationUserRoleInput;
}>;

export type CreateManyAuthorizationUserRoleMutation = {
	__typename?: 'Mutation';
	createManyAuthorizationUserRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteManyAuthorizationUserRoleMutationVariables = Exact<{
	input: DeleteManyAuthorizationUserRoleInput;
}>;

export type DeleteManyAuthorizationUserRoleMutation = {
	__typename?: 'Mutation';
	deleteManyAuthorizationUserRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type AssignPermissionsToRoleMutationVariables = Exact<{
	input: AssignPermissionsToRoleInput;
}>;

export type AssignPermissionsToRoleMutation = {
	__typename?: 'Mutation';
	assignPermissionsToRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type RemovePermissionsFromRoleMutationVariables = Exact<{
	input: RemovePermissionsFromRoleInput;
}>;

export type RemovePermissionsFromRoleMutation = {
	__typename?: 'Mutation';
	removePermissionsFromRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type GenerateMediaUploadUrlMutationVariables = Exact<{
	input: GenerateMediaUploadInput;
}>;

export type GenerateMediaUploadUrlMutation = {
	__typename?: 'Mutation';
	generateMediaUploadUrl: {
		__typename?: 'MediaUploadUrlResponse';
		uploadUrl: string;
		blobUrl: string;
		fileId: string;
		expiresAt: string;
	};
};

export type DeleteMediaFileMutationVariables = Exact<{
	blobUrl: Scalars['String']['input'];
}>;

export type DeleteMediaFileMutation = { __typename?: 'Mutation'; deleteMediaFile: boolean };

export type CreateOrganizationUserMutationVariables = Exact<{
	input: OrganizationUserCreateInput;
}>;

export type CreateOrganizationUserMutation = {
	__typename?: 'Mutation';
	createOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteOrganizationUserMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteOrganizationUserMutation = {
	__typename?: 'Mutation';
	deleteOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteManyOrganizationUserMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyOrganizationUserMutation = {
	__typename?: 'Mutation';
	deleteManyOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationSettingMutationVariables = Exact<{
	input: OrganizationSettingUpdateInput;
}>;

export type UpdateOrganizationSettingMutation = {
	__typename?: 'Mutation';
	updateOrganizationSetting: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationMutationVariables = Exact<{
	input: OrganizationUpdateInput;
}>;

export type UpdateOrganizationMutation = {
	__typename?: 'Mutation';
	updateOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteMyOrganizationMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteMyOrganizationMutation = {
	__typename?: 'Mutation';
	deleteMyOrganization: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type DeleteOrganizationMutationVariables = Exact<{
	input: DeleteInput;
}>;

export type DeleteOrganizationMutation = {
	__typename?: 'Mutation';
	deleteOrganization?: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	} | null;
};

export type DeleteManyOrganizationMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyOrganizationMutation = {
	__typename?: 'Mutation';
	deleteManyOrganization?: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	} | null;
};

export type UpdateOrganizationApprovalAndMarginMutationVariables = Exact<{
	input: UpdateOrganizationApprovalAndMarginInput;
}>;

export type UpdateOrganizationApprovalAndMarginMutation = {
	__typename?: 'Mutation';
	updateOrganizationApprovalAndMargin: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		referenceKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	};
};

export type CreateOrganizationAddressMutationVariables = Exact<{
	organizationId: Scalars['ID']['input'];
	input: OrganizationAddressInput;
}>;

export type CreateOrganizationAddressMutation = {
	__typename?: 'Mutation';
	createOrganizationAddress: {
		__typename?: 'OrganizationAddress';
		id: string;
		addressLine1: string;
		addressLine2?: string | null;
		addressType: AddressType;
		city: string;
		countryCode: string;
		postalCode: string;
		stateCode?: string | null;
		isPrimary: boolean;
		name?: string | null;
		googlePlaceId?: string | null;
		latitude?: number | null;
		longitude?: number | null;
	};
};

export type UpdateOrganizationAddressMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: OrganizationAddressInput;
}>;

export type UpdateOrganizationAddressMutation = {
	__typename?: 'Mutation';
	updateOrganizationAddress: {
		__typename?: 'OrganizationAddress';
		id: string;
		addressLine1: string;
		addressLine2?: string | null;
		addressType: AddressType;
		city: string;
		countryCode: string;
		postalCode: string;
		stateCode?: string | null;
		isPrimary: boolean;
		name?: string | null;
		googlePlaceId?: string | null;
		latitude?: number | null;
		longitude?: number | null;
	};
};

export type DeleteOrganizationAddressMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrganizationAddressMutation = {
	__typename?: 'Mutation';
	deleteOrganizationAddress: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
	};
};

export type CreateOrganizationOnboardingMutationVariables = Exact<{
	input: OrganizationOnboardingInput;
}>;

export type CreateOrganizationOnboardingMutation = {
	__typename?: 'Mutation';
	createOrganizationOnboarding: {
		__typename?: 'OrganizationOnboardingResponse';
		success: boolean;
		message: string;
		organizationId: string;
	};
};

export type GenerateOrganizationUserAvatarUploadUrlMutationVariables = Exact<{
	input: GenerateUploadUrlInput;
}>;

export type GenerateOrganizationUserAvatarUploadUrlMutation = {
	__typename?: 'Mutation';
	generateOrganizationUserAvatarUploadUrl: {
		__typename?: 'UploadUrlResponse';
		success?: boolean | null;
		message?: string | null;
		uploadUrl?: string | null;
		expiresAt?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationUserAvatarMutationVariables = Exact<{
	input: OrganizationUserUpdateInput;
}>;

export type UpdateOrganizationUserAvatarMutation = {
	__typename?: 'Mutation';
	updateOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type CreateOrganizationDepartmentMutationVariables = Exact<{
	input: OrganizationDepartmentCreateInput;
}>;

export type CreateOrganizationDepartmentMutation = {
	__typename?: 'Mutation';
	createOrganizationDepartment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationDepartmentMutationVariables = Exact<{
	input: OrganizationDepartmentUpdateInput;
}>;

export type UpdateOrganizationDepartmentMutation = {
	__typename?: 'Mutation';
	updateOrganizationDepartment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type DeleteOrganizationDepartmentMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrganizationDepartmentMutation = {
	__typename?: 'Mutation';
	deleteOrganizationDepartment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type DeleteManyOrganizationDepartmentsMutationVariables = Exact<{
	ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteManyOrganizationDepartmentsMutation = {
	__typename?: 'Mutation';
	deleteManyOrganizationDepartment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type AddUserToDepartmentMutationVariables = Exact<{
	input: AddUserToDepartmentInput;
}>;

export type AddUserToDepartmentMutation = {
	__typename?: 'Mutation';
	addUserToDepartment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type RemoveUserFromDepartmentMutationVariables = Exact<{
	departmentId: Scalars['ID']['input'];
	organizationUserId: Scalars['ID']['input'];
}>;

export type RemoveUserFromDepartmentMutation = {
	__typename?: 'Mutation';
	removeUserFromDepartment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type BulkAddUsersToDepartmentMutationVariables = Exact<{
	input: BulkAddUsersToDepartmentInput;
}>;

export type BulkAddUsersToDepartmentMutation = {
	__typename?: 'Mutation';
	bulkAddUsersToDepartment: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type UpdateDepartmentUserRoleMutationVariables = Exact<{
	input: UpdateDepartmentUserRoleInput;
}>;

export type UpdateDepartmentUserRoleMutation = {
	__typename?: 'Mutation';
	updateDepartmentUserRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type CreateOrganizationTeamMutationVariables = Exact<{
	input: OrganizationTeamCreateInput;
}>;

export type CreateOrganizationTeamMutation = {
	__typename?: 'Mutation';
	createOrganizationTeam: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type UpdateOrganizationTeamMutationVariables = Exact<{
	input: OrganizationTeamUpdateInput;
}>;

export type UpdateOrganizationTeamMutation = {
	__typename?: 'Mutation';
	updateOrganizationTeam: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type DeleteOrganizationTeamMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteOrganizationTeamMutation = {
	__typename?: 'Mutation';
	deleteOrganizationTeam: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type DeleteManyOrganizationTeamsMutationVariables = Exact<{
	ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteManyOrganizationTeamsMutation = {
	__typename?: 'Mutation';
	deleteManyOrganizationTeam: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type AddUserToTeamMutationVariables = Exact<{
	input: AddUserToTeamInput;
}>;

export type AddUserToTeamMutation = {
	__typename?: 'Mutation';
	addUserToTeam: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type RemoveUserFromTeamMutationVariables = Exact<{
	organizationUserId: Scalars['ID']['input'];
	teamId: Scalars['ID']['input'];
}>;

export type RemoveUserFromTeamMutation = {
	__typename?: 'Mutation';
	removeUserFromTeam: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type BulkAddUsersToTeamMutationVariables = Exact<{
	input: BulkAddUsersToTeamInput;
}>;

export type BulkAddUsersToTeamMutation = {
	__typename?: 'Mutation';
	bulkAddUsersToTeam: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type UpdateTeamUserRoleMutationVariables = Exact<{
	input: UpdateTeamUserRoleInput;
}>;

export type UpdateTeamUserRoleMutation = {
	__typename?: 'Mutation';
	updateTeamUserRole: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type UpdateSystemSettingsMutationVariables = Exact<{
	input: UpdateSystemSettingInput;
}>;

export type UpdateSystemSettingsMutation = {
	__typename?: 'Mutation';
	updateSystemSettings: { __typename?: 'MessageResponse'; message: string; success: boolean };
};

export type UpdateTranslationMutationVariables = Exact<{
	input: UpdateTranslationInput;
}>;

export type UpdateTranslationMutation = {
	__typename?: 'Mutation';
	updateTranslation: Array<{
		__typename?: 'Translation';
		key: string;
		language: string;
		content: string;
		params?: Array<string> | null;
	}>;
};

export type DeleteUserMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteUserMutation = {
	__typename?: 'Mutation';
	deleteUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type DeleteManyUserMutationVariables = Exact<{
	input: DeleteManyInput;
}>;

export type DeleteManyUserMutation = {
	__typename?: 'Mutation';
	deleteManyUser: { __typename?: 'MessageResponse'; success: boolean; message: string };
};

export type UpdateWellBeingSurveyQuestionTranslationsMutationVariables = Exact<{
	input: UpdateWellBeingSurveyTranslationsInput;
}>;

export type UpdateWellBeingSurveyQuestionTranslationsMutation = {
	__typename?: 'Mutation';
	updateWellBeingSurveyQuestionTranslations: boolean;
};

export type UpdateWorkoutCategoryMutationVariables = Exact<{
	input: UpdateWorkoutCategoryInput;
}>;

export type UpdateWorkoutCategoryMutation = {
	__typename?: 'Mutation';
	updateWorkoutCategory: {
		__typename?: 'WorkoutCategory';
		id: string;
		name: string;
		color: string;
		sortOrder: number;
		isActive: boolean;
		translations: Array<{
			__typename?: 'WorkoutCategoryTranslation';
			language: string;
			name: string;
		}>;
	};
};

export type CreateWorkoutMutationVariables = Exact<{
	input: CreateWorkoutInput;
}>;

export type CreateWorkoutMutation = {
	__typename?: 'Mutation';
	createWorkout: {
		__typename?: 'Workout';
		id: string;
		name: string;
		categoryId: string;
		type: ExerciseTypeEnum;
		intensity: WorkoutIntensityEnum;
		frequency: number;
		frequencyPeriod: FrequencyPeriodEnum;
		durationMin?: number | null;
		durationMax?: number | null;
		isPremium: boolean;
		why: string;
		about: string;
		instructions: string;
		thankYouMessage: string;
		reflectionMessage: string;
		isActive: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		category: { __typename?: 'WorkoutCategory'; id: string; name: string };
		exercises: Array<{
			__typename?: 'Exercise';
			id: string;
			name: string;
			sortOrder: number;
			groupId?: number | null;
			durationMin?: number | null;
			durationMax?: number | null;
			tips: Array<string>;
			typeData:
				| { __typename?: 'AudioData'; url?: string | null; duration: number }
				| {
						__typename?: 'BreathingData';
						inhale: number;
						inhaleHold: number;
						exhale: number;
						exhaleHold: number;
						instructions?: any | null;
				  }
				| { __typename?: 'ImageUploadData' }
				| {
						__typename?: 'ReflectionInputData';
						inputs: Array<{
							__typename?: 'ReflectionInput';
							title: string;
							placeholder: string;
						}>;
				  }
				| { __typename?: 'VideoData'; url?: string | null; duration: number };
		}>;
	};
};

export type UpdateWorkoutMutationVariables = Exact<{
	id: Scalars['ID']['input'];
	input: UpdateWorkoutInput;
}>;

export type UpdateWorkoutMutation = {
	__typename?: 'Mutation';
	updateWorkout: {
		__typename?: 'Workout';
		id: string;
		name: string;
		categoryId: string;
		type: ExerciseTypeEnum;
		intensity: WorkoutIntensityEnum;
		frequency: number;
		frequencyPeriod: FrequencyPeriodEnum;
		durationMin?: number | null;
		durationMax?: number | null;
		isPremium: boolean;
		why: string;
		about: string;
		instructions: string;
		thankYouMessage: string;
		reflectionMessage: string;
		isActive: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		category: { __typename?: 'WorkoutCategory'; id: string; name: string };
		exercises: Array<{
			__typename?: 'Exercise';
			id: string;
			name: string;
			sortOrder: number;
			groupId?: number | null;
			durationMin?: number | null;
			durationMax?: number | null;
			tips: Array<string>;
			typeData:
				| { __typename?: 'AudioData'; url?: string | null; duration: number }
				| {
						__typename?: 'BreathingData';
						inhale: number;
						inhaleHold: number;
						exhale: number;
						exhaleHold: number;
						instructions?: any | null;
				  }
				| { __typename?: 'ImageUploadData' }
				| {
						__typename?: 'ReflectionInputData';
						inputs: Array<{
							__typename?: 'ReflectionInput';
							title: string;
							placeholder: string;
						}>;
				  }
				| { __typename?: 'VideoData'; url?: string | null; duration: number };
		}>;
	};
};

export type DeleteWorkoutMutationVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type DeleteWorkoutMutation = { __typename?: 'Mutation'; deleteWorkout: boolean };

export type BulkUpdateWorkoutSortOrderMutationVariables = Exact<{
	input: Array<WorkoutSortOrderInput> | WorkoutSortOrderInput;
}>;

export type BulkUpdateWorkoutSortOrderMutation = {
	__typename?: 'Mutation';
	bulkUpdateWorkoutSortOrder: boolean;
};

export type GetAllAdminUserQueryVariables = Exact<{
	input: GetAllAdminUserInput;
}>;

export type GetAllAdminUserQuery = {
	__typename?: 'Query';
	getAllAdminUser: {
		__typename?: 'AdminUserPage';
		data: Array<{
			__typename?: 'AdminUser';
			id: string;
			userId: string;
			firstName: string;
			lastName: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				role: AuthRoleEnum;
				lockedAt?: string | null;
				lockReason?: string | null;
				mfaEnabled: boolean;
				language: string;
				lastActive?: string | null;
				isPremium: boolean;
				premiumRequestedAt?: string | null;
				premiumApprovedAt?: string | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetAllAdminNewsletterSubscriberQueryVariables = Exact<{
	input: GetAllAdminNewsletterSubscriberInput;
}>;

export type GetAllAdminNewsletterSubscriberQuery = {
	__typename?: 'Query';
	getAllAdminNewsletterSubscriber: {
		__typename?: 'AdminNewsletterSubscriberPage';
		data: Array<{
			__typename?: 'AdminNewsletterSubscriber';
			id: string;
			email?: string | null;
			firstName?: string | null;
			lastName?: string | null;
			status: AdminNewsletterSubscriberStatusEnum;
			createdAt?: string | null;
			updatedAt?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalCount: number;
			totalPages: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetAuthenticationUserQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetAuthenticationUserQuery = {
	__typename?: 'Query';
	getAuthenticationUser: {
		__typename?: 'AuthenticationUser';
		id: string;
		email?: string | null;
		mfaEnabled: boolean;
		mfaMethod?: MfaMethodEnum | null;
		role: AuthRoleEnum;
	};
};

export type GetAllAuthorizationRoleQueryVariables = Exact<{
	input: GetAllAuthorizationRoleInput;
}>;

export type GetAllAuthorizationRoleQuery = {
	__typename?: 'Query';
	getAllAuthorizationRole?: {
		__typename?: 'AuthorizationRolePage';
		data?: Array<{
			__typename?: 'AuthorizationRole';
			id: string;
			name: string;
			description?: string | null;
			scope: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authorizationRolePermissions?: Array<{
				__typename?: 'AuthorizationRolePermission';
				id: string;
				authorizationPermission?: {
					__typename?: 'AuthorizationPermission';
					id: string;
					resource?: string | null;
					action?: AuthorizationPermissionAction | null;
					description?: string | null;
					createdAt?: string | null;
					updatedAt?: string | null;
				} | null;
			}> | null;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetAuthorizationRoleQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetAuthorizationRoleQuery = {
	__typename?: 'Query';
	getAuthorizationRole?: {
		__typename?: 'AuthorizationRole';
		id: string;
		name: string;
		description?: string | null;
		scope: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		authorizationRolePermissions?: Array<{
			__typename?: 'AuthorizationRolePermission';
			id: string;
			authorizationPermission?: {
				__typename?: 'AuthorizationPermission';
				id: string;
				resource?: string | null;
				action?: AuthorizationPermissionAction | null;
				description?: string | null;
				createdAt?: string | null;
				updatedAt?: string | null;
			} | null;
		}> | null;
	} | null;
};

export type GetAuthorizationRoleByNameQueryVariables = Exact<{
	name: Scalars['String']['input'];
}>;

export type GetAuthorizationRoleByNameQuery = {
	__typename?: 'Query';
	getAuthorizationRoleByName?: {
		__typename?: 'AuthorizationRole';
		id: string;
		name: string;
		description?: string | null;
		scope: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		authorizationRolePermissions?: Array<{
			__typename?: 'AuthorizationRolePermission';
			id: string;
			authorizationPermission?: {
				__typename?: 'AuthorizationPermission';
				id: string;
				resource?: string | null;
				action?: AuthorizationPermissionAction | null;
				description?: string | null;
				createdAt?: string | null;
				updatedAt?: string | null;
			} | null;
		}> | null;
	} | null;
};

export type GetAllAuthorizationUserRoleQueryVariables = Exact<{
	input: GetAllAuthorizationUserRoleInput;
}>;

export type GetAllAuthorizationUserRoleQuery = {
	__typename?: 'Query';
	getAllAuthorizationUserRole?: {
		__typename?: 'AuthorizationUserRolePage';
		data?: Array<{
			__typename?: 'AuthorizationUserRole';
			id: string;
			userId: string;
			authorizationRoleId: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authorizationRole?: {
				__typename?: 'AuthorizationRole';
				id: string;
				name: string;
				description?: string | null;
				scope: string;
				createdAt?: string | null;
				updatedAt?: string | null;
				authorizationRolePermissions?: Array<{
					__typename?: 'AuthorizationRolePermission';
					id: string;
					authorizationPermission?: {
						__typename?: 'AuthorizationPermission';
						id: string;
						resource?: string | null;
						action?: AuthorizationPermissionAction | null;
						description?: string | null;
						createdAt?: string | null;
						updatedAt?: string | null;
					} | null;
				}> | null;
			} | null;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetMyAuthorizationUserRoleQueryVariables = Exact<{
	input: GetMyAuthorizationUserRoleInput;
}>;

export type GetMyAuthorizationUserRoleQuery = {
	__typename?: 'Query';
	getMyAuthorizationUserRole?: {
		__typename?: 'AuthorizationUserRolePage';
		data?: Array<{
			__typename?: 'AuthorizationUserRole';
			id: string;
			userId: string;
			authorizationRoleId: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authorizationRole?: {
				__typename?: 'AuthorizationRole';
				id: string;
				name: string;
				description?: string | null;
				scope: string;
				createdAt?: string | null;
				updatedAt?: string | null;
				authorizationRolePermissions?: Array<{
					__typename?: 'AuthorizationRolePermission';
					id: string;
					authorizationPermission?: {
						__typename?: 'AuthorizationPermission';
						id: string;
						resource?: string | null;
						action?: AuthorizationPermissionAction | null;
						description?: string | null;
						createdAt?: string | null;
						updatedAt?: string | null;
					} | null;
				}> | null;
			} | null;
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetAllLocalizationTimezonesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllLocalizationTimezonesQuery = {
	__typename?: 'Query';
	getAllLocalizationTimezones?: Array<{
		__typename?: 'LocalizationTimezone';
		name: string;
		offset: string;
	}> | null;
};

export type GetAllLocalizationCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllLocalizationCountriesQuery = {
	__typename?: 'Query';
	getAllLocalizationCountries: Array<{
		__typename?: 'LocalizationCountry';
		code: string;
		name: string;
		currency?: string | null;
		defaultTimezone?: string | null;
		defaultMeasurementSystem?: MeasurementSystemEnum | null;
		hasStates: boolean;
		isEU: boolean;
		phonePrefix?: string | null;
		nativeName?: string | null;
		registrations: Array<{
			__typename?: 'LocalizationBusinessRegistrationType';
			code: string;
			label: string;
			placeholder?: string | null;
			helpText?: string | null;
			isRequired: boolean;
			vatDerivationPattern?: string | null;
		}>;
		addressFormat: {
			__typename?: 'LocalizationAddressFormat';
			postalCodeLabel: string;
			stateLabel?: string | null;
			stateRequired: boolean;
		};
	}>;
};

export type GetLocalizationCountryQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
}>;

export type GetLocalizationCountryQuery = {
	__typename?: 'Query';
	getLocalizationCountry: {
		__typename?: 'LocalizationCountry';
		code: string;
		name: string;
		currency?: string | null;
		defaultTimezone?: string | null;
		defaultMeasurementSystem?: MeasurementSystemEnum | null;
		hasStates: boolean;
		isEU: boolean;
		phonePrefix?: string | null;
		nativeName?: string | null;
		registrations: Array<{
			__typename?: 'LocalizationBusinessRegistrationType';
			code: string;
			label: string;
			placeholder?: string | null;
			helpText?: string | null;
			isRequired: boolean;
			vatDerivationPattern?: string | null;
		}>;
		addressFormat: {
			__typename?: 'LocalizationAddressFormat';
			postalCodeLabel: string;
			stateLabel?: string | null;
			stateRequired: boolean;
		};
		states: Array<{ __typename?: 'LocalizationState'; code: string; name: string }>;
	};
};

export type GetLocalizationStatesQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
}>;

export type GetLocalizationStatesQuery = {
	__typename?: 'Query';
	getLocalizationStates: Array<{ __typename?: 'LocalizationState'; code: string; name: string }>;
};

export type ValidateCvrQueryVariables = Exact<{
	cvrNumber: Scalars['String']['input'];
}>;

export type ValidateCvrQuery = {
	__typename?: 'Query';
	validateCVR: {
		__typename?: 'CVRValidationResult';
		valid: boolean;
		error?: string | null;
		companyInfo?: {
			__typename?: 'CVRCompanyInfo';
			name: string;
			vat: string;
			active: boolean;
			startDate?: string | null;
			industryCode?: number | null;
			industryDescription?: string | null;
			employees?: string | null;
			phone?: string | null;
			email?: string | null;
			address: {
				__typename?: 'CVRAddress';
				street: string;
				zipcode: string;
				city: string;
				country: string;
			};
		} | null;
	};
};

export type ValidateBusinessRegistrationQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
}>;

export type ValidateBusinessRegistrationQuery = {
	__typename?: 'Query';
	validateBusinessRegistration: {
		__typename?: 'ValidationResult';
		valid: boolean;
		error?: string | null;
	};
};

export type AddressAutocompleteQueryVariables = Exact<{
	input: Scalars['String']['input'];
	countryCode?: InputMaybe<Scalars['String']['input']>;
	sessionToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddressAutocompleteQuery = {
	__typename?: 'Query';
	addressAutocomplete: Array<{
		__typename?: 'PlaceAutocompleteResult';
		placeId: string;
		description: string;
		mainText: string;
		secondaryText: string;
	}>;
};

export type GetPlaceDetailsQueryVariables = Exact<{
	placeId: Scalars['String']['input'];
	sessionToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPlaceDetailsQuery = {
	__typename?: 'Query';
	getPlaceDetails?: {
		__typename?: 'PlaceDetails';
		placeId: string;
		formattedAddress: string;
		streetNumber?: string | null;
		streetName?: string | null;
		city?: string | null;
		state?: string | null;
		stateCode?: string | null;
		postalCode?: string | null;
		country?: string | null;
		countryCode?: string | null;
		latitude?: number | null;
		longitude?: number | null;
		timezone?: string | null;
	} | null;
};

export type ValidateAddressQueryVariables = Exact<{
	placeId: Scalars['String']['input'];
}>;

export type ValidateAddressQuery = {
	__typename?: 'Query';
	validateAddress: {
		__typename?: 'AddressValidationResult';
		valid: boolean;
		errors: Array<string>;
		warnings: Array<string>;
	};
};

export type GetLocalizationDefaultsQueryVariables = Exact<{
	placeId: Scalars['String']['input'];
}>;

export type GetLocalizationDefaultsQuery = {
	__typename?: 'Query';
	getLocalizationDefaults: {
		__typename?: 'LocalizationDefaults';
		countryCode: string;
		currency: CurrencyEnum;
		measurementSystem: MeasurementSystemEnum;
		timezone: string;
	};
};

export type GenerateVatFromRegistrationQueryVariables = Exact<{
	countryCode: Scalars['String']['input'];
	registrationNumber: Scalars['String']['input'];
	registrationType: Scalars['String']['input'];
}>;

export type GenerateVatFromRegistrationQuery = {
	__typename?: 'Query';
	generateVATFromRegistration?: string | null;
};

export type GetTranslationsQueryVariables = Exact<{
	language: Scalars['String']['input'];
	keys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetTranslationsQuery = {
	__typename?: 'Query';
	getTranslations: Array<{
		__typename?: 'Translation';
		key: string;
		language: string;
		content: string;
		params?: Array<string> | null;
	}>;
};

export type GetAllTranslationsQueryVariables = Exact<{
	language: Scalars['String']['input'];
	search?: InputMaybe<Scalars['String']['input']>;
	sortBy?: InputMaybe<Scalars['String']['input']>;
	sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAllTranslationsQuery = {
	__typename?: 'Query';
	getAllTranslations: Array<{
		__typename?: 'Translation';
		key: string;
		language: string;
		content: string;
		params?: Array<string> | null;
	}>;
};

export type GetAllLoggingAuditLogQueryVariables = Exact<{
	input: GetAllLoggingAuditLogInput;
}>;

export type GetAllLoggingAuditLogQuery = {
	__typename?: 'Query';
	getAllLoggingAuditLog?: {
		__typename?: 'LoggingAuditLogPage';
		data: Array<{
			__typename?: 'LoggingAuditLog';
			id: string;
			action?: string | null;
			changes?: any | null;
			createdAt?: string | null;
			description?: string | null;
			organizationId?: string | null;
			resource?: string | null;
			resourceId?: string | null;
			serviceName?: string | null;
			status?: string | null;
			updatedAt?: string | null;
			userId?: string | null;
			metadata?: any | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
			totalCount: number;
			totalPages: number;
		};
	} | null;
};

export type GetAllLoggingLoginLogQueryVariables = Exact<{
	input: GetAllLoggingLoginLogInput;
}>;

export type GetAllLoggingLoginLogQuery = {
	__typename?: 'Query';
	getAllLoggingLoginLog?: {
		__typename?: 'LoggingLoginLogPage';
		data: Array<{
			__typename?: 'LoggingLoginLog';
			id: string;
			browser: string;
			createdAt?: string | null;
			failureReason?: string | null;
			ipAddress: string;
			method: string;
			os: string;
			referenceId: string;
			serviceId: string;
			status: string;
			updatedAt?: string | null;
			userAgent: string;
			userId: string;
			user?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				organizationUser?: {
					__typename?: 'OrganizationUser';
					id: string;
					firstName: string;
					lastName: string;
				} | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
			totalCount: number;
			totalPages: number;
		};
	} | null;
};

export type GetOrganizationSettingQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationSettingQuery = {
	__typename?: 'Query';
	getOrganizationSetting?: {
		__typename?: 'OrganizationSetting';
		id: string;
		measurementSystem: MeasurementSystemEnum;
		currency?: CurrencyEnum | null;
		timezone: string;
	} | null;
};

export type GetOrganizationApprovalAndMarginQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationApprovalAndMarginQuery = {
	__typename?: 'Query';
	getOrganizationApprovalAndMargin?: {
		__typename?: 'OrganizationApprovalAndMargin';
		organizationId: string;
		defaultApproval: boolean;
		defaultMargin: number;
	} | null;
};

export type GetAllOrganizationUserQueryVariables = Exact<{
	input: GetAllOrganizationUserInput;
}>;

export type GetAllOrganizationUserQuery = {
	__typename?: 'Query';
	getAllOrganizationUser?: {
		__typename?: 'OrganizationUserPage';
		data?: Array<{
			__typename?: 'OrganizationUser';
			id: string;
			firstName: string;
			lastName: string;
			jobPosition?: string | null;
			avatar?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				role: AuthRoleEnum;
				lockedAt?: string | null;
				lockReason?: string | null;
				lastActive?: string | null;
				isPremium: boolean;
				premiumRequestedAt?: string | null;
				premiumApprovedAt?: string | null;
			} | null;
			authorizationUserRoles?: Array<{
				__typename?: 'AuthorizationUserRole';
				id: string;
				userId: string;
				authorizationRoleId: string;
				authorizationRole?: {
					__typename?: 'AuthorizationRole';
					id: string;
					name: string;
					description?: string | null;
				} | null;
			} | null> | null;
		}> | null;
		pageInfo?: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		} | null;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			code?: string | null;
			field?: string | null;
			details?: string | null;
		}> | null;
	} | null;
};

export type GetOrganizationUserQueryVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type GetOrganizationUserQuery = {
	__typename?: 'Query';
	getOrganizationUser?: {
		__typename?: 'OrganizationUser';
		id: string;
		firstName: string;
		lastName: string;
		jobPosition?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		authenticationUser?: {
			__typename?: 'AuthenticationUser';
			id: string;
			email?: string | null;
			role: AuthRoleEnum;
		} | null;
	} | null;
};

export type GetOrganizationQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetOrganizationQuery = {
	__typename?: 'Query';
	getOrganization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		logo?: string | null;
		websiteUrl?: string | null;
		industry?: OrganizationIndustryEnum | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		addresses?: Array<{
			__typename?: 'OrganizationAddress';
			id: string;
			addressLine1: string;
			addressLine2?: string | null;
			addressType: AddressType;
			city: string;
			countryCode: string;
			postalCode: string;
			stateCode?: string | null;
			isPrimary: boolean;
			name?: string | null;
			googlePlaceId?: string | null;
			latitude?: number | null;
			longitude?: number | null;
		}> | null;
	} | null;
};

export type GetAllOrganizationQueryVariables = Exact<{
	input: GetAllOrganizationInput;
}>;

export type GetAllOrganizationQuery = {
	__typename?: 'Query';
	getAllOrganization: {
		__typename?: 'OrganizationPage';
		data: Array<{
			__typename?: 'Organization';
			id: string;
			name: string;
			logo?: string | null;
			websiteUrl?: string | null;
			industry?: OrganizationIndustryEnum | null;
			createdAt?: string | null;
			updatedAt?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetOrganizationWithSettingsQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationWithSettingsQuery = {
	__typename?: 'Query';
	getOrganization?: {
		__typename?: 'Organization';
		id: string;
		name: string;
		logo?: string | null;
		websiteUrl?: string | null;
		industry?: OrganizationIndustryEnum | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		organizationSetting?: {
			__typename?: 'OrganizationSetting';
			id: string;
			measurementSystem: MeasurementSystemEnum;
			currency?: CurrencyEnum | null;
			timezone: string;
		} | null;
		addresses?: Array<{
			__typename?: 'OrganizationAddress';
			id: string;
			addressLine1: string;
			addressLine2?: string | null;
			addressType: AddressType;
			city: string;
			countryCode: string;
			postalCode: string;
			stateCode?: string | null;
			isPrimary: boolean;
			name?: string | null;
			googlePlaceId?: string | null;
			latitude?: number | null;
			longitude?: number | null;
		}> | null;
	} | null;
};

export type GetOrganizationAddressesQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationAddressesQuery = {
	__typename?: 'Query';
	getOrganizationAddresses: Array<{
		__typename?: 'OrganizationAddress';
		id: string;
		name?: string | null;
		addressLine1: string;
		addressLine2?: string | null;
		city: string;
		stateCode?: string | null;
		postalCode: string;
		countryCode: string;
		addressType: AddressType;
		isPrimary: boolean;
	}>;
};

export type GetOrganizationUserAvatarDownloadUrlQueryVariables = Exact<{
	input: GetDownloadUrlInput;
}>;

export type GetOrganizationUserAvatarDownloadUrlQuery = {
	__typename?: 'Query';
	getOrganizationUserAvatarDownloadUrl: {
		__typename?: 'DownloadUrlResponse';
		success: boolean;
		message?: string | null;
		downloadUrl: string;
		expiresAt: string;
		errors?: Array<{
			__typename?: 'ResponseError';
			message: string;
			field?: string | null;
			code?: string | null;
		}> | null;
	};
};

export type GetOrganizationUserDetailsQueryVariables = Exact<{
	userId: Scalars['ID']['input'];
}>;

export type GetOrganizationUserDetailsQuery = {
	__typename?: 'Query';
	getOrganizationUser?: {
		__typename?: 'OrganizationUser';
		id: string;
		firstName: string;
		lastName: string;
		jobPosition?: string | null;
		avatar?: string | null;
		createdAt?: string | null;
		updatedAt?: string | null;
		organizationId: string;
		userId: string;
		roles?: Array<string> | null;
		authenticationUser?: {
			__typename?: 'AuthenticationUser';
			id: string;
			email?: string | null;
			language: string;
			role: AuthRoleEnum;
			mfaEnabled: boolean;
			mfaMethod?: MfaMethodEnum | null;
			lockReason?: string | null;
			lockedAt?: string | null;
			createdAt?: string | null;
			updatedAt?: string | null;
		} | null;
		organization?: {
			__typename?: 'Organization';
			id: string;
			name: string;
			industry?: OrganizationIndustryEnum | null;
			websiteUrl?: string | null;
			logo?: string | null;
		} | null;
		authorizationUserRoles?: Array<{
			__typename?: 'AuthorizationUserRole';
			id: string;
			authorizationRoleId: string;
			createdAt?: string | null;
			authorizationRole?: {
				__typename?: 'AuthorizationRole';
				id: string;
				name: string;
				description?: string | null;
				scope: string;
			} | null;
		} | null> | null;
	} | null;
};

export type UpdateOrganizationUserMutationVariables = Exact<{
	input: OrganizationUserUpdateInput;
}>;

export type UpdateOrganizationUserMutation = {
	__typename?: 'Mutation';
	updateOrganizationUser: {
		__typename?: 'MessageResponse';
		success: boolean;
		message: string;
		messageKey?: string | null;
	};
};

export type GetUserAuditLogsQueryVariables = Exact<{
	input: GetAllLoggingAuditLogInput;
}>;

export type GetUserAuditLogsQuery = {
	__typename?: 'Query';
	getAllLoggingAuditLog?: {
		__typename?: 'LoggingAuditLogPage';
		data: Array<{
			__typename?: 'LoggingAuditLog';
			id: string;
			action?: string | null;
			resource?: string | null;
			resourceId?: string | null;
			description?: string | null;
			status?: string | null;
			serviceName?: string | null;
			changes?: any | null;
			metadata?: any | null;
			createdAt?: string | null;
			userId?: string | null;
			organizationId?: string | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetUserLoginLogsQueryVariables = Exact<{
	input: GetAllLoggingLoginLogInput;
}>;

export type GetUserLoginLogsQuery = {
	__typename?: 'Query';
	getAllLoggingLoginLog?: {
		__typename?: 'LoggingLoginLogPage';
		data: Array<{
			__typename?: 'LoggingLoginLog';
			id: string;
			method: string;
			status: string;
			failureReason?: string | null;
			ipAddress: string;
			userAgent: string;
			browser: string;
			os: string;
			createdAt?: string | null;
			userId: string;
			referenceId: string;
			serviceId: string;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	} | null;
};

export type GetUserDepartmentsQueryVariables = Exact<{
	organizationUserId: Scalars['ID']['input'];
}>;

export type GetUserDepartmentsQuery = {
	__typename?: 'Query';
	getAllOrganizationDepartmentUser: {
		__typename?: 'OrganizationDepartmentUserPage';
		data: Array<{
			__typename?: 'OrganizationDepartmentUser';
			id: string;
			role: OrganizationRoleEnum;
			title?: string | null;
			department?: {
				__typename?: 'OrganizationDepartment';
				id: string;
				name: string;
				description?: string | null;
				level: number;
			} | null;
		}>;
	};
};

export type GetUserTeamsQueryVariables = Exact<{
	organizationUserId: Scalars['ID']['input'];
}>;

export type GetUserTeamsQuery = {
	__typename?: 'Query';
	getAllOrganizationTeamUser: {
		__typename?: 'OrganizationTeamUserPage';
		data: Array<{
			__typename?: 'OrganizationTeamUser';
			id: string;
			role: OrganizationRoleEnum;
			title?: string | null;
			team?: {
				__typename?: 'OrganizationTeam';
				id: string;
				name: string;
				description?: string | null;
				department?: {
					__typename?: 'OrganizationDepartment';
					id: string;
					name: string;
				} | null;
			} | null;
		}>;
	};
};

export type GetAllOrganizationDepartmentsQueryVariables = Exact<{
	input: GetAllOrganizationDepartmentInput;
}>;

export type GetAllOrganizationDepartmentsQuery = {
	__typename?: 'Query';
	getAllOrganizationDepartment: {
		__typename?: 'OrganizationDepartmentPage';
		data: Array<{
			__typename?: 'OrganizationDepartment';
			id: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			name: string;
			description?: string | null;
			level: number;
			organizationId: string;
			parentDepartmentId?: string | null;
			parentDepartment?: {
				__typename?: 'OrganizationDepartment';
				id: string;
				name: string;
			} | null;
			organization?: { __typename?: 'Organization'; id: string; name: string } | null;
			subDepartments?: Array<{
				__typename?: 'OrganizationDepartment';
				id: string;
				name: string;
				level: number;
			}> | null;
			teams?: Array<{
				__typename?: 'OrganizationTeam';
				id: string;
				name: string;
				description?: string | null;
			}> | null;
			users?: Array<{
				__typename?: 'OrganizationDepartmentUser';
				id: string;
				role: OrganizationRoleEnum;
				title?: string | null;
				organizationUser?: {
					__typename?: 'OrganizationUser';
					id: string;
					firstName: string;
					lastName: string;
					jobPosition?: string | null;
					authenticationUser?: {
						__typename?: 'AuthenticationUser';
						email?: string | null;
					} | null;
				} | null;
			}> | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetOrganizationDepartmentQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetOrganizationDepartmentQuery = {
	__typename?: 'Query';
	getOrganizationDepartment?: {
		__typename?: 'OrganizationDepartment';
		id: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		name: string;
		description?: string | null;
		level: number;
		organizationId: string;
		parentDepartmentId?: string | null;
		parentDepartment?: {
			__typename?: 'OrganizationDepartment';
			id: string;
			name: string;
		} | null;
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
		subDepartments?: Array<{
			__typename?: 'OrganizationDepartment';
			id: string;
			name: string;
			level: number;
		}> | null;
		teams?: Array<{
			__typename?: 'OrganizationTeam';
			id: string;
			name: string;
			description?: string | null;
		}> | null;
		users?: Array<{
			__typename?: 'OrganizationDepartmentUser';
			id: string;
			role: OrganizationRoleEnum;
			title?: string | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				firstName: string;
				lastName: string;
				jobPosition?: string | null;
				authenticationUser?: {
					__typename?: 'AuthenticationUser';
					email?: string | null;
				} | null;
			} | null;
		}> | null;
	} | null;
};

export type GetOrganizationDepartmentHierarchyQueryVariables = Exact<{
	organizationId: Scalars['ID']['input'];
}>;

export type GetOrganizationDepartmentHierarchyQuery = {
	__typename?: 'Query';
	getOrganizationDepartmentHierarchy: Array<{
		__typename?: 'OrganizationDepartment';
		id: string;
		name: string;
		description?: string | null;
		level: number;
		parentDepartmentId?: string | null;
		subDepartments?: Array<{
			__typename?: 'OrganizationDepartment';
			id: string;
			name: string;
			description?: string | null;
			level: number;
			parentDepartmentId?: string | null;
		}> | null;
	}>;
};

export type GetAllOrganizationDepartmentUsersQueryVariables = Exact<{
	input: GetAllOrganizationDepartmentUserInput;
}>;

export type GetAllOrganizationDepartmentUsersQuery = {
	__typename?: 'Query';
	getAllOrganizationDepartmentUser: {
		__typename?: 'OrganizationDepartmentUserPage';
		data: Array<{
			__typename?: 'OrganizationDepartmentUser';
			id: string;
			role: OrganizationRoleEnum;
			title?: string | null;
			departmentId: string;
			organizationUserId: string;
			department?: { __typename?: 'OrganizationDepartment'; id: string; name: string } | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				firstName: string;
				lastName: string;
				jobPosition?: string | null;
				authenticationUser?: {
					__typename?: 'AuthenticationUser';
					email?: string | null;
				} | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetDepartmentLeadersQueryVariables = Exact<{
	departmentId: Scalars['ID']['input'];
}>;

export type GetDepartmentLeadersQuery = {
	__typename?: 'Query';
	getDepartmentLeaders: Array<{
		__typename?: 'OrganizationDepartmentUser';
		id: string;
		role: OrganizationRoleEnum;
		title?: string | null;
		organizationUser?: {
			__typename?: 'OrganizationUser';
			id: string;
			firstName: string;
			lastName: string;
			jobPosition?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				email?: string | null;
			} | null;
		} | null;
	}>;
};

export type GetAllOrganizationTeamsQueryVariables = Exact<{
	input: GetAllOrganizationTeamInput;
}>;

export type GetAllOrganizationTeamsQuery = {
	__typename?: 'Query';
	getAllOrganizationTeam: {
		__typename?: 'OrganizationTeamPage';
		data: Array<{
			__typename?: 'OrganizationTeam';
			id: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			name: string;
			description?: string | null;
			organizationId: string;
			departmentId?: string | null;
			department?: {
				__typename?: 'OrganizationDepartment';
				id: string;
				name: string;
				level: number;
			} | null;
			organization?: { __typename?: 'Organization'; id: string; name: string } | null;
			users?: Array<{
				__typename?: 'OrganizationTeamUser';
				id: string;
				role: OrganizationRoleEnum;
				title?: string | null;
				organizationUser?: {
					__typename?: 'OrganizationUser';
					id: string;
					firstName: string;
					lastName: string;
					jobPosition?: string | null;
					authenticationUser?: {
						__typename?: 'AuthenticationUser';
						email?: string | null;
					} | null;
				} | null;
			}> | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetOrganizationTeamQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetOrganizationTeamQuery = {
	__typename?: 'Query';
	getOrganizationTeam?: {
		__typename?: 'OrganizationTeam';
		id: string;
		createdAt?: string | null;
		updatedAt?: string | null;
		name: string;
		description?: string | null;
		organizationId: string;
		departmentId?: string | null;
		department?: {
			__typename?: 'OrganizationDepartment';
			id: string;
			name: string;
			level: number;
		} | null;
		organization?: { __typename?: 'Organization'; id: string; name: string } | null;
		users?: Array<{
			__typename?: 'OrganizationTeamUser';
			id: string;
			role: OrganizationRoleEnum;
			title?: string | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				firstName: string;
				lastName: string;
				jobPosition?: string | null;
				authenticationUser?: {
					__typename?: 'AuthenticationUser';
					email?: string | null;
				} | null;
			} | null;
		}> | null;
	} | null;
};

export type GetAllOrganizationTeamUsersQueryVariables = Exact<{
	input: GetAllOrganizationTeamUserInput;
}>;

export type GetAllOrganizationTeamUsersQuery = {
	__typename?: 'Query';
	getAllOrganizationTeamUser: {
		__typename?: 'OrganizationTeamUserPage';
		data: Array<{
			__typename?: 'OrganizationTeamUser';
			id: string;
			role: OrganizationRoleEnum;
			title?: string | null;
			teamId: string;
			organizationUserId: string;
			team?: {
				__typename?: 'OrganizationTeam';
				id: string;
				name: string;
				department?: {
					__typename?: 'OrganizationDepartment';
					id: string;
					name: string;
				} | null;
			} | null;
			organizationUser?: {
				__typename?: 'OrganizationUser';
				id: string;
				firstName: string;
				lastName: string;
				jobPosition?: string | null;
				authenticationUser?: {
					__typename?: 'AuthenticationUser';
					email?: string | null;
				} | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			currentPage: number;
			totalPages: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetTeamLeadersQueryVariables = Exact<{
	teamId: Scalars['ID']['input'];
}>;

export type GetTeamLeadersQuery = {
	__typename?: 'Query';
	getTeamLeaders: Array<{
		__typename?: 'OrganizationTeamUser';
		id: string;
		role: OrganizationRoleEnum;
		title?: string | null;
		organizationUser?: {
			__typename?: 'OrganizationUser';
			id: string;
			firstName: string;
			lastName: string;
			jobPosition?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				email?: string | null;
			} | null;
		} | null;
	}>;
};

export type GetSupportedLanguagesQueryVariables = Exact<{ [key: string]: never }>;

export type GetSupportedLanguagesQuery = {
	__typename?: 'Query';
	getSupportedLanguages: Array<{
		__typename?: 'SupportedLanguage';
		code: string;
		name: string;
		nativeName: string;
	}>;
};

export type GetSystemSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSystemSettingsQuery = {
	__typename?: 'Query';
	getSystemSettings?: {
		__typename?: 'AdminSystemSetting';
		id: string;
		createdAt: string;
		updatedAt: string;
	} | null;
};

export type GetAllUsersQueryVariables = Exact<{
	input: GetAllUserInput;
}>;

export type GetAllUsersQuery = {
	__typename?: 'Query';
	getAllUsers: {
		__typename?: 'UserPage';
		data: Array<{
			__typename?: 'User';
			id: string;
			userId: string;
			firstName: string;
			lastName: string;
			createdAt?: string | null;
			updatedAt?: string | null;
			authenticationUser?: {
				__typename?: 'AuthenticationUser';
				id: string;
				email?: string | null;
				role: AuthRoleEnum;
				language: string;
				lastActive?: string | null;
				isPremium: boolean;
				isMigrated: boolean;
				status: StatusEnum;
				premiumRequestedAt?: string | null;
				premiumApprovedAt?: string | null;
				mfaBypassedAt?: string | null;
			} | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetAllUserAuthenticationUserQueryVariables = Exact<{
	input: GetAllUserAuthenticationUserInput;
}>;

export type GetAllUserAuthenticationUserQuery = {
	__typename?: 'Query';
	getAllUserAuthenticationUser: {
		__typename?: 'AuthenticationUserPage';
		data: Array<{
			__typename?: 'AuthenticationUser';
			id: string;
			email?: string | null;
			role: AuthRoleEnum;
			lastActive?: string | null;
			createdAt?: string | null;
			isPremium: boolean;
			premiumRequestedAt?: string | null;
			premiumApprovedAt?: string | null;
			user?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			totalPages: number;
			currentPage: number;
			totalCount: number;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
	};
};

export type GetAllWellBeingSurveyQuestionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllWellBeingSurveyQuestionsQuery = {
	__typename?: 'Query';
	getAllWellBeingSurveyQuestionsWithTranslations: Array<{
		__typename?: 'WellBeingSurveyQuestionWithTranslations';
		id: string;
		questionKey: string;
		sortOrder: number;
		translations: Array<{
			__typename?: 'WellBeingSurveyQuestionTranslation';
			language: string;
			text: string;
		}>;
	}>;
};

export type GetAllWorkoutCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllWorkoutCategoriesQuery = {
	__typename?: 'Query';
	getAllWorkoutCategories: Array<{
		__typename?: 'WorkoutCategory';
		id: string;
		name: string;
		color: string;
		headerColor?: string | null;
		cardColor?: string | null;
		headerSvg?: string | null;
		illustrationSvg?: string | null;
		isActive: boolean;
		translations: Array<{
			__typename?: 'WorkoutCategoryTranslation';
			language: string;
			name: string;
		}>;
	}>;
};

export type GetAllWorkoutsQueryVariables = Exact<{
	categoryId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetAllWorkoutsQuery = {
	__typename?: 'Query';
	getAllWorkouts: Array<{
		__typename?: 'Workout';
		id: string;
		name: string;
		categoryId: string;
		sortOrder: number;
		type: ExerciseTypeEnum;
		intensity: WorkoutIntensityEnum;
		frequency: number;
		frequencyPeriod: FrequencyPeriodEnum;
		durationMin?: number | null;
		durationMax?: number | null;
		isPremium: boolean;
		why: string;
		about: string;
		instructions: string;
		thankYouMessage: string;
		reflectionMessage: string;
		isActive: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		category: { __typename?: 'WorkoutCategory'; id: string; name: string };
		translations: Array<{
			__typename?: 'WorkoutTranslation';
			language: string;
			name: string;
			why: string;
			about: string;
			instructions: string;
			thankYouMessage: string;
			reflectionMessage: string;
		}>;
		exercises: Array<{
			__typename?: 'Exercise';
			id: string;
			name: string;
			description: string;
			sortOrder: number;
			groupId?: number | null;
			durationMin?: number | null;
			durationMax?: number | null;
			tips: Array<string>;
			translations: Array<{
				__typename?: 'ExerciseTranslation';
				language: string;
				name: string;
				description: string;
				tips: Array<string>;
			}>;
			typeData:
				| {
						__typename?: 'AudioData';
						url?: string | null;
						duration: number;
						fileId?: string | null;
						mediaUrls: Array<{
							__typename?: 'MediaUrl';
							language: string;
							url: string;
							fileId?: string | null;
						}>;
				  }
				| {
						__typename?: 'BreathingData';
						inhale: number;
						inhaleHold: number;
						exhale: number;
						exhaleHold: number;
						mediaUrl?: string | null;
						instructions?: any | null;
						mediaUrls: Array<{
							__typename?: 'MediaUrl';
							language: string;
							url: string;
							fileId?: string | null;
						}>;
				  }
				| { __typename?: 'ImageUploadData'; minImages: number; maxImages: number }
				| {
						__typename?: 'ReflectionInputData';
						inputs: Array<{
							__typename?: 'ReflectionInput';
							title: string;
							placeholder: string;
							translations: Array<{
								__typename?: 'ReflectionInputTranslation';
								language: string;
								title: string;
								placeholder: string;
							}>;
						}>;
				  }
				| {
						__typename?: 'VideoData';
						url?: string | null;
						duration: number;
						fileId?: string | null;
						mediaUrls: Array<{
							__typename?: 'MediaUrl';
							language: string;
							url: string;
							fileId?: string | null;
						}>;
				  };
		}>;
	}>;
};

export type GetWorkoutQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetWorkoutQuery = {
	__typename?: 'Query';
	getWorkout?: {
		__typename?: 'Workout';
		id: string;
		name: string;
		categoryId: string;
		type: ExerciseTypeEnum;
		intensity: WorkoutIntensityEnum;
		frequency: number;
		frequencyPeriod: FrequencyPeriodEnum;
		durationMin?: number | null;
		durationMax?: number | null;
		isPremium: boolean;
		why: string;
		about: string;
		instructions: string;
		thankYouMessage: string;
		reflectionMessage: string;
		isActive: boolean;
		createdAt?: string | null;
		updatedAt?: string | null;
		category: { __typename?: 'WorkoutCategory'; id: string; name: string };
		translations: Array<{
			__typename?: 'WorkoutTranslation';
			language: string;
			name: string;
			why: string;
			about: string;
			instructions: string;
			thankYouMessage: string;
			reflectionMessage: string;
		}>;
		exercises: Array<{
			__typename?: 'Exercise';
			id: string;
			name: string;
			description: string;
			sortOrder: number;
			groupId?: number | null;
			durationMin?: number | null;
			durationMax?: number | null;
			tips: Array<string>;
			translations: Array<{
				__typename?: 'ExerciseTranslation';
				language: string;
				name: string;
				description: string;
				tips: Array<string>;
			}>;
			typeData:
				| {
						__typename?: 'AudioData';
						url?: string | null;
						duration: number;
						fileId?: string | null;
						mediaUrls: Array<{
							__typename?: 'MediaUrl';
							language: string;
							url: string;
							fileId?: string | null;
						}>;
				  }
				| {
						__typename?: 'BreathingData';
						inhale: number;
						inhaleHold: number;
						exhale: number;
						exhaleHold: number;
						mediaUrl?: string | null;
						instructions?: any | null;
						mediaUrls: Array<{
							__typename?: 'MediaUrl';
							language: string;
							url: string;
							fileId?: string | null;
						}>;
				  }
				| { __typename?: 'ImageUploadData'; minImages: number; maxImages: number }
				| {
						__typename?: 'ReflectionInputData';
						inputs: Array<{
							__typename?: 'ReflectionInput';
							title: string;
							placeholder: string;
							translations: Array<{
								__typename?: 'ReflectionInputTranslation';
								language: string;
								title: string;
								placeholder: string;
							}>;
						}>;
				  }
				| {
						__typename?: 'VideoData';
						url?: string | null;
						duration: number;
						fileId?: string | null;
						mediaUrls: Array<{
							__typename?: 'MediaUrl';
							language: string;
							url: string;
							fileId?: string | null;
						}>;
				  };
		}>;
	} | null;
};

export const AuthorizationPermissionFragmentFragmentDoc = gql`
	fragment AuthorizationPermissionFragment on AuthorizationPermission {
		id
		resource
		action
		description
		createdAt
		updatedAt
	}
`;
export const AuthorizationRoleFragmentFragmentDoc = gql`
	fragment AuthorizationRoleFragment on AuthorizationRole {
		id
		name
		description
		scope
		createdAt
		updatedAt
		authorizationRolePermissions {
			id
			authorizationPermission {
				...AuthorizationPermissionFragment
			}
		}
	}
	${AuthorizationPermissionFragmentFragmentDoc}
`;
export const AuthorizationUserRoleFragmentFragmentDoc = gql`
	fragment AuthorizationUserRoleFragment on AuthorizationUserRole {
		id
		userId
		authorizationRoleId
		createdAt
		updatedAt
		authorizationRole {
			...AuthorizationRoleFragment
		}
	}
	${AuthorizationRoleFragmentFragmentDoc}
`;
export const BaseFragmentFragmentDoc = gql`
	fragment BaseFragment on Base {
		id
		createdAt
		updatedAt
	}
`;
export const PageInfoFragmentFragmentDoc = gql`
	fragment PageInfoFragment on PageInfo {
		totalPages
		currentPage
		totalCount
		hasNextPage
		hasPreviousPage
	}
`;
export const ResponseErrorFragmentFragmentDoc = gql`
	fragment ResponseErrorFragment on ResponseError {
		message
		code
		field
		details
	}
`;
export const MessageResponseFragmentFragmentDoc = gql`
	fragment MessageResponseFragment on MessageResponse {
		success
		message
		referenceKey
		errors {
			...ResponseErrorFragment
		}
	}
	${ResponseErrorFragmentFragmentDoc}
`;
export const CreateAdminUserDocument = gql`
	mutation CreateAdminUser($input: CreateAdminUserInput!) {
		createAdminUser(input: $input) {
			success
			message
		}
	}
`;
export type CreateAdminUserMutationFn = Apollo.MutationFunction<
	CreateAdminUserMutation,
	CreateAdminUserMutationVariables
>;

/**
 * __useCreateAdminUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserMutation, { data, loading, error }] = useCreateAdminUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateAdminUserMutation,
		CreateAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateAdminUserMutation, CreateAdminUserMutationVariables>(
		CreateAdminUserDocument,
		options
	);
}
export type CreateAdminUserMutationHookResult = ReturnType<typeof useCreateAdminUserMutation>;
export type CreateAdminUserMutationResult = Apollo.MutationResult<CreateAdminUserMutation>;
export type CreateAdminUserMutationOptions = Apollo.BaseMutationOptions<
	CreateAdminUserMutation,
	CreateAdminUserMutationVariables
>;
export const UpdateAdminUserDocument = gql`
	mutation UpdateAdminUser($id: ID!, $input: UpdateAdminUserInput!) {
		updateAdminUser(id: $id, input: $input) {
			success
			message
		}
	}
`;
export type UpdateAdminUserMutationFn = Apollo.MutationFunction<
	UpdateAdminUserMutation,
	UpdateAdminUserMutationVariables
>;

/**
 * __useUpdateAdminUserMutation__
 *
 * To run a mutation, you first call `useUpdateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminUserMutation, { data, loading, error }] = useUpdateAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateAdminUserMutation,
		UpdateAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>(
		UpdateAdminUserDocument,
		options
	);
}
export type UpdateAdminUserMutationHookResult = ReturnType<typeof useUpdateAdminUserMutation>;
export type UpdateAdminUserMutationResult = Apollo.MutationResult<UpdateAdminUserMutation>;
export type UpdateAdminUserMutationOptions = Apollo.BaseMutationOptions<
	UpdateAdminUserMutation,
	UpdateAdminUserMutationVariables
>;
export const DeleteAdminUserDocument = gql`
	mutation DeleteAdminUser($id: ID!) {
		deleteAdminUser(id: $id) {
			success
			message
		}
	}
`;
export type DeleteAdminUserMutationFn = Apollo.MutationFunction<
	DeleteAdminUserMutation,
	DeleteAdminUserMutationVariables
>;

/**
 * __useDeleteAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminUserMutation, { data, loading, error }] = useDeleteAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteAdminUserMutation,
		DeleteAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>(
		DeleteAdminUserDocument,
		options
	);
}
export type DeleteAdminUserMutationHookResult = ReturnType<typeof useDeleteAdminUserMutation>;
export type DeleteAdminUserMutationResult = Apollo.MutationResult<DeleteAdminUserMutation>;
export type DeleteAdminUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteAdminUserMutation,
	DeleteAdminUserMutationVariables
>;
export const DeleteManyAdminUserDocument = gql`
	mutation DeleteManyAdminUser($input: DeleteManyInput!) {
		deleteManyAdminUser(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManyAdminUserMutationFn = Apollo.MutationFunction<
	DeleteManyAdminUserMutation,
	DeleteManyAdminUserMutationVariables
>;

/**
 * __useDeleteManyAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteManyAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyAdminUserMutation, { data, loading, error }] = useDeleteManyAdminUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyAdminUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyAdminUserMutation,
		DeleteManyAdminUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManyAdminUserMutation, DeleteManyAdminUserMutationVariables>(
		DeleteManyAdminUserDocument,
		options
	);
}
export type DeleteManyAdminUserMutationHookResult = ReturnType<
	typeof useDeleteManyAdminUserMutation
>;
export type DeleteManyAdminUserMutationResult = Apollo.MutationResult<DeleteManyAdminUserMutation>;
export type DeleteManyAdminUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyAdminUserMutation,
	DeleteManyAdminUserMutationVariables
>;
export const ApprovePremiumAccessDocument = gql`
	mutation ApprovePremiumAccess($userId: ID!) {
		approvePremiumAccess(userId: $userId) {
			id
			isPremium
			premiumRequestedAt
			premiumApprovedAt
		}
	}
`;
export type ApprovePremiumAccessMutationFn = Apollo.MutationFunction<
	ApprovePremiumAccessMutation,
	ApprovePremiumAccessMutationVariables
>;

/**
 * __useApprovePremiumAccessMutation__
 *
 * To run a mutation, you first call `useApprovePremiumAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePremiumAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePremiumAccessMutation, { data, loading, error }] = useApprovePremiumAccessMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useApprovePremiumAccessMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApprovePremiumAccessMutation,
		ApprovePremiumAccessMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ApprovePremiumAccessMutation, ApprovePremiumAccessMutationVariables>(
		ApprovePremiumAccessDocument,
		options
	);
}
export type ApprovePremiumAccessMutationHookResult = ReturnType<
	typeof useApprovePremiumAccessMutation
>;
export type ApprovePremiumAccessMutationResult =
	Apollo.MutationResult<ApprovePremiumAccessMutation>;
export type ApprovePremiumAccessMutationOptions = Apollo.BaseMutationOptions<
	ApprovePremiumAccessMutation,
	ApprovePremiumAccessMutationVariables
>;
export const RejectPremiumAccessDocument = gql`
	mutation RejectPremiumAccess($userId: ID!) {
		rejectPremiumAccess(userId: $userId) {
			id
			isPremium
			premiumRequestedAt
			premiumApprovedAt
		}
	}
`;
export type RejectPremiumAccessMutationFn = Apollo.MutationFunction<
	RejectPremiumAccessMutation,
	RejectPremiumAccessMutationVariables
>;

/**
 * __useRejectPremiumAccessMutation__
 *
 * To run a mutation, you first call `useRejectPremiumAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectPremiumAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectPremiumAccessMutation, { data, loading, error }] = useRejectPremiumAccessMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRejectPremiumAccessMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectPremiumAccessMutation,
		RejectPremiumAccessMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RejectPremiumAccessMutation, RejectPremiumAccessMutationVariables>(
		RejectPremiumAccessDocument,
		options
	);
}
export type RejectPremiumAccessMutationHookResult = ReturnType<
	typeof useRejectPremiumAccessMutation
>;
export type RejectPremiumAccessMutationResult = Apollo.MutationResult<RejectPremiumAccessMutation>;
export type RejectPremiumAccessMutationOptions = Apollo.BaseMutationOptions<
	RejectPremiumAccessMutation,
	RejectPremiumAccessMutationVariables
>;
export const ApproveManyPremiumAccessDocument = gql`
	mutation ApproveManyPremiumAccess($userIds: [ID!]!) {
		approveManyPremiumAccess(userIds: $userIds) {
			success
			message
		}
	}
`;
export type ApproveManyPremiumAccessMutationFn = Apollo.MutationFunction<
	ApproveManyPremiumAccessMutation,
	ApproveManyPremiumAccessMutationVariables
>;

/**
 * __useApproveManyPremiumAccessMutation__
 *
 * To run a mutation, you first call `useApproveManyPremiumAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveManyPremiumAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveManyPremiumAccessMutation, { data, loading, error }] = useApproveManyPremiumAccessMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useApproveManyPremiumAccessMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveManyPremiumAccessMutation,
		ApproveManyPremiumAccessMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ApproveManyPremiumAccessMutation,
		ApproveManyPremiumAccessMutationVariables
	>(ApproveManyPremiumAccessDocument, options);
}
export type ApproveManyPremiumAccessMutationHookResult = ReturnType<
	typeof useApproveManyPremiumAccessMutation
>;
export type ApproveManyPremiumAccessMutationResult =
	Apollo.MutationResult<ApproveManyPremiumAccessMutation>;
export type ApproveManyPremiumAccessMutationOptions = Apollo.BaseMutationOptions<
	ApproveManyPremiumAccessMutation,
	ApproveManyPremiumAccessMutationVariables
>;
export const RejectManyPremiumAccessDocument = gql`
	mutation RejectManyPremiumAccess($userIds: [ID!]!) {
		rejectManyPremiumAccess(userIds: $userIds) {
			success
			message
		}
	}
`;
export type RejectManyPremiumAccessMutationFn = Apollo.MutationFunction<
	RejectManyPremiumAccessMutation,
	RejectManyPremiumAccessMutationVariables
>;

/**
 * __useRejectManyPremiumAccessMutation__
 *
 * To run a mutation, you first call `useRejectManyPremiumAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectManyPremiumAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectManyPremiumAccessMutation, { data, loading, error }] = useRejectManyPremiumAccessMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useRejectManyPremiumAccessMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RejectManyPremiumAccessMutation,
		RejectManyPremiumAccessMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RejectManyPremiumAccessMutation,
		RejectManyPremiumAccessMutationVariables
	>(RejectManyPremiumAccessDocument, options);
}
export type RejectManyPremiumAccessMutationHookResult = ReturnType<
	typeof useRejectManyPremiumAccessMutation
>;
export type RejectManyPremiumAccessMutationResult =
	Apollo.MutationResult<RejectManyPremiumAccessMutation>;
export type RejectManyPremiumAccessMutationOptions = Apollo.BaseMutationOptions<
	RejectManyPremiumAccessMutation,
	RejectManyPremiumAccessMutationVariables
>;
export const UploadAdminNewsletterSubscribersDocument = gql`
	mutation UploadAdminNewsletterSubscribers($input: [UploadAdminNewsletterSubscriberInput!]!) {
		uploadAdminNewsletterSubscribers(input: $input) {
			success
			message
			created
			updated
			skipped
		}
	}
`;
export type UploadAdminNewsletterSubscribersMutationFn = Apollo.MutationFunction<
	UploadAdminNewsletterSubscribersMutation,
	UploadAdminNewsletterSubscribersMutationVariables
>;

/**
 * __useUploadAdminNewsletterSubscribersMutation__
 *
 * To run a mutation, you first call `useUploadAdminNewsletterSubscribersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdminNewsletterSubscribersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAdminNewsletterSubscribersMutation, { data, loading, error }] = useUploadAdminNewsletterSubscribersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAdminNewsletterSubscribersMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UploadAdminNewsletterSubscribersMutation,
		UploadAdminNewsletterSubscribersMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UploadAdminNewsletterSubscribersMutation,
		UploadAdminNewsletterSubscribersMutationVariables
	>(UploadAdminNewsletterSubscribersDocument, options);
}
export type UploadAdminNewsletterSubscribersMutationHookResult = ReturnType<
	typeof useUploadAdminNewsletterSubscribersMutation
>;
export type UploadAdminNewsletterSubscribersMutationResult =
	Apollo.MutationResult<UploadAdminNewsletterSubscribersMutation>;
export type UploadAdminNewsletterSubscribersMutationOptions = Apollo.BaseMutationOptions<
	UploadAdminNewsletterSubscribersMutation,
	UploadAdminNewsletterSubscribersMutationVariables
>;
export const SendAdminNewsletterEmailDocument = gql`
	mutation SendAdminNewsletterEmail($input: SendAdminNewsletterEmailInput!) {
		sendAdminNewsletterEmail(input: $input) {
			success
			message
			sent
			failed
		}
	}
`;
export type SendAdminNewsletterEmailMutationFn = Apollo.MutationFunction<
	SendAdminNewsletterEmailMutation,
	SendAdminNewsletterEmailMutationVariables
>;

/**
 * __useSendAdminNewsletterEmailMutation__
 *
 * To run a mutation, you first call `useSendAdminNewsletterEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAdminNewsletterEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAdminNewsletterEmailMutation, { data, loading, error }] = useSendAdminNewsletterEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAdminNewsletterEmailMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SendAdminNewsletterEmailMutation,
		SendAdminNewsletterEmailMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		SendAdminNewsletterEmailMutation,
		SendAdminNewsletterEmailMutationVariables
	>(SendAdminNewsletterEmailDocument, options);
}
export type SendAdminNewsletterEmailMutationHookResult = ReturnType<
	typeof useSendAdminNewsletterEmailMutation
>;
export type SendAdminNewsletterEmailMutationResult =
	Apollo.MutationResult<SendAdminNewsletterEmailMutation>;
export type SendAdminNewsletterEmailMutationOptions = Apollo.BaseMutationOptions<
	SendAdminNewsletterEmailMutation,
	SendAdminNewsletterEmailMutationVariables
>;
export const UnsubscribeAdminNewsletterSubscriberDocument = gql`
	mutation UnsubscribeAdminNewsletterSubscriber($email: String!) {
		unsubscribeAdminNewsletterSubscriber(email: $email) {
			success
			message
		}
	}
`;
export type UnsubscribeAdminNewsletterSubscriberMutationFn = Apollo.MutationFunction<
	UnsubscribeAdminNewsletterSubscriberMutation,
	UnsubscribeAdminNewsletterSubscriberMutationVariables
>;

/**
 * __useUnsubscribeAdminNewsletterSubscriberMutation__
 *
 * To run a mutation, you first call `useUnsubscribeAdminNewsletterSubscriberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeAdminNewsletterSubscriberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeAdminNewsletterSubscriberMutation, { data, loading, error }] = useUnsubscribeAdminNewsletterSubscriberMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUnsubscribeAdminNewsletterSubscriberMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UnsubscribeAdminNewsletterSubscriberMutation,
		UnsubscribeAdminNewsletterSubscriberMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UnsubscribeAdminNewsletterSubscriberMutation,
		UnsubscribeAdminNewsletterSubscriberMutationVariables
	>(UnsubscribeAdminNewsletterSubscriberDocument, options);
}
export type UnsubscribeAdminNewsletterSubscriberMutationHookResult = ReturnType<
	typeof useUnsubscribeAdminNewsletterSubscriberMutation
>;
export type UnsubscribeAdminNewsletterSubscriberMutationResult =
	Apollo.MutationResult<UnsubscribeAdminNewsletterSubscriberMutation>;
export type UnsubscribeAdminNewsletterSubscriberMutationOptions = Apollo.BaseMutationOptions<
	UnsubscribeAdminNewsletterSubscriberMutation,
	UnsubscribeAdminNewsletterSubscriberMutationVariables
>;
export const ResubscribeAdminNewsletterSubscriberDocument = gql`
	mutation ResubscribeAdminNewsletterSubscriber($email: String!) {
		resubscribeAdminNewsletterSubscriber(email: $email) {
			success
			message
		}
	}
`;
export type ResubscribeAdminNewsletterSubscriberMutationFn = Apollo.MutationFunction<
	ResubscribeAdminNewsletterSubscriberMutation,
	ResubscribeAdminNewsletterSubscriberMutationVariables
>;

/**
 * __useResubscribeAdminNewsletterSubscriberMutation__
 *
 * To run a mutation, you first call `useResubscribeAdminNewsletterSubscriberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResubscribeAdminNewsletterSubscriberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resubscribeAdminNewsletterSubscriberMutation, { data, loading, error }] = useResubscribeAdminNewsletterSubscriberMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResubscribeAdminNewsletterSubscriberMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ResubscribeAdminNewsletterSubscriberMutation,
		ResubscribeAdminNewsletterSubscriberMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ResubscribeAdminNewsletterSubscriberMutation,
		ResubscribeAdminNewsletterSubscriberMutationVariables
	>(ResubscribeAdminNewsletterSubscriberDocument, options);
}
export type ResubscribeAdminNewsletterSubscriberMutationHookResult = ReturnType<
	typeof useResubscribeAdminNewsletterSubscriberMutation
>;
export type ResubscribeAdminNewsletterSubscriberMutationResult =
	Apollo.MutationResult<ResubscribeAdminNewsletterSubscriberMutation>;
export type ResubscribeAdminNewsletterSubscriberMutationOptions = Apollo.BaseMutationOptions<
	ResubscribeAdminNewsletterSubscriberMutation,
	ResubscribeAdminNewsletterSubscriberMutationVariables
>;
export const DeleteManyAdminNewsletterSubscriberDocument = gql`
	mutation DeleteManyAdminNewsletterSubscriber($input: DeleteManyInput!) {
		deleteManyAdminNewsletterSubscriber(input: $input) {
			success
			message
			deleted
		}
	}
`;
export type DeleteManyAdminNewsletterSubscriberMutationFn = Apollo.MutationFunction<
	DeleteManyAdminNewsletterSubscriberMutation,
	DeleteManyAdminNewsletterSubscriberMutationVariables
>;

/**
 * __useDeleteManyAdminNewsletterSubscriberMutation__
 *
 * To run a mutation, you first call `useDeleteManyAdminNewsletterSubscriberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyAdminNewsletterSubscriberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyAdminNewsletterSubscriberMutation, { data, loading, error }] = useDeleteManyAdminNewsletterSubscriberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyAdminNewsletterSubscriberMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyAdminNewsletterSubscriberMutation,
		DeleteManyAdminNewsletterSubscriberMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyAdminNewsletterSubscriberMutation,
		DeleteManyAdminNewsletterSubscriberMutationVariables
	>(DeleteManyAdminNewsletterSubscriberDocument, options);
}
export type DeleteManyAdminNewsletterSubscriberMutationHookResult = ReturnType<
	typeof useDeleteManyAdminNewsletterSubscriberMutation
>;
export type DeleteManyAdminNewsletterSubscriberMutationResult =
	Apollo.MutationResult<DeleteManyAdminNewsletterSubscriberMutation>;
export type DeleteManyAdminNewsletterSubscriberMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyAdminNewsletterSubscriberMutation,
	DeleteManyAdminNewsletterSubscriberMutationVariables
>;
export const LoginDocument = gql`
	mutation Login($input: LoginInput!) {
		login(input: $input) {
			token
			userId
			mfaRequired
			mfaMethod
			role
			supportsBackupCodes
		}
	}
`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(
	baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<
	LoginMutation,
	LoginMutationVariables
>;
export const LoginValidateDocument = gql`
	mutation LoginValidate($input: LoginValidateInput!) {
		loginValidate(input: $input) {
			token
			refreshToken
			user {
				id
				role
				language
				email
				organizationUser {
					id
					organizationId
					firstName
					lastName
					organization {
						id
						name
						onboarded
						organizationSetting {
							timezone
							currency
							measurementSystem
						}
					}
				}
				user {
					id
					userId
					firstName
					lastName
				}
			}
		}
	}
`;
export type LoginValidateMutationFn = Apollo.MutationFunction<
	LoginValidateMutation,
	LoginValidateMutationVariables
>;

/**
 * __useLoginValidateMutation__
 *
 * To run a mutation, you first call `useLoginValidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginValidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginValidateMutation, { data, loading, error }] = useLoginValidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginValidateMutation(
	baseOptions?: Apollo.MutationHookOptions<LoginValidateMutation, LoginValidateMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LoginValidateMutation, LoginValidateMutationVariables>(
		LoginValidateDocument,
		options
	);
}
export type LoginValidateMutationHookResult = ReturnType<typeof useLoginValidateMutation>;
export type LoginValidateMutationResult = Apollo.MutationResult<LoginValidateMutation>;
export type LoginValidateMutationOptions = Apollo.BaseMutationOptions<
	LoginValidateMutation,
	LoginValidateMutationVariables
>;
export const RefreshTokenDocument = gql`
	mutation RefreshToken($token: String!) {
		refreshToken(token: $token) {
			token
			refreshToken
			user {
				id
				role
				language
				email
				organizationUser {
					id
					organizationId
					firstName
					lastName
					organization {
						id
						name
						onboarded
						organizationSetting {
							timezone
							currency
							measurementSystem
						}
					}
				}
				user {
					id
					userId
					firstName
					lastName
				}
			}
		}
	}
`;
export type RefreshTokenMutationFn = Apollo.MutationFunction<
	RefreshTokenMutation,
	RefreshTokenMutationVariables
>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRefreshTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(
		RefreshTokenDocument,
		options
	);
}
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
	RefreshTokenMutation,
	RefreshTokenMutationVariables
>;
export const ValidateAuthenticationTokenDocument = gql`
	mutation ValidateAuthenticationToken($token: String!) {
		validateAuthenticationToken(token: $token) {
			token
			user {
				id
				email
				organizationUser {
					id
					firstName
					lastName
				}
			}
		}
	}
`;
export type ValidateAuthenticationTokenMutationFn = Apollo.MutationFunction<
	ValidateAuthenticationTokenMutation,
	ValidateAuthenticationTokenMutationVariables
>;

/**
 * __useValidateAuthenticationTokenMutation__
 *
 * To run a mutation, you first call `useValidateAuthenticationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAuthenticationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAuthenticationTokenMutation, { data, loading, error }] = useValidateAuthenticationTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateAuthenticationTokenMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ValidateAuthenticationTokenMutation,
		ValidateAuthenticationTokenMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ValidateAuthenticationTokenMutation,
		ValidateAuthenticationTokenMutationVariables
	>(ValidateAuthenticationTokenDocument, options);
}
export type ValidateAuthenticationTokenMutationHookResult = ReturnType<
	typeof useValidateAuthenticationTokenMutation
>;
export type ValidateAuthenticationTokenMutationResult =
	Apollo.MutationResult<ValidateAuthenticationTokenMutation>;
export type ValidateAuthenticationTokenMutationOptions = Apollo.BaseMutationOptions<
	ValidateAuthenticationTokenMutation,
	ValidateAuthenticationTokenMutationVariables
>;
export const RegisterDocument = gql`
	mutation Register($input: RegisterInput!) {
		register(input: $input) {
			userId
			qrCodeDataURL
		}
	}
`;
export type RegisterMutationFn = Apollo.MutationFunction<
	RegisterMutation,
	RegisterMutationVariables
>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(
	baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(
		RegisterDocument,
		options
	);
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<
	RegisterMutation,
	RegisterMutationVariables
>;
export const UnlockAuthenticationUserDocument = gql`
	mutation UnlockAuthenticationUser($userId: ID!) {
		unlockAuthenticationUser(userId: $userId) {
			success
			message
		}
	}
`;
export type UnlockAuthenticationUserMutationFn = Apollo.MutationFunction<
	UnlockAuthenticationUserMutation,
	UnlockAuthenticationUserMutationVariables
>;

/**
 * __useUnlockAuthenticationUserMutation__
 *
 * To run a mutation, you first call `useUnlockAuthenticationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockAuthenticationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockAuthenticationUserMutation, { data, loading, error }] = useUnlockAuthenticationUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnlockAuthenticationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UnlockAuthenticationUserMutation,
		UnlockAuthenticationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UnlockAuthenticationUserMutation,
		UnlockAuthenticationUserMutationVariables
	>(UnlockAuthenticationUserDocument, options);
}
export type UnlockAuthenticationUserMutationHookResult = ReturnType<
	typeof useUnlockAuthenticationUserMutation
>;
export type UnlockAuthenticationUserMutationResult =
	Apollo.MutationResult<UnlockAuthenticationUserMutation>;
export type UnlockAuthenticationUserMutationOptions = Apollo.BaseMutationOptions<
	UnlockAuthenticationUserMutation,
	UnlockAuthenticationUserMutationVariables
>;
export const BypassMigrated2FaDocument = gql`
	mutation BypassMigrated2FA($userId: ID!) {
		bypassMigrated2FA(userId: $userId) {
			success
			message
		}
	}
`;
export type BypassMigrated2FaMutationFn = Apollo.MutationFunction<
	BypassMigrated2FaMutation,
	BypassMigrated2FaMutationVariables
>;

/**
 * __useBypassMigrated2FaMutation__
 *
 * To run a mutation, you first call `useBypassMigrated2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBypassMigrated2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bypassMigrated2FaMutation, { data, loading, error }] = useBypassMigrated2FaMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBypassMigrated2FaMutation(
	baseOptions?: Apollo.MutationHookOptions<
		BypassMigrated2FaMutation,
		BypassMigrated2FaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BypassMigrated2FaMutation, BypassMigrated2FaMutationVariables>(
		BypassMigrated2FaDocument,
		options
	);
}
export type BypassMigrated2FaMutationHookResult = ReturnType<typeof useBypassMigrated2FaMutation>;
export type BypassMigrated2FaMutationResult = Apollo.MutationResult<BypassMigrated2FaMutation>;
export type BypassMigrated2FaMutationOptions = Apollo.BaseMutationOptions<
	BypassMigrated2FaMutation,
	BypassMigrated2FaMutationVariables
>;
export const BypassManyMigrated2FaDocument = gql`
	mutation BypassManyMigrated2FA($userIds: [ID!]!) {
		bypassManyMigrated2FA(userIds: $userIds) {
			success
			message
		}
	}
`;
export type BypassManyMigrated2FaMutationFn = Apollo.MutationFunction<
	BypassManyMigrated2FaMutation,
	BypassManyMigrated2FaMutationVariables
>;

/**
 * __useBypassManyMigrated2FaMutation__
 *
 * To run a mutation, you first call `useBypassManyMigrated2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBypassManyMigrated2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bypassManyMigrated2FaMutation, { data, loading, error }] = useBypassManyMigrated2FaMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useBypassManyMigrated2FaMutation(
	baseOptions?: Apollo.MutationHookOptions<
		BypassManyMigrated2FaMutation,
		BypassManyMigrated2FaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		BypassManyMigrated2FaMutation,
		BypassManyMigrated2FaMutationVariables
	>(BypassManyMigrated2FaDocument, options);
}
export type BypassManyMigrated2FaMutationHookResult = ReturnType<
	typeof useBypassManyMigrated2FaMutation
>;
export type BypassManyMigrated2FaMutationResult =
	Apollo.MutationResult<BypassManyMigrated2FaMutation>;
export type BypassManyMigrated2FaMutationOptions = Apollo.BaseMutationOptions<
	BypassManyMigrated2FaMutation,
	BypassManyMigrated2FaMutationVariables
>;
export const PasswordResetRequestDocument = gql`
	mutation PasswordResetRequest($input: PasswordResetRequestInput!) {
		passwordResetRequest(input: $input)
	}
`;
export type PasswordResetRequestMutationFn = Apollo.MutationFunction<
	PasswordResetRequestMutation,
	PasswordResetRequestMutationVariables
>;

/**
 * __usePasswordResetRequestMutation__
 *
 * To run a mutation, you first call `usePasswordResetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetRequestMutation, { data, loading, error }] = usePasswordResetRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PasswordResetRequestMutation,
		PasswordResetRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PasswordResetRequestMutation, PasswordResetRequestMutationVariables>(
		PasswordResetRequestDocument,
		options
	);
}
export type PasswordResetRequestMutationHookResult = ReturnType<
	typeof usePasswordResetRequestMutation
>;
export type PasswordResetRequestMutationResult =
	Apollo.MutationResult<PasswordResetRequestMutation>;
export type PasswordResetRequestMutationOptions = Apollo.BaseMutationOptions<
	PasswordResetRequestMutation,
	PasswordResetRequestMutationVariables
>;
export const PasswordResetValidateDocument = gql`
	mutation PasswordResetValidate($input: PasswordResetValidateInput!) {
		passwordResetValidate(input: $input) {
			success
			message
		}
	}
`;
export type PasswordResetValidateMutationFn = Apollo.MutationFunction<
	PasswordResetValidateMutation,
	PasswordResetValidateMutationVariables
>;

/**
 * __usePasswordResetValidateMutation__
 *
 * To run a mutation, you first call `usePasswordResetValidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetValidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetValidateMutation, { data, loading, error }] = usePasswordResetValidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetValidateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		PasswordResetValidateMutation,
		PasswordResetValidateMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		PasswordResetValidateMutation,
		PasswordResetValidateMutationVariables
	>(PasswordResetValidateDocument, options);
}
export type PasswordResetValidateMutationHookResult = ReturnType<
	typeof usePasswordResetValidateMutation
>;
export type PasswordResetValidateMutationResult =
	Apollo.MutationResult<PasswordResetValidateMutation>;
export type PasswordResetValidateMutationOptions = Apollo.BaseMutationOptions<
	PasswordResetValidateMutation,
	PasswordResetValidateMutationVariables
>;
export const PasswordResetDocument = gql`
	mutation PasswordReset($input: PasswordResetInput!) {
		passwordReset(input: $input) {
			success
			message
		}
	}
`;
export type PasswordResetMutationFn = Apollo.MutationFunction<
	PasswordResetMutation,
	PasswordResetMutationVariables
>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetMutation(
	baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(
		PasswordResetDocument,
		options
	);
}
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<
	PasswordResetMutation,
	PasswordResetMutationVariables
>;
export const ResendPasswordResetRequestDocument = gql`
	mutation ResendPasswordResetRequest($input: PasswordResetRequestInput!) {
		resendPasswordResetRequest(input: $input)
	}
`;
export type ResendPasswordResetRequestMutationFn = Apollo.MutationFunction<
	ResendPasswordResetRequestMutation,
	ResendPasswordResetRequestMutationVariables
>;

/**
 * __useResendPasswordResetRequestMutation__
 *
 * To run a mutation, you first call `useResendPasswordResetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPasswordResetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPasswordResetRequestMutation, { data, loading, error }] = useResendPasswordResetRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendPasswordResetRequestMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ResendPasswordResetRequestMutation,
		ResendPasswordResetRequestMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ResendPasswordResetRequestMutation,
		ResendPasswordResetRequestMutationVariables
	>(ResendPasswordResetRequestDocument, options);
}
export type ResendPasswordResetRequestMutationHookResult = ReturnType<
	typeof useResendPasswordResetRequestMutation
>;
export type ResendPasswordResetRequestMutationResult =
	Apollo.MutationResult<ResendPasswordResetRequestMutation>;
export type ResendPasswordResetRequestMutationOptions = Apollo.BaseMutationOptions<
	ResendPasswordResetRequestMutation,
	ResendPasswordResetRequestMutationVariables
>;
export const VerifyAuthenticatorSetupDocument = gql`
	mutation VerifyAuthenticatorSetup($input: VerifyAuthenticatorSetupInput!) {
		verifyAuthenticatorSetup(input: $input) {
			token
			userId
			role
			backupCodes
		}
	}
`;
export type VerifyAuthenticatorSetupMutationFn = Apollo.MutationFunction<
	VerifyAuthenticatorSetupMutation,
	VerifyAuthenticatorSetupMutationVariables
>;

/**
 * __useVerifyAuthenticatorSetupMutation__
 *
 * To run a mutation, you first call `useVerifyAuthenticatorSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthenticatorSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthenticatorSetupMutation, { data, loading, error }] = useVerifyAuthenticatorSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAuthenticatorSetupMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VerifyAuthenticatorSetupMutation,
		VerifyAuthenticatorSetupMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		VerifyAuthenticatorSetupMutation,
		VerifyAuthenticatorSetupMutationVariables
	>(VerifyAuthenticatorSetupDocument, options);
}
export type VerifyAuthenticatorSetupMutationHookResult = ReturnType<
	typeof useVerifyAuthenticatorSetupMutation
>;
export type VerifyAuthenticatorSetupMutationResult =
	Apollo.MutationResult<VerifyAuthenticatorSetupMutation>;
export type VerifyAuthenticatorSetupMutationOptions = Apollo.BaseMutationOptions<
	VerifyAuthenticatorSetupMutation,
	VerifyAuthenticatorSetupMutationVariables
>;
export const VerifyEmailMfaDocument = gql`
	mutation VerifyEmailMfa($input: VerifyEmailMfaInput!) {
		verifyEmailMfa(input: $input) {
			token
			role
		}
	}
`;
export type VerifyEmailMfaMutationFn = Apollo.MutationFunction<
	VerifyEmailMfaMutation,
	VerifyEmailMfaMutationVariables
>;

/**
 * __useVerifyEmailMfaMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMfaMutation, { data, loading, error }] = useVerifyEmailMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMfaMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VerifyEmailMfaMutation,
		VerifyEmailMfaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<VerifyEmailMfaMutation, VerifyEmailMfaMutationVariables>(
		VerifyEmailMfaDocument,
		options
	);
}
export type VerifyEmailMfaMutationHookResult = ReturnType<typeof useVerifyEmailMfaMutation>;
export type VerifyEmailMfaMutationResult = Apollo.MutationResult<VerifyEmailMfaMutation>;
export type VerifyEmailMfaMutationOptions = Apollo.BaseMutationOptions<
	VerifyEmailMfaMutation,
	VerifyEmailMfaMutationVariables
>;
export const ResendEmailMfaCodeDocument = gql`
	mutation ResendEmailMfaCode($userId: ID!) {
		resendEmailMfaCode(userId: $userId) {
			message
			success
		}
	}
`;
export type ResendEmailMfaCodeMutationFn = Apollo.MutationFunction<
	ResendEmailMfaCodeMutation,
	ResendEmailMfaCodeMutationVariables
>;

/**
 * __useResendEmailMfaCodeMutation__
 *
 * To run a mutation, you first call `useResendEmailMfaCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailMfaCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailMfaCodeMutation, { data, loading, error }] = useResendEmailMfaCodeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendEmailMfaCodeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ResendEmailMfaCodeMutation,
		ResendEmailMfaCodeMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ResendEmailMfaCodeMutation, ResendEmailMfaCodeMutationVariables>(
		ResendEmailMfaCodeDocument,
		options
	);
}
export type ResendEmailMfaCodeMutationHookResult = ReturnType<typeof useResendEmailMfaCodeMutation>;
export type ResendEmailMfaCodeMutationResult = Apollo.MutationResult<ResendEmailMfaCodeMutation>;
export type ResendEmailMfaCodeMutationOptions = Apollo.BaseMutationOptions<
	ResendEmailMfaCodeMutation,
	ResendEmailMfaCodeMutationVariables
>;
export const VerifyAuthenticatorMfaDocument = gql`
	mutation VerifyAuthenticatorMfa($input: VerifyAuthenticatorMfaInput!) {
		verifyAuthenticatorMfa(input: $input) {
			token
			role
		}
	}
`;
export type VerifyAuthenticatorMfaMutationFn = Apollo.MutationFunction<
	VerifyAuthenticatorMfaMutation,
	VerifyAuthenticatorMfaMutationVariables
>;

/**
 * __useVerifyAuthenticatorMfaMutation__
 *
 * To run a mutation, you first call `useVerifyAuthenticatorMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthenticatorMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthenticatorMfaMutation, { data, loading, error }] = useVerifyAuthenticatorMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAuthenticatorMfaMutation(
	baseOptions?: Apollo.MutationHookOptions<
		VerifyAuthenticatorMfaMutation,
		VerifyAuthenticatorMfaMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		VerifyAuthenticatorMfaMutation,
		VerifyAuthenticatorMfaMutationVariables
	>(VerifyAuthenticatorMfaDocument, options);
}
export type VerifyAuthenticatorMfaMutationHookResult = ReturnType<
	typeof useVerifyAuthenticatorMfaMutation
>;
export type VerifyAuthenticatorMfaMutationResult =
	Apollo.MutationResult<VerifyAuthenticatorMfaMutation>;
export type VerifyAuthenticatorMfaMutationOptions = Apollo.BaseMutationOptions<
	VerifyAuthenticatorMfaMutation,
	VerifyAuthenticatorMfaMutationVariables
>;
export const LogoutDocument = gql`
	mutation Logout($input: LogoutInput!) {
		logout(input: $input) {
			success
			message
		}
	}
`;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutMutation(
	baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
	LogoutMutation,
	LogoutMutationVariables
>;
export const CreateOrganizationSignupDocument = gql`
	mutation CreateOrganizationSignup($input: OrganizationSignupInput!) {
		createOrganizationSignup(input: $input) {
			userId
			qrCodeDataURL
		}
	}
`;
export type CreateOrganizationSignupMutationFn = Apollo.MutationFunction<
	CreateOrganizationSignupMutation,
	CreateOrganizationSignupMutationVariables
>;

/**
 * __useCreateOrganizationSignupMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationSignupMutation, { data, loading, error }] = useCreateOrganizationSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationSignupMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationSignupMutation,
		CreateOrganizationSignupMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationSignupMutation,
		CreateOrganizationSignupMutationVariables
	>(CreateOrganizationSignupDocument, options);
}
export type CreateOrganizationSignupMutationHookResult = ReturnType<
	typeof useCreateOrganizationSignupMutation
>;
export type CreateOrganizationSignupMutationResult =
	Apollo.MutationResult<CreateOrganizationSignupMutation>;
export type CreateOrganizationSignupMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationSignupMutation,
	CreateOrganizationSignupMutationVariables
>;
export const CreateUserSignupDocument = gql`
	mutation CreateUserSignup($input: UserSignupInput!) {
		createUserSignup(input: $input) {
			userId
			qrCodeDataURL
		}
	}
`;
export type CreateUserSignupMutationFn = Apollo.MutationFunction<
	CreateUserSignupMutation,
	CreateUserSignupMutationVariables
>;

/**
 * __useCreateUserSignupMutation__
 *
 * To run a mutation, you first call `useCreateUserSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSignupMutation, { data, loading, error }] = useCreateUserSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserSignupMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateUserSignupMutation,
		CreateUserSignupMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateUserSignupMutation, CreateUserSignupMutationVariables>(
		CreateUserSignupDocument,
		options
	);
}
export type CreateUserSignupMutationHookResult = ReturnType<typeof useCreateUserSignupMutation>;
export type CreateUserSignupMutationResult = Apollo.MutationResult<CreateUserSignupMutation>;
export type CreateUserSignupMutationOptions = Apollo.BaseMutationOptions<
	CreateUserSignupMutation,
	CreateUserSignupMutationVariables
>;
export const CreateAuthorizationRoleDocument = gql`
	mutation CreateAuthorizationRole($input: AuthorizationRoleCreateInput!) {
		createAuthorizationRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateAuthorizationRoleMutationFn = Apollo.MutationFunction<
	CreateAuthorizationRoleMutation,
	CreateAuthorizationRoleMutationVariables
>;

/**
 * __useCreateAuthorizationRoleMutation__
 *
 * To run a mutation, you first call `useCreateAuthorizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorizationRoleMutation, { data, loading, error }] = useCreateAuthorizationRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthorizationRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateAuthorizationRoleMutation,
		CreateAuthorizationRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateAuthorizationRoleMutation,
		CreateAuthorizationRoleMutationVariables
	>(CreateAuthorizationRoleDocument, options);
}
export type CreateAuthorizationRoleMutationHookResult = ReturnType<
	typeof useCreateAuthorizationRoleMutation
>;
export type CreateAuthorizationRoleMutationResult =
	Apollo.MutationResult<CreateAuthorizationRoleMutation>;
export type CreateAuthorizationRoleMutationOptions = Apollo.BaseMutationOptions<
	CreateAuthorizationRoleMutation,
	CreateAuthorizationRoleMutationVariables
>;
export const UpdateAuthorizationRoleDocument = gql`
	mutation UpdateAuthorizationRole($input: AuthorizationRoleUpdateInput!) {
		updateAuthorizationRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateAuthorizationRoleMutationFn = Apollo.MutationFunction<
	UpdateAuthorizationRoleMutation,
	UpdateAuthorizationRoleMutationVariables
>;

/**
 * __useUpdateAuthorizationRoleMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorizationRoleMutation, { data, loading, error }] = useUpdateAuthorizationRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorizationRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateAuthorizationRoleMutation,
		UpdateAuthorizationRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateAuthorizationRoleMutation,
		UpdateAuthorizationRoleMutationVariables
	>(UpdateAuthorizationRoleDocument, options);
}
export type UpdateAuthorizationRoleMutationHookResult = ReturnType<
	typeof useUpdateAuthorizationRoleMutation
>;
export type UpdateAuthorizationRoleMutationResult =
	Apollo.MutationResult<UpdateAuthorizationRoleMutation>;
export type UpdateAuthorizationRoleMutationOptions = Apollo.BaseMutationOptions<
	UpdateAuthorizationRoleMutation,
	UpdateAuthorizationRoleMutationVariables
>;
export const DeleteAuthorizationRoleDocument = gql`
	mutation DeleteAuthorizationRole($input: DeleteInput!) {
		deleteAuthorizationRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteAuthorizationRoleMutationFn = Apollo.MutationFunction<
	DeleteAuthorizationRoleMutation,
	DeleteAuthorizationRoleMutationVariables
>;

/**
 * __useDeleteAuthorizationRoleMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorizationRoleMutation, { data, loading, error }] = useDeleteAuthorizationRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAuthorizationRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteAuthorizationRoleMutation,
		DeleteAuthorizationRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteAuthorizationRoleMutation,
		DeleteAuthorizationRoleMutationVariables
	>(DeleteAuthorizationRoleDocument, options);
}
export type DeleteAuthorizationRoleMutationHookResult = ReturnType<
	typeof useDeleteAuthorizationRoleMutation
>;
export type DeleteAuthorizationRoleMutationResult =
	Apollo.MutationResult<DeleteAuthorizationRoleMutation>;
export type DeleteAuthorizationRoleMutationOptions = Apollo.BaseMutationOptions<
	DeleteAuthorizationRoleMutation,
	DeleteAuthorizationRoleMutationVariables
>;
export const DeleteManyAuthorizationRoleDocument = gql`
	mutation DeleteManyAuthorizationRole($input: DeleteManyInput!) {
		deleteManyAuthorizationRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyAuthorizationRoleMutationFn = Apollo.MutationFunction<
	DeleteManyAuthorizationRoleMutation,
	DeleteManyAuthorizationRoleMutationVariables
>;

/**
 * __useDeleteManyAuthorizationRoleMutation__
 *
 * To run a mutation, you first call `useDeleteManyAuthorizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyAuthorizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyAuthorizationRoleMutation, { data, loading, error }] = useDeleteManyAuthorizationRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyAuthorizationRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyAuthorizationRoleMutation,
		DeleteManyAuthorizationRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyAuthorizationRoleMutation,
		DeleteManyAuthorizationRoleMutationVariables
	>(DeleteManyAuthorizationRoleDocument, options);
}
export type DeleteManyAuthorizationRoleMutationHookResult = ReturnType<
	typeof useDeleteManyAuthorizationRoleMutation
>;
export type DeleteManyAuthorizationRoleMutationResult =
	Apollo.MutationResult<DeleteManyAuthorizationRoleMutation>;
export type DeleteManyAuthorizationRoleMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyAuthorizationRoleMutation,
	DeleteManyAuthorizationRoleMutationVariables
>;
export const CreateManyAuthorizationUserRoleDocument = gql`
	mutation CreateManyAuthorizationUserRole($input: CreateManyAuthorizationUserRoleInput!) {
		createManyAuthorizationUserRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateManyAuthorizationUserRoleMutationFn = Apollo.MutationFunction<
	CreateManyAuthorizationUserRoleMutation,
	CreateManyAuthorizationUserRoleMutationVariables
>;

/**
 * __useCreateManyAuthorizationUserRoleMutation__
 *
 * To run a mutation, you first call `useCreateManyAuthorizationUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManyAuthorizationUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManyAuthorizationUserRoleMutation, { data, loading, error }] = useCreateManyAuthorizationUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManyAuthorizationUserRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateManyAuthorizationUserRoleMutation,
		CreateManyAuthorizationUserRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateManyAuthorizationUserRoleMutation,
		CreateManyAuthorizationUserRoleMutationVariables
	>(CreateManyAuthorizationUserRoleDocument, options);
}
export type CreateManyAuthorizationUserRoleMutationHookResult = ReturnType<
	typeof useCreateManyAuthorizationUserRoleMutation
>;
export type CreateManyAuthorizationUserRoleMutationResult =
	Apollo.MutationResult<CreateManyAuthorizationUserRoleMutation>;
export type CreateManyAuthorizationUserRoleMutationOptions = Apollo.BaseMutationOptions<
	CreateManyAuthorizationUserRoleMutation,
	CreateManyAuthorizationUserRoleMutationVariables
>;
export const DeleteManyAuthorizationUserRoleDocument = gql`
	mutation DeleteManyAuthorizationUserRole($input: DeleteManyAuthorizationUserRoleInput!) {
		deleteManyAuthorizationUserRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyAuthorizationUserRoleMutationFn = Apollo.MutationFunction<
	DeleteManyAuthorizationUserRoleMutation,
	DeleteManyAuthorizationUserRoleMutationVariables
>;

/**
 * __useDeleteManyAuthorizationUserRoleMutation__
 *
 * To run a mutation, you first call `useDeleteManyAuthorizationUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyAuthorizationUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyAuthorizationUserRoleMutation, { data, loading, error }] = useDeleteManyAuthorizationUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyAuthorizationUserRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyAuthorizationUserRoleMutation,
		DeleteManyAuthorizationUserRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyAuthorizationUserRoleMutation,
		DeleteManyAuthorizationUserRoleMutationVariables
	>(DeleteManyAuthorizationUserRoleDocument, options);
}
export type DeleteManyAuthorizationUserRoleMutationHookResult = ReturnType<
	typeof useDeleteManyAuthorizationUserRoleMutation
>;
export type DeleteManyAuthorizationUserRoleMutationResult =
	Apollo.MutationResult<DeleteManyAuthorizationUserRoleMutation>;
export type DeleteManyAuthorizationUserRoleMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyAuthorizationUserRoleMutation,
	DeleteManyAuthorizationUserRoleMutationVariables
>;
export const AssignPermissionsToRoleDocument = gql`
	mutation AssignPermissionsToRole($input: AssignPermissionsToRoleInput!) {
		assignPermissionsToRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type AssignPermissionsToRoleMutationFn = Apollo.MutationFunction<
	AssignPermissionsToRoleMutation,
	AssignPermissionsToRoleMutationVariables
>;

/**
 * __useAssignPermissionsToRoleMutation__
 *
 * To run a mutation, you first call `useAssignPermissionsToRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPermissionsToRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPermissionsToRoleMutation, { data, loading, error }] = useAssignPermissionsToRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignPermissionsToRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AssignPermissionsToRoleMutation,
		AssignPermissionsToRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		AssignPermissionsToRoleMutation,
		AssignPermissionsToRoleMutationVariables
	>(AssignPermissionsToRoleDocument, options);
}
export type AssignPermissionsToRoleMutationHookResult = ReturnType<
	typeof useAssignPermissionsToRoleMutation
>;
export type AssignPermissionsToRoleMutationResult =
	Apollo.MutationResult<AssignPermissionsToRoleMutation>;
export type AssignPermissionsToRoleMutationOptions = Apollo.BaseMutationOptions<
	AssignPermissionsToRoleMutation,
	AssignPermissionsToRoleMutationVariables
>;
export const RemovePermissionsFromRoleDocument = gql`
	mutation RemovePermissionsFromRole($input: RemovePermissionsFromRoleInput!) {
		removePermissionsFromRole(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type RemovePermissionsFromRoleMutationFn = Apollo.MutationFunction<
	RemovePermissionsFromRoleMutation,
	RemovePermissionsFromRoleMutationVariables
>;

/**
 * __useRemovePermissionsFromRoleMutation__
 *
 * To run a mutation, you first call `useRemovePermissionsFromRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermissionsFromRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePermissionsFromRoleMutation, { data, loading, error }] = useRemovePermissionsFromRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePermissionsFromRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemovePermissionsFromRoleMutation,
		RemovePermissionsFromRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemovePermissionsFromRoleMutation,
		RemovePermissionsFromRoleMutationVariables
	>(RemovePermissionsFromRoleDocument, options);
}
export type RemovePermissionsFromRoleMutationHookResult = ReturnType<
	typeof useRemovePermissionsFromRoleMutation
>;
export type RemovePermissionsFromRoleMutationResult =
	Apollo.MutationResult<RemovePermissionsFromRoleMutation>;
export type RemovePermissionsFromRoleMutationOptions = Apollo.BaseMutationOptions<
	RemovePermissionsFromRoleMutation,
	RemovePermissionsFromRoleMutationVariables
>;
export const GenerateMediaUploadUrlDocument = gql`
	mutation GenerateMediaUploadUrl($input: GenerateMediaUploadInput!) {
		generateMediaUploadUrl(input: $input) {
			uploadUrl
			blobUrl
			fileId
			expiresAt
		}
	}
`;
export type GenerateMediaUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateMediaUploadUrlMutation,
	GenerateMediaUploadUrlMutationVariables
>;

/**
 * __useGenerateMediaUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateMediaUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMediaUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMediaUploadUrlMutation, { data, loading, error }] = useGenerateMediaUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateMediaUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateMediaUploadUrlMutation,
		GenerateMediaUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateMediaUploadUrlMutation,
		GenerateMediaUploadUrlMutationVariables
	>(GenerateMediaUploadUrlDocument, options);
}
export type GenerateMediaUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateMediaUploadUrlMutation
>;
export type GenerateMediaUploadUrlMutationResult =
	Apollo.MutationResult<GenerateMediaUploadUrlMutation>;
export type GenerateMediaUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateMediaUploadUrlMutation,
	GenerateMediaUploadUrlMutationVariables
>;
export const DeleteMediaFileDocument = gql`
	mutation DeleteMediaFile($blobUrl: String!) {
		deleteMediaFile(blobUrl: $blobUrl)
	}
`;
export type DeleteMediaFileMutationFn = Apollo.MutationFunction<
	DeleteMediaFileMutation,
	DeleteMediaFileMutationVariables
>;

/**
 * __useDeleteMediaFileMutation__
 *
 * To run a mutation, you first call `useDeleteMediaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaFileMutation, { data, loading, error }] = useDeleteMediaFileMutation({
 *   variables: {
 *      blobUrl: // value for 'blobUrl'
 *   },
 * });
 */
export function useDeleteMediaFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteMediaFileMutation,
		DeleteMediaFileMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteMediaFileMutation, DeleteMediaFileMutationVariables>(
		DeleteMediaFileDocument,
		options
	);
}
export type DeleteMediaFileMutationHookResult = ReturnType<typeof useDeleteMediaFileMutation>;
export type DeleteMediaFileMutationResult = Apollo.MutationResult<DeleteMediaFileMutation>;
export type DeleteMediaFileMutationOptions = Apollo.BaseMutationOptions<
	DeleteMediaFileMutation,
	DeleteMediaFileMutationVariables
>;
export const CreateOrganizationUserDocument = gql`
	mutation CreateOrganizationUser($input: OrganizationUserCreateInput!) {
		createOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type CreateOrganizationUserMutationFn = Apollo.MutationFunction<
	CreateOrganizationUserMutation,
	CreateOrganizationUserMutationVariables
>;

/**
 * __useCreateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationUserMutation, { data, loading, error }] = useCreateOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationUserMutation,
		CreateOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationUserMutation,
		CreateOrganizationUserMutationVariables
	>(CreateOrganizationUserDocument, options);
}
export type CreateOrganizationUserMutationHookResult = ReturnType<
	typeof useCreateOrganizationUserMutation
>;
export type CreateOrganizationUserMutationResult =
	Apollo.MutationResult<CreateOrganizationUserMutation>;
export type CreateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationUserMutation,
	CreateOrganizationUserMutationVariables
>;
export const DeleteOrganizationUserDocument = gql`
	mutation DeleteOrganizationUser($input: DeleteInput!) {
		deleteOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrganizationUserMutationFn = Apollo.MutationFunction<
	DeleteOrganizationUserMutation,
	DeleteOrganizationUserMutationVariables
>;

/**
 * __useDeleteOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationUserMutation, { data, loading, error }] = useDeleteOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationUserMutation,
		DeleteOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationUserMutation,
		DeleteOrganizationUserMutationVariables
	>(DeleteOrganizationUserDocument, options);
}
export type DeleteOrganizationUserMutationHookResult = ReturnType<
	typeof useDeleteOrganizationUserMutation
>;
export type DeleteOrganizationUserMutationResult =
	Apollo.MutationResult<DeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationUserMutation,
	DeleteOrganizationUserMutationVariables
>;
export const DeleteManyOrganizationUserDocument = gql`
	mutation DeleteManyOrganizationUser($input: DeleteManyInput!) {
		deleteManyOrganizationUser(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyOrganizationUserMutationFn = Apollo.MutationFunction<
	DeleteManyOrganizationUserMutation,
	DeleteManyOrganizationUserMutationVariables
>;

/**
 * __useDeleteManyOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteManyOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyOrganizationUserMutation, { data, loading, error }] = useDeleteManyOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyOrganizationUserMutation,
		DeleteManyOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyOrganizationUserMutation,
		DeleteManyOrganizationUserMutationVariables
	>(DeleteManyOrganizationUserDocument, options);
}
export type DeleteManyOrganizationUserMutationHookResult = ReturnType<
	typeof useDeleteManyOrganizationUserMutation
>;
export type DeleteManyOrganizationUserMutationResult =
	Apollo.MutationResult<DeleteManyOrganizationUserMutation>;
export type DeleteManyOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyOrganizationUserMutation,
	DeleteManyOrganizationUserMutationVariables
>;
export const UpdateOrganizationSettingDocument = gql`
	mutation UpdateOrganizationSetting($input: OrganizationSettingUpdateInput!) {
		updateOrganizationSetting(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationSettingMutationFn = Apollo.MutationFunction<
	UpdateOrganizationSettingMutation,
	UpdateOrganizationSettingMutationVariables
>;

/**
 * __useUpdateOrganizationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingMutation, { data, loading, error }] = useUpdateOrganizationSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSettingMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationSettingMutation,
		UpdateOrganizationSettingMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationSettingMutation,
		UpdateOrganizationSettingMutationVariables
	>(UpdateOrganizationSettingDocument, options);
}
export type UpdateOrganizationSettingMutationHookResult = ReturnType<
	typeof useUpdateOrganizationSettingMutation
>;
export type UpdateOrganizationSettingMutationResult =
	Apollo.MutationResult<UpdateOrganizationSettingMutation>;
export type UpdateOrganizationSettingMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationSettingMutation,
	UpdateOrganizationSettingMutationVariables
>;
export const UpdateOrganizationDocument = gql`
	mutation UpdateOrganization($input: OrganizationUpdateInput!) {
		updateOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<
	UpdateOrganizationMutation,
	UpdateOrganizationMutationVariables
>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationMutation,
		UpdateOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(
		UpdateOrganizationDocument,
		options
	);
}
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationMutation,
	UpdateOrganizationMutationVariables
>;
export const DeleteMyOrganizationDocument = gql`
	mutation DeleteMyOrganization {
		deleteMyOrganization {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteMyOrganizationMutationFn = Apollo.MutationFunction<
	DeleteMyOrganizationMutation,
	DeleteMyOrganizationMutationVariables
>;

/**
 * __useDeleteMyOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteMyOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyOrganizationMutation, { data, loading, error }] = useDeleteMyOrganizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMyOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteMyOrganizationMutation,
		DeleteMyOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteMyOrganizationMutation, DeleteMyOrganizationMutationVariables>(
		DeleteMyOrganizationDocument,
		options
	);
}
export type DeleteMyOrganizationMutationHookResult = ReturnType<
	typeof useDeleteMyOrganizationMutation
>;
export type DeleteMyOrganizationMutationResult =
	Apollo.MutationResult<DeleteMyOrganizationMutation>;
export type DeleteMyOrganizationMutationOptions = Apollo.BaseMutationOptions<
	DeleteMyOrganizationMutation,
	DeleteMyOrganizationMutationVariables
>;
export const DeleteOrganizationDocument = gql`
	mutation DeleteOrganization($input: DeleteInput!) {
		deleteOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<
	DeleteOrganizationMutation,
	DeleteOrganizationMutationVariables
>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationMutation,
		DeleteOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(
		DeleteOrganizationDocument,
		options
	);
}
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationMutation,
	DeleteOrganizationMutationVariables
>;
export const DeleteManyOrganizationDocument = gql`
	mutation DeleteManyOrganization($input: DeleteManyInput!) {
		deleteManyOrganization(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type DeleteManyOrganizationMutationFn = Apollo.MutationFunction<
	DeleteManyOrganizationMutation,
	DeleteManyOrganizationMutationVariables
>;

/**
 * __useDeleteManyOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteManyOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyOrganizationMutation, { data, loading, error }] = useDeleteManyOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyOrganizationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyOrganizationMutation,
		DeleteManyOrganizationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyOrganizationMutation,
		DeleteManyOrganizationMutationVariables
	>(DeleteManyOrganizationDocument, options);
}
export type DeleteManyOrganizationMutationHookResult = ReturnType<
	typeof useDeleteManyOrganizationMutation
>;
export type DeleteManyOrganizationMutationResult =
	Apollo.MutationResult<DeleteManyOrganizationMutation>;
export type DeleteManyOrganizationMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyOrganizationMutation,
	DeleteManyOrganizationMutationVariables
>;
export const UpdateOrganizationApprovalAndMarginDocument = gql`
	mutation UpdateOrganizationApprovalAndMargin(
		$input: UpdateOrganizationApprovalAndMarginInput!
	) {
		updateOrganizationApprovalAndMargin(input: $input) {
			...MessageResponseFragment
		}
	}
	${MessageResponseFragmentFragmentDoc}
`;
export type UpdateOrganizationApprovalAndMarginMutationFn = Apollo.MutationFunction<
	UpdateOrganizationApprovalAndMarginMutation,
	UpdateOrganizationApprovalAndMarginMutationVariables
>;

/**
 * __useUpdateOrganizationApprovalAndMarginMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationApprovalAndMarginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationApprovalAndMarginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationApprovalAndMarginMutation, { data, loading, error }] = useUpdateOrganizationApprovalAndMarginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationApprovalAndMarginMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationApprovalAndMarginMutation,
		UpdateOrganizationApprovalAndMarginMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationApprovalAndMarginMutation,
		UpdateOrganizationApprovalAndMarginMutationVariables
	>(UpdateOrganizationApprovalAndMarginDocument, options);
}
export type UpdateOrganizationApprovalAndMarginMutationHookResult = ReturnType<
	typeof useUpdateOrganizationApprovalAndMarginMutation
>;
export type UpdateOrganizationApprovalAndMarginMutationResult =
	Apollo.MutationResult<UpdateOrganizationApprovalAndMarginMutation>;
export type UpdateOrganizationApprovalAndMarginMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationApprovalAndMarginMutation,
	UpdateOrganizationApprovalAndMarginMutationVariables
>;
export const CreateOrganizationAddressDocument = gql`
	mutation CreateOrganizationAddress($organizationId: ID!, $input: OrganizationAddressInput!) {
		createOrganizationAddress(organizationId: $organizationId, input: $input) {
			id
			addressLine1
			addressLine2
			addressType
			city
			countryCode
			postalCode
			stateCode
			isPrimary
			name
			googlePlaceId
			latitude
			longitude
		}
	}
`;
export type CreateOrganizationAddressMutationFn = Apollo.MutationFunction<
	CreateOrganizationAddressMutation,
	CreateOrganizationAddressMutationVariables
>;

/**
 * __useCreateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationAddressMutation, { data, loading, error }] = useCreateOrganizationAddressMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationAddressMutation,
		CreateOrganizationAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationAddressMutation,
		CreateOrganizationAddressMutationVariables
	>(CreateOrganizationAddressDocument, options);
}
export type CreateOrganizationAddressMutationHookResult = ReturnType<
	typeof useCreateOrganizationAddressMutation
>;
export type CreateOrganizationAddressMutationResult =
	Apollo.MutationResult<CreateOrganizationAddressMutation>;
export type CreateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationAddressMutation,
	CreateOrganizationAddressMutationVariables
>;
export const UpdateOrganizationAddressDocument = gql`
	mutation UpdateOrganizationAddress($id: ID!, $input: OrganizationAddressInput!) {
		updateOrganizationAddress(id: $id, input: $input) {
			id
			addressLine1
			addressLine2
			addressType
			city
			countryCode
			postalCode
			stateCode
			isPrimary
			name
			googlePlaceId
			latitude
			longitude
		}
	}
`;
export type UpdateOrganizationAddressMutationFn = Apollo.MutationFunction<
	UpdateOrganizationAddressMutation,
	UpdateOrganizationAddressMutationVariables
>;

/**
 * __useUpdateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAddressMutation, { data, loading, error }] = useUpdateOrganizationAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationAddressMutation,
		UpdateOrganizationAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationAddressMutation,
		UpdateOrganizationAddressMutationVariables
	>(UpdateOrganizationAddressDocument, options);
}
export type UpdateOrganizationAddressMutationHookResult = ReturnType<
	typeof useUpdateOrganizationAddressMutation
>;
export type UpdateOrganizationAddressMutationResult =
	Apollo.MutationResult<UpdateOrganizationAddressMutation>;
export type UpdateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationAddressMutation,
	UpdateOrganizationAddressMutationVariables
>;
export const DeleteOrganizationAddressDocument = gql`
	mutation DeleteOrganizationAddress($id: ID!) {
		deleteOrganizationAddress(id: $id) {
			success
			message
		}
	}
`;
export type DeleteOrganizationAddressMutationFn = Apollo.MutationFunction<
	DeleteOrganizationAddressMutation,
	DeleteOrganizationAddressMutationVariables
>;

/**
 * __useDeleteOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationAddressMutation, { data, loading, error }] = useDeleteOrganizationAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationAddressMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationAddressMutation,
		DeleteOrganizationAddressMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationAddressMutation,
		DeleteOrganizationAddressMutationVariables
	>(DeleteOrganizationAddressDocument, options);
}
export type DeleteOrganizationAddressMutationHookResult = ReturnType<
	typeof useDeleteOrganizationAddressMutation
>;
export type DeleteOrganizationAddressMutationResult =
	Apollo.MutationResult<DeleteOrganizationAddressMutation>;
export type DeleteOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationAddressMutation,
	DeleteOrganizationAddressMutationVariables
>;
export const CreateOrganizationOnboardingDocument = gql`
	mutation CreateOrganizationOnboarding($input: OrganizationOnboardingInput!) {
		createOrganizationOnboarding(input: $input) {
			success
			message
			organizationId
		}
	}
`;
export type CreateOrganizationOnboardingMutationFn = Apollo.MutationFunction<
	CreateOrganizationOnboardingMutation,
	CreateOrganizationOnboardingMutationVariables
>;

/**
 * __useCreateOrganizationOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationOnboardingMutation, { data, loading, error }] = useCreateOrganizationOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationOnboardingMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationOnboardingMutation,
		CreateOrganizationOnboardingMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationOnboardingMutation,
		CreateOrganizationOnboardingMutationVariables
	>(CreateOrganizationOnboardingDocument, options);
}
export type CreateOrganizationOnboardingMutationHookResult = ReturnType<
	typeof useCreateOrganizationOnboardingMutation
>;
export type CreateOrganizationOnboardingMutationResult =
	Apollo.MutationResult<CreateOrganizationOnboardingMutation>;
export type CreateOrganizationOnboardingMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationOnboardingMutation,
	CreateOrganizationOnboardingMutationVariables
>;
export const GenerateOrganizationUserAvatarUploadUrlDocument = gql`
	mutation GenerateOrganizationUserAvatarUploadUrl($input: GenerateUploadUrlInput!) {
		generateOrganizationUserAvatarUploadUrl(input: $input) {
			success
			message
			uploadUrl
			expiresAt
			errors {
				message
				field
				code
			}
		}
	}
`;
export type GenerateOrganizationUserAvatarUploadUrlMutationFn = Apollo.MutationFunction<
	GenerateOrganizationUserAvatarUploadUrlMutation,
	GenerateOrganizationUserAvatarUploadUrlMutationVariables
>;

/**
 * __useGenerateOrganizationUserAvatarUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateOrganizationUserAvatarUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrganizationUserAvatarUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrganizationUserAvatarUploadUrlMutation, { data, loading, error }] = useGenerateOrganizationUserAvatarUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOrganizationUserAvatarUploadUrlMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GenerateOrganizationUserAvatarUploadUrlMutation,
		GenerateOrganizationUserAvatarUploadUrlMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		GenerateOrganizationUserAvatarUploadUrlMutation,
		GenerateOrganizationUserAvatarUploadUrlMutationVariables
	>(GenerateOrganizationUserAvatarUploadUrlDocument, options);
}
export type GenerateOrganizationUserAvatarUploadUrlMutationHookResult = ReturnType<
	typeof useGenerateOrganizationUserAvatarUploadUrlMutation
>;
export type GenerateOrganizationUserAvatarUploadUrlMutationResult =
	Apollo.MutationResult<GenerateOrganizationUserAvatarUploadUrlMutation>;
export type GenerateOrganizationUserAvatarUploadUrlMutationOptions = Apollo.BaseMutationOptions<
	GenerateOrganizationUserAvatarUploadUrlMutation,
	GenerateOrganizationUserAvatarUploadUrlMutationVariables
>;
export const UpdateOrganizationUserAvatarDocument = gql`
	mutation UpdateOrganizationUserAvatar($input: OrganizationUserUpdateInput!) {
		updateOrganizationUser(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type UpdateOrganizationUserAvatarMutationFn = Apollo.MutationFunction<
	UpdateOrganizationUserAvatarMutation,
	UpdateOrganizationUserAvatarMutationVariables
>;

/**
 * __useUpdateOrganizationUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserAvatarMutation, { data, loading, error }] = useUpdateOrganizationUserAvatarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationUserAvatarMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationUserAvatarMutation,
		UpdateOrganizationUserAvatarMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationUserAvatarMutation,
		UpdateOrganizationUserAvatarMutationVariables
	>(UpdateOrganizationUserAvatarDocument, options);
}
export type UpdateOrganizationUserAvatarMutationHookResult = ReturnType<
	typeof useUpdateOrganizationUserAvatarMutation
>;
export type UpdateOrganizationUserAvatarMutationResult =
	Apollo.MutationResult<UpdateOrganizationUserAvatarMutation>;
export type UpdateOrganizationUserAvatarMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationUserAvatarMutation,
	UpdateOrganizationUserAvatarMutationVariables
>;
export const CreateOrganizationDepartmentDocument = gql`
	mutation CreateOrganizationDepartment($input: OrganizationDepartmentCreateInput!) {
		createOrganizationDepartment(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type CreateOrganizationDepartmentMutationFn = Apollo.MutationFunction<
	CreateOrganizationDepartmentMutation,
	CreateOrganizationDepartmentMutationVariables
>;

/**
 * __useCreateOrganizationDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationDepartmentMutation, { data, loading, error }] = useCreateOrganizationDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationDepartmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationDepartmentMutation,
		CreateOrganizationDepartmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationDepartmentMutation,
		CreateOrganizationDepartmentMutationVariables
	>(CreateOrganizationDepartmentDocument, options);
}
export type CreateOrganizationDepartmentMutationHookResult = ReturnType<
	typeof useCreateOrganizationDepartmentMutation
>;
export type CreateOrganizationDepartmentMutationResult =
	Apollo.MutationResult<CreateOrganizationDepartmentMutation>;
export type CreateOrganizationDepartmentMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationDepartmentMutation,
	CreateOrganizationDepartmentMutationVariables
>;
export const UpdateOrganizationDepartmentDocument = gql`
	mutation UpdateOrganizationDepartment($input: OrganizationDepartmentUpdateInput!) {
		updateOrganizationDepartment(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type UpdateOrganizationDepartmentMutationFn = Apollo.MutationFunction<
	UpdateOrganizationDepartmentMutation,
	UpdateOrganizationDepartmentMutationVariables
>;

/**
 * __useUpdateOrganizationDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationDepartmentMutation, { data, loading, error }] = useUpdateOrganizationDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationDepartmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationDepartmentMutation,
		UpdateOrganizationDepartmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationDepartmentMutation,
		UpdateOrganizationDepartmentMutationVariables
	>(UpdateOrganizationDepartmentDocument, options);
}
export type UpdateOrganizationDepartmentMutationHookResult = ReturnType<
	typeof useUpdateOrganizationDepartmentMutation
>;
export type UpdateOrganizationDepartmentMutationResult =
	Apollo.MutationResult<UpdateOrganizationDepartmentMutation>;
export type UpdateOrganizationDepartmentMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationDepartmentMutation,
	UpdateOrganizationDepartmentMutationVariables
>;
export const DeleteOrganizationDepartmentDocument = gql`
	mutation DeleteOrganizationDepartment($id: ID!) {
		deleteOrganizationDepartment(id: $id) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type DeleteOrganizationDepartmentMutationFn = Apollo.MutationFunction<
	DeleteOrganizationDepartmentMutation,
	DeleteOrganizationDepartmentMutationVariables
>;

/**
 * __useDeleteOrganizationDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationDepartmentMutation, { data, loading, error }] = useDeleteOrganizationDepartmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationDepartmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationDepartmentMutation,
		DeleteOrganizationDepartmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationDepartmentMutation,
		DeleteOrganizationDepartmentMutationVariables
	>(DeleteOrganizationDepartmentDocument, options);
}
export type DeleteOrganizationDepartmentMutationHookResult = ReturnType<
	typeof useDeleteOrganizationDepartmentMutation
>;
export type DeleteOrganizationDepartmentMutationResult =
	Apollo.MutationResult<DeleteOrganizationDepartmentMutation>;
export type DeleteOrganizationDepartmentMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationDepartmentMutation,
	DeleteOrganizationDepartmentMutationVariables
>;
export const DeleteManyOrganizationDepartmentsDocument = gql`
	mutation DeleteManyOrganizationDepartments($ids: [ID!]!) {
		deleteManyOrganizationDepartment(ids: $ids) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type DeleteManyOrganizationDepartmentsMutationFn = Apollo.MutationFunction<
	DeleteManyOrganizationDepartmentsMutation,
	DeleteManyOrganizationDepartmentsMutationVariables
>;

/**
 * __useDeleteManyOrganizationDepartmentsMutation__
 *
 * To run a mutation, you first call `useDeleteManyOrganizationDepartmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyOrganizationDepartmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyOrganizationDepartmentsMutation, { data, loading, error }] = useDeleteManyOrganizationDepartmentsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteManyOrganizationDepartmentsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyOrganizationDepartmentsMutation,
		DeleteManyOrganizationDepartmentsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyOrganizationDepartmentsMutation,
		DeleteManyOrganizationDepartmentsMutationVariables
	>(DeleteManyOrganizationDepartmentsDocument, options);
}
export type DeleteManyOrganizationDepartmentsMutationHookResult = ReturnType<
	typeof useDeleteManyOrganizationDepartmentsMutation
>;
export type DeleteManyOrganizationDepartmentsMutationResult =
	Apollo.MutationResult<DeleteManyOrganizationDepartmentsMutation>;
export type DeleteManyOrganizationDepartmentsMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyOrganizationDepartmentsMutation,
	DeleteManyOrganizationDepartmentsMutationVariables
>;
export const AddUserToDepartmentDocument = gql`
	mutation AddUserToDepartment($input: AddUserToDepartmentInput!) {
		addUserToDepartment(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type AddUserToDepartmentMutationFn = Apollo.MutationFunction<
	AddUserToDepartmentMutation,
	AddUserToDepartmentMutationVariables
>;

/**
 * __useAddUserToDepartmentMutation__
 *
 * To run a mutation, you first call `useAddUserToDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToDepartmentMutation, { data, loading, error }] = useAddUserToDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToDepartmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddUserToDepartmentMutation,
		AddUserToDepartmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AddUserToDepartmentMutation, AddUserToDepartmentMutationVariables>(
		AddUserToDepartmentDocument,
		options
	);
}
export type AddUserToDepartmentMutationHookResult = ReturnType<
	typeof useAddUserToDepartmentMutation
>;
export type AddUserToDepartmentMutationResult = Apollo.MutationResult<AddUserToDepartmentMutation>;
export type AddUserToDepartmentMutationOptions = Apollo.BaseMutationOptions<
	AddUserToDepartmentMutation,
	AddUserToDepartmentMutationVariables
>;
export const RemoveUserFromDepartmentDocument = gql`
	mutation RemoveUserFromDepartment($departmentId: ID!, $organizationUserId: ID!) {
		removeUserFromDepartment(
			departmentId: $departmentId
			organizationUserId: $organizationUserId
		) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type RemoveUserFromDepartmentMutationFn = Apollo.MutationFunction<
	RemoveUserFromDepartmentMutation,
	RemoveUserFromDepartmentMutationVariables
>;

/**
 * __useRemoveUserFromDepartmentMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromDepartmentMutation, { data, loading, error }] = useRemoveUserFromDepartmentMutation({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *      organizationUserId: // value for 'organizationUserId'
 *   },
 * });
 */
export function useRemoveUserFromDepartmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveUserFromDepartmentMutation,
		RemoveUserFromDepartmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RemoveUserFromDepartmentMutation,
		RemoveUserFromDepartmentMutationVariables
	>(RemoveUserFromDepartmentDocument, options);
}
export type RemoveUserFromDepartmentMutationHookResult = ReturnType<
	typeof useRemoveUserFromDepartmentMutation
>;
export type RemoveUserFromDepartmentMutationResult =
	Apollo.MutationResult<RemoveUserFromDepartmentMutation>;
export type RemoveUserFromDepartmentMutationOptions = Apollo.BaseMutationOptions<
	RemoveUserFromDepartmentMutation,
	RemoveUserFromDepartmentMutationVariables
>;
export const BulkAddUsersToDepartmentDocument = gql`
	mutation BulkAddUsersToDepartment($input: BulkAddUsersToDepartmentInput!) {
		bulkAddUsersToDepartment(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type BulkAddUsersToDepartmentMutationFn = Apollo.MutationFunction<
	BulkAddUsersToDepartmentMutation,
	BulkAddUsersToDepartmentMutationVariables
>;

/**
 * __useBulkAddUsersToDepartmentMutation__
 *
 * To run a mutation, you first call `useBulkAddUsersToDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddUsersToDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddUsersToDepartmentMutation, { data, loading, error }] = useBulkAddUsersToDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkAddUsersToDepartmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		BulkAddUsersToDepartmentMutation,
		BulkAddUsersToDepartmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		BulkAddUsersToDepartmentMutation,
		BulkAddUsersToDepartmentMutationVariables
	>(BulkAddUsersToDepartmentDocument, options);
}
export type BulkAddUsersToDepartmentMutationHookResult = ReturnType<
	typeof useBulkAddUsersToDepartmentMutation
>;
export type BulkAddUsersToDepartmentMutationResult =
	Apollo.MutationResult<BulkAddUsersToDepartmentMutation>;
export type BulkAddUsersToDepartmentMutationOptions = Apollo.BaseMutationOptions<
	BulkAddUsersToDepartmentMutation,
	BulkAddUsersToDepartmentMutationVariables
>;
export const UpdateDepartmentUserRoleDocument = gql`
	mutation UpdateDepartmentUserRole($input: UpdateDepartmentUserRoleInput!) {
		updateDepartmentUserRole(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type UpdateDepartmentUserRoleMutationFn = Apollo.MutationFunction<
	UpdateDepartmentUserRoleMutation,
	UpdateDepartmentUserRoleMutationVariables
>;

/**
 * __useUpdateDepartmentUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentUserRoleMutation, { data, loading, error }] = useUpdateDepartmentUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDepartmentUserRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateDepartmentUserRoleMutation,
		UpdateDepartmentUserRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateDepartmentUserRoleMutation,
		UpdateDepartmentUserRoleMutationVariables
	>(UpdateDepartmentUserRoleDocument, options);
}
export type UpdateDepartmentUserRoleMutationHookResult = ReturnType<
	typeof useUpdateDepartmentUserRoleMutation
>;
export type UpdateDepartmentUserRoleMutationResult =
	Apollo.MutationResult<UpdateDepartmentUserRoleMutation>;
export type UpdateDepartmentUserRoleMutationOptions = Apollo.BaseMutationOptions<
	UpdateDepartmentUserRoleMutation,
	UpdateDepartmentUserRoleMutationVariables
>;
export const CreateOrganizationTeamDocument = gql`
	mutation CreateOrganizationTeam($input: OrganizationTeamCreateInput!) {
		createOrganizationTeam(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type CreateOrganizationTeamMutationFn = Apollo.MutationFunction<
	CreateOrganizationTeamMutation,
	CreateOrganizationTeamMutationVariables
>;

/**
 * __useCreateOrganizationTeamMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationTeamMutation, { data, loading, error }] = useCreateOrganizationTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationTeamMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrganizationTeamMutation,
		CreateOrganizationTeamMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrganizationTeamMutation,
		CreateOrganizationTeamMutationVariables
	>(CreateOrganizationTeamDocument, options);
}
export type CreateOrganizationTeamMutationHookResult = ReturnType<
	typeof useCreateOrganizationTeamMutation
>;
export type CreateOrganizationTeamMutationResult =
	Apollo.MutationResult<CreateOrganizationTeamMutation>;
export type CreateOrganizationTeamMutationOptions = Apollo.BaseMutationOptions<
	CreateOrganizationTeamMutation,
	CreateOrganizationTeamMutationVariables
>;
export const UpdateOrganizationTeamDocument = gql`
	mutation UpdateOrganizationTeam($input: OrganizationTeamUpdateInput!) {
		updateOrganizationTeam(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type UpdateOrganizationTeamMutationFn = Apollo.MutationFunction<
	UpdateOrganizationTeamMutation,
	UpdateOrganizationTeamMutationVariables
>;

/**
 * __useUpdateOrganizationTeamMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationTeamMutation, { data, loading, error }] = useUpdateOrganizationTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationTeamMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationTeamMutation,
		UpdateOrganizationTeamMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationTeamMutation,
		UpdateOrganizationTeamMutationVariables
	>(UpdateOrganizationTeamDocument, options);
}
export type UpdateOrganizationTeamMutationHookResult = ReturnType<
	typeof useUpdateOrganizationTeamMutation
>;
export type UpdateOrganizationTeamMutationResult =
	Apollo.MutationResult<UpdateOrganizationTeamMutation>;
export type UpdateOrganizationTeamMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationTeamMutation,
	UpdateOrganizationTeamMutationVariables
>;
export const DeleteOrganizationTeamDocument = gql`
	mutation DeleteOrganizationTeam($id: ID!) {
		deleteOrganizationTeam(id: $id) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type DeleteOrganizationTeamMutationFn = Apollo.MutationFunction<
	DeleteOrganizationTeamMutation,
	DeleteOrganizationTeamMutationVariables
>;

/**
 * __useDeleteOrganizationTeamMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationTeamMutation, { data, loading, error }] = useDeleteOrganizationTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationTeamMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteOrganizationTeamMutation,
		DeleteOrganizationTeamMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteOrganizationTeamMutation,
		DeleteOrganizationTeamMutationVariables
	>(DeleteOrganizationTeamDocument, options);
}
export type DeleteOrganizationTeamMutationHookResult = ReturnType<
	typeof useDeleteOrganizationTeamMutation
>;
export type DeleteOrganizationTeamMutationResult =
	Apollo.MutationResult<DeleteOrganizationTeamMutation>;
export type DeleteOrganizationTeamMutationOptions = Apollo.BaseMutationOptions<
	DeleteOrganizationTeamMutation,
	DeleteOrganizationTeamMutationVariables
>;
export const DeleteManyOrganizationTeamsDocument = gql`
	mutation DeleteManyOrganizationTeams($ids: [ID!]!) {
		deleteManyOrganizationTeam(ids: $ids) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type DeleteManyOrganizationTeamsMutationFn = Apollo.MutationFunction<
	DeleteManyOrganizationTeamsMutation,
	DeleteManyOrganizationTeamsMutationVariables
>;

/**
 * __useDeleteManyOrganizationTeamsMutation__
 *
 * To run a mutation, you first call `useDeleteManyOrganizationTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyOrganizationTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyOrganizationTeamsMutation, { data, loading, error }] = useDeleteManyOrganizationTeamsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteManyOrganizationTeamsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyOrganizationTeamsMutation,
		DeleteManyOrganizationTeamsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteManyOrganizationTeamsMutation,
		DeleteManyOrganizationTeamsMutationVariables
	>(DeleteManyOrganizationTeamsDocument, options);
}
export type DeleteManyOrganizationTeamsMutationHookResult = ReturnType<
	typeof useDeleteManyOrganizationTeamsMutation
>;
export type DeleteManyOrganizationTeamsMutationResult =
	Apollo.MutationResult<DeleteManyOrganizationTeamsMutation>;
export type DeleteManyOrganizationTeamsMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyOrganizationTeamsMutation,
	DeleteManyOrganizationTeamsMutationVariables
>;
export const AddUserToTeamDocument = gql`
	mutation AddUserToTeam($input: AddUserToTeamInput!) {
		addUserToTeam(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type AddUserToTeamMutationFn = Apollo.MutationFunction<
	AddUserToTeamMutation,
	AddUserToTeamMutationVariables
>;

/**
 * __useAddUserToTeamMutation__
 *
 * To run a mutation, you first call `useAddUserToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToTeamMutation, { data, loading, error }] = useAddUserToTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToTeamMutation(
	baseOptions?: Apollo.MutationHookOptions<AddUserToTeamMutation, AddUserToTeamMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AddUserToTeamMutation, AddUserToTeamMutationVariables>(
		AddUserToTeamDocument,
		options
	);
}
export type AddUserToTeamMutationHookResult = ReturnType<typeof useAddUserToTeamMutation>;
export type AddUserToTeamMutationResult = Apollo.MutationResult<AddUserToTeamMutation>;
export type AddUserToTeamMutationOptions = Apollo.BaseMutationOptions<
	AddUserToTeamMutation,
	AddUserToTeamMutationVariables
>;
export const RemoveUserFromTeamDocument = gql`
	mutation RemoveUserFromTeam($organizationUserId: ID!, $teamId: ID!) {
		removeUserFromTeam(organizationUserId: $organizationUserId, teamId: $teamId) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type RemoveUserFromTeamMutationFn = Apollo.MutationFunction<
	RemoveUserFromTeamMutation,
	RemoveUserFromTeamMutationVariables
>;

/**
 * __useRemoveUserFromTeamMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromTeamMutation, { data, loading, error }] = useRemoveUserFromTeamMutation({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useRemoveUserFromTeamMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveUserFromTeamMutation,
		RemoveUserFromTeamMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>(
		RemoveUserFromTeamDocument,
		options
	);
}
export type RemoveUserFromTeamMutationHookResult = ReturnType<typeof useRemoveUserFromTeamMutation>;
export type RemoveUserFromTeamMutationResult = Apollo.MutationResult<RemoveUserFromTeamMutation>;
export type RemoveUserFromTeamMutationOptions = Apollo.BaseMutationOptions<
	RemoveUserFromTeamMutation,
	RemoveUserFromTeamMutationVariables
>;
export const BulkAddUsersToTeamDocument = gql`
	mutation BulkAddUsersToTeam($input: BulkAddUsersToTeamInput!) {
		bulkAddUsersToTeam(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type BulkAddUsersToTeamMutationFn = Apollo.MutationFunction<
	BulkAddUsersToTeamMutation,
	BulkAddUsersToTeamMutationVariables
>;

/**
 * __useBulkAddUsersToTeamMutation__
 *
 * To run a mutation, you first call `useBulkAddUsersToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddUsersToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddUsersToTeamMutation, { data, loading, error }] = useBulkAddUsersToTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkAddUsersToTeamMutation(
	baseOptions?: Apollo.MutationHookOptions<
		BulkAddUsersToTeamMutation,
		BulkAddUsersToTeamMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BulkAddUsersToTeamMutation, BulkAddUsersToTeamMutationVariables>(
		BulkAddUsersToTeamDocument,
		options
	);
}
export type BulkAddUsersToTeamMutationHookResult = ReturnType<typeof useBulkAddUsersToTeamMutation>;
export type BulkAddUsersToTeamMutationResult = Apollo.MutationResult<BulkAddUsersToTeamMutation>;
export type BulkAddUsersToTeamMutationOptions = Apollo.BaseMutationOptions<
	BulkAddUsersToTeamMutation,
	BulkAddUsersToTeamMutationVariables
>;
export const UpdateTeamUserRoleDocument = gql`
	mutation UpdateTeamUserRole($input: UpdateTeamUserRoleInput!) {
		updateTeamUserRole(input: $input) {
			success
			message
			messageKey
			errors {
				message
				field
				code
			}
		}
	}
`;
export type UpdateTeamUserRoleMutationFn = Apollo.MutationFunction<
	UpdateTeamUserRoleMutation,
	UpdateTeamUserRoleMutationVariables
>;

/**
 * __useUpdateTeamUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateTeamUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamUserRoleMutation, { data, loading, error }] = useUpdateTeamUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamUserRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateTeamUserRoleMutation,
		UpdateTeamUserRoleMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateTeamUserRoleMutation, UpdateTeamUserRoleMutationVariables>(
		UpdateTeamUserRoleDocument,
		options
	);
}
export type UpdateTeamUserRoleMutationHookResult = ReturnType<typeof useUpdateTeamUserRoleMutation>;
export type UpdateTeamUserRoleMutationResult = Apollo.MutationResult<UpdateTeamUserRoleMutation>;
export type UpdateTeamUserRoleMutationOptions = Apollo.BaseMutationOptions<
	UpdateTeamUserRoleMutation,
	UpdateTeamUserRoleMutationVariables
>;
export const UpdateSystemSettingsDocument = gql`
	mutation UpdateSystemSettings($input: UpdateSystemSettingInput!) {
		updateSystemSettings(input: $input) {
			message
			success
		}
	}
`;
export type UpdateSystemSettingsMutationFn = Apollo.MutationFunction<
	UpdateSystemSettingsMutation,
	UpdateSystemSettingsMutationVariables
>;

/**
 * __useUpdateSystemSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSystemSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemSettingsMutation, { data, loading, error }] = useUpdateSystemSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSystemSettingsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateSystemSettingsMutation,
		UpdateSystemSettingsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>(
		UpdateSystemSettingsDocument,
		options
	);
}
export type UpdateSystemSettingsMutationHookResult = ReturnType<
	typeof useUpdateSystemSettingsMutation
>;
export type UpdateSystemSettingsMutationResult =
	Apollo.MutationResult<UpdateSystemSettingsMutation>;
export type UpdateSystemSettingsMutationOptions = Apollo.BaseMutationOptions<
	UpdateSystemSettingsMutation,
	UpdateSystemSettingsMutationVariables
>;
export const UpdateTranslationDocument = gql`
	mutation UpdateTranslation($input: UpdateTranslationInput!) {
		updateTranslation(input: $input) {
			key
			language
			content
			params
		}
	}
`;
export type UpdateTranslationMutationFn = Apollo.MutationFunction<
	UpdateTranslationMutation,
	UpdateTranslationMutationVariables
>;

/**
 * __useUpdateTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationMutation, { data, loading, error }] = useUpdateTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTranslationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateTranslationMutation,
		UpdateTranslationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateTranslationMutation, UpdateTranslationMutationVariables>(
		UpdateTranslationDocument,
		options
	);
}
export type UpdateTranslationMutationHookResult = ReturnType<typeof useUpdateTranslationMutation>;
export type UpdateTranslationMutationResult = Apollo.MutationResult<UpdateTranslationMutation>;
export type UpdateTranslationMutationOptions = Apollo.BaseMutationOptions<
	UpdateTranslationMutation,
	UpdateTranslationMutationVariables
>;
export const DeleteUserDocument = gql`
	mutation DeleteUser($id: ID!) {
		deleteUser(id: $id) {
			success
			message
		}
	}
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
	DeleteUserMutation,
	DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(
	baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
		DeleteUserDocument,
		options
	);
}
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteUserMutation,
	DeleteUserMutationVariables
>;
export const DeleteManyUserDocument = gql`
	mutation DeleteManyUser($input: DeleteManyInput!) {
		deleteManyUser(input: $input) {
			success
			message
		}
	}
`;
export type DeleteManyUserMutationFn = Apollo.MutationFunction<
	DeleteManyUserMutation,
	DeleteManyUserMutationVariables
>;

/**
 * __useDeleteManyUserMutation__
 *
 * To run a mutation, you first call `useDeleteManyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyUserMutation, { data, loading, error }] = useDeleteManyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteManyUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteManyUserMutation,
		DeleteManyUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteManyUserMutation, DeleteManyUserMutationVariables>(
		DeleteManyUserDocument,
		options
	);
}
export type DeleteManyUserMutationHookResult = ReturnType<typeof useDeleteManyUserMutation>;
export type DeleteManyUserMutationResult = Apollo.MutationResult<DeleteManyUserMutation>;
export type DeleteManyUserMutationOptions = Apollo.BaseMutationOptions<
	DeleteManyUserMutation,
	DeleteManyUserMutationVariables
>;
export const UpdateWellBeingSurveyQuestionTranslationsDocument = gql`
	mutation UpdateWellBeingSurveyQuestionTranslations(
		$input: UpdateWellBeingSurveyTranslationsInput!
	) {
		updateWellBeingSurveyQuestionTranslations(input: $input)
	}
`;
export type UpdateWellBeingSurveyQuestionTranslationsMutationFn = Apollo.MutationFunction<
	UpdateWellBeingSurveyQuestionTranslationsMutation,
	UpdateWellBeingSurveyQuestionTranslationsMutationVariables
>;

/**
 * __useUpdateWellBeingSurveyQuestionTranslationsMutation__
 *
 * To run a mutation, you first call `useUpdateWellBeingSurveyQuestionTranslationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWellBeingSurveyQuestionTranslationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWellBeingSurveyQuestionTranslationsMutation, { data, loading, error }] = useUpdateWellBeingSurveyQuestionTranslationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWellBeingSurveyQuestionTranslationsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateWellBeingSurveyQuestionTranslationsMutation,
		UpdateWellBeingSurveyQuestionTranslationsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateWellBeingSurveyQuestionTranslationsMutation,
		UpdateWellBeingSurveyQuestionTranslationsMutationVariables
	>(UpdateWellBeingSurveyQuestionTranslationsDocument, options);
}
export type UpdateWellBeingSurveyQuestionTranslationsMutationHookResult = ReturnType<
	typeof useUpdateWellBeingSurveyQuestionTranslationsMutation
>;
export type UpdateWellBeingSurveyQuestionTranslationsMutationResult =
	Apollo.MutationResult<UpdateWellBeingSurveyQuestionTranslationsMutation>;
export type UpdateWellBeingSurveyQuestionTranslationsMutationOptions = Apollo.BaseMutationOptions<
	UpdateWellBeingSurveyQuestionTranslationsMutation,
	UpdateWellBeingSurveyQuestionTranslationsMutationVariables
>;
export const UpdateWorkoutCategoryDocument = gql`
	mutation UpdateWorkoutCategory($input: UpdateWorkoutCategoryInput!) {
		updateWorkoutCategory(input: $input) {
			id
			name
			color
			sortOrder
			translations {
				language
				name
			}
			isActive
		}
	}
`;
export type UpdateWorkoutCategoryMutationFn = Apollo.MutationFunction<
	UpdateWorkoutCategoryMutation,
	UpdateWorkoutCategoryMutationVariables
>;

/**
 * __useUpdateWorkoutCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateWorkoutCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkoutCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkoutCategoryMutation, { data, loading, error }] = useUpdateWorkoutCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkoutCategoryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateWorkoutCategoryMutation,
		UpdateWorkoutCategoryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateWorkoutCategoryMutation,
		UpdateWorkoutCategoryMutationVariables
	>(UpdateWorkoutCategoryDocument, options);
}
export type UpdateWorkoutCategoryMutationHookResult = ReturnType<
	typeof useUpdateWorkoutCategoryMutation
>;
export type UpdateWorkoutCategoryMutationResult =
	Apollo.MutationResult<UpdateWorkoutCategoryMutation>;
export type UpdateWorkoutCategoryMutationOptions = Apollo.BaseMutationOptions<
	UpdateWorkoutCategoryMutation,
	UpdateWorkoutCategoryMutationVariables
>;
export const CreateWorkoutDocument = gql`
	mutation CreateWorkout($input: CreateWorkoutInput!) {
		createWorkout(input: $input) {
			id
			name
			categoryId
			type
			category {
				id
				name
			}
			intensity
			frequency
			frequencyPeriod
			durationMin
			durationMax
			isPremium
			why
			about
			instructions
			thankYouMessage
			reflectionMessage
			isActive
			createdAt
			updatedAt
			exercises {
				id
				name
				sortOrder
				groupId
				durationMin
				durationMax
				tips
				typeData {
					... on ReflectionInputData {
						inputs {
							title
							placeholder
						}
					}
					... on AudioData {
						url
						duration
					}
					... on VideoData {
						url
						duration
					}
					... on BreathingData {
						inhale
						inhaleHold
						exhale
						exhaleHold
						instructions
					}
				}
			}
		}
	}
`;
export type CreateWorkoutMutationFn = Apollo.MutationFunction<
	CreateWorkoutMutation,
	CreateWorkoutMutationVariables
>;

/**
 * __useCreateWorkoutMutation__
 *
 * To run a mutation, you first call `useCreateWorkoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkoutMutation, { data, loading, error }] = useCreateWorkoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkoutMutation(
	baseOptions?: Apollo.MutationHookOptions<CreateWorkoutMutation, CreateWorkoutMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateWorkoutMutation, CreateWorkoutMutationVariables>(
		CreateWorkoutDocument,
		options
	);
}
export type CreateWorkoutMutationHookResult = ReturnType<typeof useCreateWorkoutMutation>;
export type CreateWorkoutMutationResult = Apollo.MutationResult<CreateWorkoutMutation>;
export type CreateWorkoutMutationOptions = Apollo.BaseMutationOptions<
	CreateWorkoutMutation,
	CreateWorkoutMutationVariables
>;
export const UpdateWorkoutDocument = gql`
	mutation UpdateWorkout($id: ID!, $input: UpdateWorkoutInput!) {
		updateWorkout(id: $id, input: $input) {
			id
			name
			categoryId
			type
			category {
				id
				name
			}
			intensity
			frequency
			frequencyPeriod
			durationMin
			durationMax
			isPremium
			why
			about
			instructions
			thankYouMessage
			reflectionMessage
			isActive
			createdAt
			updatedAt
			exercises {
				id
				name
				sortOrder
				groupId
				durationMin
				durationMax
				tips
				typeData {
					... on ReflectionInputData {
						inputs {
							title
							placeholder
						}
					}
					... on AudioData {
						url
						duration
					}
					... on VideoData {
						url
						duration
					}
					... on BreathingData {
						inhale
						inhaleHold
						exhale
						exhaleHold
						instructions
					}
				}
			}
		}
	}
`;
export type UpdateWorkoutMutationFn = Apollo.MutationFunction<
	UpdateWorkoutMutation,
	UpdateWorkoutMutationVariables
>;

/**
 * __useUpdateWorkoutMutation__
 *
 * To run a mutation, you first call `useUpdateWorkoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkoutMutation, { data, loading, error }] = useUpdateWorkoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkoutMutation(
	baseOptions?: Apollo.MutationHookOptions<UpdateWorkoutMutation, UpdateWorkoutMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdateWorkoutMutation, UpdateWorkoutMutationVariables>(
		UpdateWorkoutDocument,
		options
	);
}
export type UpdateWorkoutMutationHookResult = ReturnType<typeof useUpdateWorkoutMutation>;
export type UpdateWorkoutMutationResult = Apollo.MutationResult<UpdateWorkoutMutation>;
export type UpdateWorkoutMutationOptions = Apollo.BaseMutationOptions<
	UpdateWorkoutMutation,
	UpdateWorkoutMutationVariables
>;
export const DeleteWorkoutDocument = gql`
	mutation DeleteWorkout($id: ID!) {
		deleteWorkout(id: $id)
	}
`;
export type DeleteWorkoutMutationFn = Apollo.MutationFunction<
	DeleteWorkoutMutation,
	DeleteWorkoutMutationVariables
>;

/**
 * __useDeleteWorkoutMutation__
 *
 * To run a mutation, you first call `useDeleteWorkoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkoutMutation, { data, loading, error }] = useDeleteWorkoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkoutMutation(
	baseOptions?: Apollo.MutationHookOptions<DeleteWorkoutMutation, DeleteWorkoutMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DeleteWorkoutMutation, DeleteWorkoutMutationVariables>(
		DeleteWorkoutDocument,
		options
	);
}
export type DeleteWorkoutMutationHookResult = ReturnType<typeof useDeleteWorkoutMutation>;
export type DeleteWorkoutMutationResult = Apollo.MutationResult<DeleteWorkoutMutation>;
export type DeleteWorkoutMutationOptions = Apollo.BaseMutationOptions<
	DeleteWorkoutMutation,
	DeleteWorkoutMutationVariables
>;
export const BulkUpdateWorkoutSortOrderDocument = gql`
	mutation BulkUpdateWorkoutSortOrder($input: [WorkoutSortOrderInput!]!) {
		bulkUpdateWorkoutSortOrder(input: $input)
	}
`;
export type BulkUpdateWorkoutSortOrderMutationFn = Apollo.MutationFunction<
	BulkUpdateWorkoutSortOrderMutation,
	BulkUpdateWorkoutSortOrderMutationVariables
>;

/**
 * __useBulkUpdateWorkoutSortOrderMutation__
 *
 * To run a mutation, you first call `useBulkUpdateWorkoutSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateWorkoutSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateWorkoutSortOrderMutation, { data, loading, error }] = useBulkUpdateWorkoutSortOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateWorkoutSortOrderMutation(
	baseOptions?: Apollo.MutationHookOptions<
		BulkUpdateWorkoutSortOrderMutation,
		BulkUpdateWorkoutSortOrderMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		BulkUpdateWorkoutSortOrderMutation,
		BulkUpdateWorkoutSortOrderMutationVariables
	>(BulkUpdateWorkoutSortOrderDocument, options);
}
export type BulkUpdateWorkoutSortOrderMutationHookResult = ReturnType<
	typeof useBulkUpdateWorkoutSortOrderMutation
>;
export type BulkUpdateWorkoutSortOrderMutationResult =
	Apollo.MutationResult<BulkUpdateWorkoutSortOrderMutation>;
export type BulkUpdateWorkoutSortOrderMutationOptions = Apollo.BaseMutationOptions<
	BulkUpdateWorkoutSortOrderMutation,
	BulkUpdateWorkoutSortOrderMutationVariables
>;
export const GetAllAdminUserDocument = gql`
	query GetAllAdminUser($input: GetAllAdminUserInput!) {
		getAllAdminUser(input: $input) {
			data {
				id
				userId
				firstName
				lastName
				createdAt
				updatedAt
				authenticationUser {
					id
					email
					role
					lockedAt
					lockReason
					mfaEnabled
					language
					lastActive
					isPremium
					premiumRequestedAt
					premiumApprovedAt
				}
			}
			pageInfo {
				currentPage
				totalCount
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllAdminUserQuery__
 *
 * To run a query within a React component, call `useGetAllAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAdminUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllAdminUserQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables> &
		({ variables: GetAllAdminUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>(
		GetAllAdminUserDocument,
		options
	);
}
export function useGetAllAdminUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>(
		GetAllAdminUserDocument,
		options
	);
}
// @ts-ignore
export function useGetAllAdminUserSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllAdminUserQuery,
		GetAllAdminUserQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>;
export function useGetAllAdminUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAllAdminUserQuery | undefined, GetAllAdminUserQueryVariables>;
export function useGetAllAdminUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllAdminUserQuery, GetAllAdminUserQueryVariables>(
		GetAllAdminUserDocument,
		options
	);
}
export type GetAllAdminUserQueryHookResult = ReturnType<typeof useGetAllAdminUserQuery>;
export type GetAllAdminUserLazyQueryHookResult = ReturnType<typeof useGetAllAdminUserLazyQuery>;
export type GetAllAdminUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAllAdminUserSuspenseQuery
>;
export type GetAllAdminUserQueryResult = Apollo.QueryResult<
	GetAllAdminUserQuery,
	GetAllAdminUserQueryVariables
>;
export const GetAllAdminNewsletterSubscriberDocument = gql`
	query GetAllAdminNewsletterSubscriber($input: GetAllAdminNewsletterSubscriberInput!) {
		getAllAdminNewsletterSubscriber(input: $input) {
			data {
				id
				email
				firstName
				lastName
				status
				createdAt
				updatedAt
			}
			pageInfo {
				currentPage
				totalCount
				totalPages
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllAdminNewsletterSubscriberQuery__
 *
 * To run a query within a React component, call `useGetAllAdminNewsletterSubscriberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAdminNewsletterSubscriberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAdminNewsletterSubscriberQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllAdminNewsletterSubscriberQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllAdminNewsletterSubscriberQuery,
		GetAllAdminNewsletterSubscriberQueryVariables
	> &
		(
			| { variables: GetAllAdminNewsletterSubscriberQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllAdminNewsletterSubscriberQuery,
		GetAllAdminNewsletterSubscriberQueryVariables
	>(GetAllAdminNewsletterSubscriberDocument, options);
}
export function useGetAllAdminNewsletterSubscriberLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllAdminNewsletterSubscriberQuery,
		GetAllAdminNewsletterSubscriberQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllAdminNewsletterSubscriberQuery,
		GetAllAdminNewsletterSubscriberQueryVariables
	>(GetAllAdminNewsletterSubscriberDocument, options);
}
// @ts-ignore
export function useGetAllAdminNewsletterSubscriberSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllAdminNewsletterSubscriberQuery,
		GetAllAdminNewsletterSubscriberQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllAdminNewsletterSubscriberQuery,
	GetAllAdminNewsletterSubscriberQueryVariables
>;
export function useGetAllAdminNewsletterSubscriberSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllAdminNewsletterSubscriberQuery,
				GetAllAdminNewsletterSubscriberQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllAdminNewsletterSubscriberQuery | undefined,
	GetAllAdminNewsletterSubscriberQueryVariables
>;
export function useGetAllAdminNewsletterSubscriberSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllAdminNewsletterSubscriberQuery,
				GetAllAdminNewsletterSubscriberQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllAdminNewsletterSubscriberQuery,
		GetAllAdminNewsletterSubscriberQueryVariables
	>(GetAllAdminNewsletterSubscriberDocument, options);
}
export type GetAllAdminNewsletterSubscriberQueryHookResult = ReturnType<
	typeof useGetAllAdminNewsletterSubscriberQuery
>;
export type GetAllAdminNewsletterSubscriberLazyQueryHookResult = ReturnType<
	typeof useGetAllAdminNewsletterSubscriberLazyQuery
>;
export type GetAllAdminNewsletterSubscriberSuspenseQueryHookResult = ReturnType<
	typeof useGetAllAdminNewsletterSubscriberSuspenseQuery
>;
export type GetAllAdminNewsletterSubscriberQueryResult = Apollo.QueryResult<
	GetAllAdminNewsletterSubscriberQuery,
	GetAllAdminNewsletterSubscriberQueryVariables
>;
export const GetAuthenticationUserDocument = gql`
	query GetAuthenticationUser($id: ID!) {
		getAuthenticationUser(id: $id) {
			id
			email
			mfaEnabled
			mfaMethod
			role
		}
	}
`;

/**
 * __useGetAuthenticationUserQuery__
 *
 * To run a query within a React component, call `useGetAuthenticationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticationUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAuthenticationUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAuthenticationUserQuery,
		GetAuthenticationUserQueryVariables
	> &
		({ variables: GetAuthenticationUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAuthenticationUserQuery, GetAuthenticationUserQueryVariables>(
		GetAuthenticationUserDocument,
		options
	);
}
export function useGetAuthenticationUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAuthenticationUserQuery,
		GetAuthenticationUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAuthenticationUserQuery, GetAuthenticationUserQueryVariables>(
		GetAuthenticationUserDocument,
		options
	);
}
// @ts-ignore
export function useGetAuthenticationUserSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAuthenticationUserQuery,
		GetAuthenticationUserQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetAuthenticationUserQuery, GetAuthenticationUserQueryVariables>;
export function useGetAuthenticationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAuthenticationUserQuery,
				GetAuthenticationUserQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAuthenticationUserQuery | undefined,
	GetAuthenticationUserQueryVariables
>;
export function useGetAuthenticationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAuthenticationUserQuery,
				GetAuthenticationUserQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAuthenticationUserQuery, GetAuthenticationUserQueryVariables>(
		GetAuthenticationUserDocument,
		options
	);
}
export type GetAuthenticationUserQueryHookResult = ReturnType<typeof useGetAuthenticationUserQuery>;
export type GetAuthenticationUserLazyQueryHookResult = ReturnType<
	typeof useGetAuthenticationUserLazyQuery
>;
export type GetAuthenticationUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAuthenticationUserSuspenseQuery
>;
export type GetAuthenticationUserQueryResult = Apollo.QueryResult<
	GetAuthenticationUserQuery,
	GetAuthenticationUserQueryVariables
>;
export const GetAllAuthorizationRoleDocument = gql`
	query GetAllAuthorizationRole($input: GetAllAuthorizationRoleInput!) {
		getAllAuthorizationRole(input: $input) {
			data {
				...AuthorizationRoleFragment
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${AuthorizationRoleFragmentFragmentDoc}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllAuthorizationRoleQuery__
 *
 * To run a query within a React component, call `useGetAllAuthorizationRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAuthorizationRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAuthorizationRoleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllAuthorizationRoleQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllAuthorizationRoleQuery,
		GetAllAuthorizationRoleQueryVariables
	> &
		({ variables: GetAllAuthorizationRoleQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllAuthorizationRoleQuery, GetAllAuthorizationRoleQueryVariables>(
		GetAllAuthorizationRoleDocument,
		options
	);
}
export function useGetAllAuthorizationRoleLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllAuthorizationRoleQuery,
		GetAllAuthorizationRoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllAuthorizationRoleQuery, GetAllAuthorizationRoleQueryVariables>(
		GetAllAuthorizationRoleDocument,
		options
	);
}
// @ts-ignore
export function useGetAllAuthorizationRoleSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllAuthorizationRoleQuery,
		GetAllAuthorizationRoleQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllAuthorizationRoleQuery,
	GetAllAuthorizationRoleQueryVariables
>;
export function useGetAllAuthorizationRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllAuthorizationRoleQuery,
				GetAllAuthorizationRoleQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllAuthorizationRoleQuery | undefined,
	GetAllAuthorizationRoleQueryVariables
>;
export function useGetAllAuthorizationRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllAuthorizationRoleQuery,
				GetAllAuthorizationRoleQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllAuthorizationRoleQuery,
		GetAllAuthorizationRoleQueryVariables
	>(GetAllAuthorizationRoleDocument, options);
}
export type GetAllAuthorizationRoleQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationRoleQuery
>;
export type GetAllAuthorizationRoleLazyQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationRoleLazyQuery
>;
export type GetAllAuthorizationRoleSuspenseQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationRoleSuspenseQuery
>;
export type GetAllAuthorizationRoleQueryResult = Apollo.QueryResult<
	GetAllAuthorizationRoleQuery,
	GetAllAuthorizationRoleQueryVariables
>;
export const GetAuthorizationRoleDocument = gql`
	query GetAuthorizationRole($id: ID!) {
		getAuthorizationRole(id: $id) {
			...AuthorizationRoleFragment
		}
	}
	${AuthorizationRoleFragmentFragmentDoc}
`;

/**
 * __useGetAuthorizationRoleQuery__
 *
 * To run a query within a React component, call `useGetAuthorizationRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizationRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizationRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAuthorizationRoleQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAuthorizationRoleQuery,
		GetAuthorizationRoleQueryVariables
	> &
		({ variables: GetAuthorizationRoleQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAuthorizationRoleQuery, GetAuthorizationRoleQueryVariables>(
		GetAuthorizationRoleDocument,
		options
	);
}
export function useGetAuthorizationRoleLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAuthorizationRoleQuery,
		GetAuthorizationRoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAuthorizationRoleQuery, GetAuthorizationRoleQueryVariables>(
		GetAuthorizationRoleDocument,
		options
	);
}
// @ts-ignore
export function useGetAuthorizationRoleSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAuthorizationRoleQuery,
		GetAuthorizationRoleQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetAuthorizationRoleQuery, GetAuthorizationRoleQueryVariables>;
export function useGetAuthorizationRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAuthorizationRoleQuery,
				GetAuthorizationRoleQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAuthorizationRoleQuery | undefined,
	GetAuthorizationRoleQueryVariables
>;
export function useGetAuthorizationRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAuthorizationRoleQuery,
				GetAuthorizationRoleQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAuthorizationRoleQuery, GetAuthorizationRoleQueryVariables>(
		GetAuthorizationRoleDocument,
		options
	);
}
export type GetAuthorizationRoleQueryHookResult = ReturnType<typeof useGetAuthorizationRoleQuery>;
export type GetAuthorizationRoleLazyQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleLazyQuery
>;
export type GetAuthorizationRoleSuspenseQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleSuspenseQuery
>;
export type GetAuthorizationRoleQueryResult = Apollo.QueryResult<
	GetAuthorizationRoleQuery,
	GetAuthorizationRoleQueryVariables
>;
export const GetAuthorizationRoleByNameDocument = gql`
	query GetAuthorizationRoleByName($name: String!) {
		getAuthorizationRoleByName(name: $name) {
			...AuthorizationRoleFragment
		}
	}
	${AuthorizationRoleFragmentFragmentDoc}
`;

/**
 * __useGetAuthorizationRoleByNameQuery__
 *
 * To run a query within a React component, call `useGetAuthorizationRoleByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizationRoleByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizationRoleByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAuthorizationRoleByNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	> &
		(
			| { variables: GetAuthorizationRoleByNameQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	>(GetAuthorizationRoleByNameDocument, options);
}
export function useGetAuthorizationRoleByNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	>(GetAuthorizationRoleByNameDocument, options);
}
// @ts-ignore
export function useGetAuthorizationRoleByNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAuthorizationRoleByNameQuery,
	GetAuthorizationRoleByNameQueryVariables
>;
export function useGetAuthorizationRoleByNameSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAuthorizationRoleByNameQuery,
				GetAuthorizationRoleByNameQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAuthorizationRoleByNameQuery | undefined,
	GetAuthorizationRoleByNameQueryVariables
>;
export function useGetAuthorizationRoleByNameSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAuthorizationRoleByNameQuery,
				GetAuthorizationRoleByNameQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAuthorizationRoleByNameQuery,
		GetAuthorizationRoleByNameQueryVariables
	>(GetAuthorizationRoleByNameDocument, options);
}
export type GetAuthorizationRoleByNameQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleByNameQuery
>;
export type GetAuthorizationRoleByNameLazyQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleByNameLazyQuery
>;
export type GetAuthorizationRoleByNameSuspenseQueryHookResult = ReturnType<
	typeof useGetAuthorizationRoleByNameSuspenseQuery
>;
export type GetAuthorizationRoleByNameQueryResult = Apollo.QueryResult<
	GetAuthorizationRoleByNameQuery,
	GetAuthorizationRoleByNameQueryVariables
>;
export const GetAllAuthorizationUserRoleDocument = gql`
	query GetAllAuthorizationUserRole($input: GetAllAuthorizationUserRoleInput!) {
		getAllAuthorizationUserRole(input: $input) {
			data {
				...AuthorizationUserRoleFragment
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${AuthorizationUserRoleFragmentFragmentDoc}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllAuthorizationUserRoleQuery__
 *
 * To run a query within a React component, call `useGetAllAuthorizationUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAuthorizationUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAuthorizationUserRoleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllAuthorizationUserRoleQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	> &
		(
			| { variables: GetAllAuthorizationUserRoleQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	>(GetAllAuthorizationUserRoleDocument, options);
}
export function useGetAllAuthorizationUserRoleLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	>(GetAllAuthorizationUserRoleDocument, options);
}
// @ts-ignore
export function useGetAllAuthorizationUserRoleSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllAuthorizationUserRoleQuery,
	GetAllAuthorizationUserRoleQueryVariables
>;
export function useGetAllAuthorizationUserRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllAuthorizationUserRoleQuery,
				GetAllAuthorizationUserRoleQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllAuthorizationUserRoleQuery | undefined,
	GetAllAuthorizationUserRoleQueryVariables
>;
export function useGetAllAuthorizationUserRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllAuthorizationUserRoleQuery,
				GetAllAuthorizationUserRoleQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllAuthorizationUserRoleQuery,
		GetAllAuthorizationUserRoleQueryVariables
	>(GetAllAuthorizationUserRoleDocument, options);
}
export type GetAllAuthorizationUserRoleQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationUserRoleQuery
>;
export type GetAllAuthorizationUserRoleLazyQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationUserRoleLazyQuery
>;
export type GetAllAuthorizationUserRoleSuspenseQueryHookResult = ReturnType<
	typeof useGetAllAuthorizationUserRoleSuspenseQuery
>;
export type GetAllAuthorizationUserRoleQueryResult = Apollo.QueryResult<
	GetAllAuthorizationUserRoleQuery,
	GetAllAuthorizationUserRoleQueryVariables
>;
export const GetMyAuthorizationUserRoleDocument = gql`
	query GetMyAuthorizationUserRole($input: GetMyAuthorizationUserRoleInput!) {
		getMyAuthorizationUserRole(input: $input) {
			data {
				...AuthorizationUserRoleFragment
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${AuthorizationUserRoleFragmentFragmentDoc}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetMyAuthorizationUserRoleQuery__
 *
 * To run a query within a React component, call `useGetMyAuthorizationUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAuthorizationUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAuthorizationUserRoleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMyAuthorizationUserRoleQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	> &
		(
			| { variables: GetMyAuthorizationUserRoleQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	>(GetMyAuthorizationUserRoleDocument, options);
}
export function useGetMyAuthorizationUserRoleLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	>(GetMyAuthorizationUserRoleDocument, options);
}
// @ts-ignore
export function useGetMyAuthorizationUserRoleSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetMyAuthorizationUserRoleQuery,
	GetMyAuthorizationUserRoleQueryVariables
>;
export function useGetMyAuthorizationUserRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetMyAuthorizationUserRoleQuery,
				GetMyAuthorizationUserRoleQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetMyAuthorizationUserRoleQuery | undefined,
	GetMyAuthorizationUserRoleQueryVariables
>;
export function useGetMyAuthorizationUserRoleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetMyAuthorizationUserRoleQuery,
				GetMyAuthorizationUserRoleQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetMyAuthorizationUserRoleQuery,
		GetMyAuthorizationUserRoleQueryVariables
	>(GetMyAuthorizationUserRoleDocument, options);
}
export type GetMyAuthorizationUserRoleQueryHookResult = ReturnType<
	typeof useGetMyAuthorizationUserRoleQuery
>;
export type GetMyAuthorizationUserRoleLazyQueryHookResult = ReturnType<
	typeof useGetMyAuthorizationUserRoleLazyQuery
>;
export type GetMyAuthorizationUserRoleSuspenseQueryHookResult = ReturnType<
	typeof useGetMyAuthorizationUserRoleSuspenseQuery
>;
export type GetMyAuthorizationUserRoleQueryResult = Apollo.QueryResult<
	GetMyAuthorizationUserRoleQuery,
	GetMyAuthorizationUserRoleQueryVariables
>;
export const GetAllLocalizationTimezonesDocument = gql`
	query GetAllLocalizationTimezones {
		getAllLocalizationTimezones {
			name
			offset
		}
	}
`;

/**
 * __useGetAllLocalizationTimezonesQuery__
 *
 * To run a query within a React component, call `useGetAllLocalizationTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocalizationTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocalizationTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLocalizationTimezonesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>(GetAllLocalizationTimezonesDocument, options);
}
export function useGetAllLocalizationTimezonesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>(GetAllLocalizationTimezonesDocument, options);
}
// @ts-ignore
export function useGetAllLocalizationTimezonesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllLocalizationTimezonesQuery,
	GetAllLocalizationTimezonesQueryVariables
>;
export function useGetAllLocalizationTimezonesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLocalizationTimezonesQuery,
				GetAllLocalizationTimezonesQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllLocalizationTimezonesQuery | undefined,
	GetAllLocalizationTimezonesQueryVariables
>;
export function useGetAllLocalizationTimezonesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLocalizationTimezonesQuery,
				GetAllLocalizationTimezonesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllLocalizationTimezonesQuery,
		GetAllLocalizationTimezonesQueryVariables
	>(GetAllLocalizationTimezonesDocument, options);
}
export type GetAllLocalizationTimezonesQueryHookResult = ReturnType<
	typeof useGetAllLocalizationTimezonesQuery
>;
export type GetAllLocalizationTimezonesLazyQueryHookResult = ReturnType<
	typeof useGetAllLocalizationTimezonesLazyQuery
>;
export type GetAllLocalizationTimezonesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLocalizationTimezonesSuspenseQuery
>;
export type GetAllLocalizationTimezonesQueryResult = Apollo.QueryResult<
	GetAllLocalizationTimezonesQuery,
	GetAllLocalizationTimezonesQueryVariables
>;
export const GetAllLocalizationCountriesDocument = gql`
	query GetAllLocalizationCountries {
		getAllLocalizationCountries {
			code
			name
			currency
			defaultTimezone
			defaultMeasurementSystem
			hasStates
			isEU
			phonePrefix
			nativeName
			registrations {
				code
				label
				placeholder
				helpText
				isRequired
				vatDerivationPattern
			}
			addressFormat {
				postalCodeLabel
				stateLabel
				stateRequired
			}
		}
	}
`;

/**
 * __useGetAllLocalizationCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllLocalizationCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocalizationCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocalizationCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLocalizationCountriesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>(GetAllLocalizationCountriesDocument, options);
}
export function useGetAllLocalizationCountriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>(GetAllLocalizationCountriesDocument, options);
}
// @ts-ignore
export function useGetAllLocalizationCountriesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllLocalizationCountriesQuery,
	GetAllLocalizationCountriesQueryVariables
>;
export function useGetAllLocalizationCountriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLocalizationCountriesQuery,
				GetAllLocalizationCountriesQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllLocalizationCountriesQuery | undefined,
	GetAllLocalizationCountriesQueryVariables
>;
export function useGetAllLocalizationCountriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLocalizationCountriesQuery,
				GetAllLocalizationCountriesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllLocalizationCountriesQuery,
		GetAllLocalizationCountriesQueryVariables
	>(GetAllLocalizationCountriesDocument, options);
}
export type GetAllLocalizationCountriesQueryHookResult = ReturnType<
	typeof useGetAllLocalizationCountriesQuery
>;
export type GetAllLocalizationCountriesLazyQueryHookResult = ReturnType<
	typeof useGetAllLocalizationCountriesLazyQuery
>;
export type GetAllLocalizationCountriesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLocalizationCountriesSuspenseQuery
>;
export type GetAllLocalizationCountriesQueryResult = Apollo.QueryResult<
	GetAllLocalizationCountriesQuery,
	GetAllLocalizationCountriesQueryVariables
>;
export const GetLocalizationCountryDocument = gql`
	query GetLocalizationCountry($countryCode: String!) {
		getLocalizationCountry(countryCode: $countryCode) {
			code
			name
			currency
			defaultTimezone
			defaultMeasurementSystem
			hasStates
			isEU
			phonePrefix
			nativeName
			registrations {
				code
				label
				placeholder
				helpText
				isRequired
				vatDerivationPattern
			}
			addressFormat {
				postalCodeLabel
				stateLabel
				stateRequired
			}
			states {
				code
				name
			}
		}
	}
`;

/**
 * __useGetLocalizationCountryQuery__
 *
 * To run a query within a React component, call `useGetLocalizationCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationCountryQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetLocalizationCountryQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetLocalizationCountryQuery,
		GetLocalizationCountryQueryVariables
	> &
		({ variables: GetLocalizationCountryQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetLocalizationCountryQuery, GetLocalizationCountryQueryVariables>(
		GetLocalizationCountryDocument,
		options
	);
}
export function useGetLocalizationCountryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetLocalizationCountryQuery,
		GetLocalizationCountryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetLocalizationCountryQuery, GetLocalizationCountryQueryVariables>(
		GetLocalizationCountryDocument,
		options
	);
}
// @ts-ignore
export function useGetLocalizationCountrySuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetLocalizationCountryQuery,
		GetLocalizationCountryQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetLocalizationCountryQuery, GetLocalizationCountryQueryVariables>;
export function useGetLocalizationCountrySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationCountryQuery,
				GetLocalizationCountryQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetLocalizationCountryQuery | undefined,
	GetLocalizationCountryQueryVariables
>;
export function useGetLocalizationCountrySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationCountryQuery,
				GetLocalizationCountryQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetLocalizationCountryQuery,
		GetLocalizationCountryQueryVariables
	>(GetLocalizationCountryDocument, options);
}
export type GetLocalizationCountryQueryHookResult = ReturnType<
	typeof useGetLocalizationCountryQuery
>;
export type GetLocalizationCountryLazyQueryHookResult = ReturnType<
	typeof useGetLocalizationCountryLazyQuery
>;
export type GetLocalizationCountrySuspenseQueryHookResult = ReturnType<
	typeof useGetLocalizationCountrySuspenseQuery
>;
export type GetLocalizationCountryQueryResult = Apollo.QueryResult<
	GetLocalizationCountryQuery,
	GetLocalizationCountryQueryVariables
>;
export const GetLocalizationStatesDocument = gql`
	query GetLocalizationStates($countryCode: String!) {
		getLocalizationStates(countryCode: $countryCode) {
			code
			name
		}
	}
`;

/**
 * __useGetLocalizationStatesQuery__
 *
 * To run a query within a React component, call `useGetLocalizationStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationStatesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetLocalizationStatesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetLocalizationStatesQuery,
		GetLocalizationStatesQueryVariables
	> &
		({ variables: GetLocalizationStatesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>(
		GetLocalizationStatesDocument,
		options
	);
}
export function useGetLocalizationStatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetLocalizationStatesQuery,
		GetLocalizationStatesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>(
		GetLocalizationStatesDocument,
		options
	);
}
// @ts-ignore
export function useGetLocalizationStatesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetLocalizationStatesQuery,
		GetLocalizationStatesQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>;
export function useGetLocalizationStatesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationStatesQuery,
				GetLocalizationStatesQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetLocalizationStatesQuery | undefined,
	GetLocalizationStatesQueryVariables
>;
export function useGetLocalizationStatesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationStatesQuery,
				GetLocalizationStatesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetLocalizationStatesQuery, GetLocalizationStatesQueryVariables>(
		GetLocalizationStatesDocument,
		options
	);
}
export type GetLocalizationStatesQueryHookResult = ReturnType<typeof useGetLocalizationStatesQuery>;
export type GetLocalizationStatesLazyQueryHookResult = ReturnType<
	typeof useGetLocalizationStatesLazyQuery
>;
export type GetLocalizationStatesSuspenseQueryHookResult = ReturnType<
	typeof useGetLocalizationStatesSuspenseQuery
>;
export type GetLocalizationStatesQueryResult = Apollo.QueryResult<
	GetLocalizationStatesQuery,
	GetLocalizationStatesQueryVariables
>;
export const ValidateCvrDocument = gql`
	query ValidateCVR($cvrNumber: String!) {
		validateCVR(cvrNumber: $cvrNumber) {
			valid
			companyInfo {
				name
				vat
				address {
					street
					zipcode
					city
					country
				}
				active
				startDate
				industryCode
				industryDescription
				employees
				phone
				email
			}
			error
		}
	}
`;

/**
 * __useValidateCvrQuery__
 *
 * To run a query within a React component, call `useValidateCvrQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCvrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCvrQuery({
 *   variables: {
 *      cvrNumber: // value for 'cvrNumber'
 *   },
 * });
 */
export function useValidateCvrQuery(
	baseOptions: Apollo.QueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables> &
		({ variables: ValidateCvrQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ValidateCvrQuery, ValidateCvrQueryVariables>(
		ValidateCvrDocument,
		options
	);
}
export function useValidateCvrLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ValidateCvrQuery, ValidateCvrQueryVariables>(
		ValidateCvrDocument,
		options
	);
}
// @ts-ignore
export function useValidateCvrSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables>
): Apollo.UseSuspenseQueryResult<ValidateCvrQuery, ValidateCvrQueryVariables>;
export function useValidateCvrSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables>
): Apollo.UseSuspenseQueryResult<ValidateCvrQuery | undefined, ValidateCvrQueryVariables>;
export function useValidateCvrSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<ValidateCvrQuery, ValidateCvrQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ValidateCvrQuery, ValidateCvrQueryVariables>(
		ValidateCvrDocument,
		options
	);
}
export type ValidateCvrQueryHookResult = ReturnType<typeof useValidateCvrQuery>;
export type ValidateCvrLazyQueryHookResult = ReturnType<typeof useValidateCvrLazyQuery>;
export type ValidateCvrSuspenseQueryHookResult = ReturnType<typeof useValidateCvrSuspenseQuery>;
export type ValidateCvrQueryResult = Apollo.QueryResult<
	ValidateCvrQuery,
	ValidateCvrQueryVariables
>;
export const ValidateBusinessRegistrationDocument = gql`
	query ValidateBusinessRegistration(
		$countryCode: String!
		$registrationType: String!
		$registrationNumber: String!
	) {
		validateBusinessRegistration(
			countryCode: $countryCode
			registrationType: $registrationType
			registrationNumber: $registrationNumber
		) {
			valid
			error
		}
	}
`;

/**
 * __useValidateBusinessRegistrationQuery__
 *
 * To run a query within a React component, call `useValidateBusinessRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBusinessRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBusinessRegistrationQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      registrationType: // value for 'registrationType'
 *      registrationNumber: // value for 'registrationNumber'
 *   },
 * });
 */
export function useValidateBusinessRegistrationQuery(
	baseOptions: Apollo.QueryHookOptions<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	> &
		(
			| { variables: ValidateBusinessRegistrationQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	>(ValidateBusinessRegistrationDocument, options);
}
export function useValidateBusinessRegistrationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	>(ValidateBusinessRegistrationDocument, options);
}
// @ts-ignore
export function useValidateBusinessRegistrationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	ValidateBusinessRegistrationQuery,
	ValidateBusinessRegistrationQueryVariables
>;
export function useValidateBusinessRegistrationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ValidateBusinessRegistrationQuery,
				ValidateBusinessRegistrationQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	ValidateBusinessRegistrationQuery | undefined,
	ValidateBusinessRegistrationQueryVariables
>;
export function useValidateBusinessRegistrationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ValidateBusinessRegistrationQuery,
				ValidateBusinessRegistrationQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ValidateBusinessRegistrationQuery,
		ValidateBusinessRegistrationQueryVariables
	>(ValidateBusinessRegistrationDocument, options);
}
export type ValidateBusinessRegistrationQueryHookResult = ReturnType<
	typeof useValidateBusinessRegistrationQuery
>;
export type ValidateBusinessRegistrationLazyQueryHookResult = ReturnType<
	typeof useValidateBusinessRegistrationLazyQuery
>;
export type ValidateBusinessRegistrationSuspenseQueryHookResult = ReturnType<
	typeof useValidateBusinessRegistrationSuspenseQuery
>;
export type ValidateBusinessRegistrationQueryResult = Apollo.QueryResult<
	ValidateBusinessRegistrationQuery,
	ValidateBusinessRegistrationQueryVariables
>;
export const AddressAutocompleteDocument = gql`
	query AddressAutocomplete($input: String!, $countryCode: String, $sessionToken: String) {
		addressAutocomplete(input: $input, countryCode: $countryCode, sessionToken: $sessionToken) {
			placeId
			description
			mainText
			secondaryText
		}
	}
`;

/**
 * __useAddressAutocompleteQuery__
 *
 * To run a query within a React component, call `useAddressAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressAutocompleteQuery({
 *   variables: {
 *      input: // value for 'input'
 *      countryCode: // value for 'countryCode'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useAddressAutocompleteQuery(
	baseOptions: Apollo.QueryHookOptions<
		AddressAutocompleteQuery,
		AddressAutocompleteQueryVariables
	> &
		({ variables: AddressAutocompleteQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>(
		AddressAutocompleteDocument,
		options
	);
}
export function useAddressAutocompleteLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AddressAutocompleteQuery,
		AddressAutocompleteQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>(
		AddressAutocompleteDocument,
		options
	);
}
// @ts-ignore
export function useAddressAutocompleteSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AddressAutocompleteQuery,
		AddressAutocompleteQueryVariables
	>
): Apollo.UseSuspenseQueryResult<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>;
export function useAddressAutocompleteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				AddressAutocompleteQuery,
				AddressAutocompleteQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	AddressAutocompleteQuery | undefined,
	AddressAutocompleteQueryVariables
>;
export function useAddressAutocompleteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				AddressAutocompleteQuery,
				AddressAutocompleteQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>(
		AddressAutocompleteDocument,
		options
	);
}
export type AddressAutocompleteQueryHookResult = ReturnType<typeof useAddressAutocompleteQuery>;
export type AddressAutocompleteLazyQueryHookResult = ReturnType<
	typeof useAddressAutocompleteLazyQuery
>;
export type AddressAutocompleteSuspenseQueryHookResult = ReturnType<
	typeof useAddressAutocompleteSuspenseQuery
>;
export type AddressAutocompleteQueryResult = Apollo.QueryResult<
	AddressAutocompleteQuery,
	AddressAutocompleteQueryVariables
>;
export const GetPlaceDetailsDocument = gql`
	query GetPlaceDetails($placeId: String!, $sessionToken: String) {
		getPlaceDetails(placeId: $placeId, sessionToken: $sessionToken) {
			placeId
			formattedAddress
			streetNumber
			streetName
			city
			state
			stateCode
			postalCode
			country
			countryCode
			latitude
			longitude
			timezone
		}
	}
`;

/**
 * __useGetPlaceDetailsQuery__
 *
 * To run a query within a React component, call `useGetPlaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceDetailsQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetPlaceDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables> &
		({ variables: GetPlaceDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(
		GetPlaceDetailsDocument,
		options
	);
}
export function useGetPlaceDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(
		GetPlaceDetailsDocument,
		options
	);
}
// @ts-ignore
export function useGetPlaceDetailsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetPlaceDetailsQuery,
		GetPlaceDetailsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>;
export function useGetPlaceDetailsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetPlaceDetailsQuery | undefined, GetPlaceDetailsQueryVariables>;
export function useGetPlaceDetailsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(
		GetPlaceDetailsDocument,
		options
	);
}
export type GetPlaceDetailsQueryHookResult = ReturnType<typeof useGetPlaceDetailsQuery>;
export type GetPlaceDetailsLazyQueryHookResult = ReturnType<typeof useGetPlaceDetailsLazyQuery>;
export type GetPlaceDetailsSuspenseQueryHookResult = ReturnType<
	typeof useGetPlaceDetailsSuspenseQuery
>;
export type GetPlaceDetailsQueryResult = Apollo.QueryResult<
	GetPlaceDetailsQuery,
	GetPlaceDetailsQueryVariables
>;
export const ValidateAddressDocument = gql`
	query ValidateAddress($placeId: String!) {
		validateAddress(placeId: $placeId) {
			valid
			errors
			warnings
		}
	}
`;

/**
 * __useValidateAddressQuery__
 *
 * To run a query within a React component, call `useValidateAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateAddressQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useValidateAddressQuery(
	baseOptions: Apollo.QueryHookOptions<ValidateAddressQuery, ValidateAddressQueryVariables> &
		({ variables: ValidateAddressQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ValidateAddressQuery, ValidateAddressQueryVariables>(
		ValidateAddressDocument,
		options
	);
}
export function useValidateAddressLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ValidateAddressQuery, ValidateAddressQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ValidateAddressQuery, ValidateAddressQueryVariables>(
		ValidateAddressDocument,
		options
	);
}
// @ts-ignore
export function useValidateAddressSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ValidateAddressQuery,
		ValidateAddressQueryVariables
	>
): Apollo.UseSuspenseQueryResult<ValidateAddressQuery, ValidateAddressQueryVariables>;
export function useValidateAddressSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<ValidateAddressQuery, ValidateAddressQueryVariables>
): Apollo.UseSuspenseQueryResult<ValidateAddressQuery | undefined, ValidateAddressQueryVariables>;
export function useValidateAddressSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<ValidateAddressQuery, ValidateAddressQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ValidateAddressQuery, ValidateAddressQueryVariables>(
		ValidateAddressDocument,
		options
	);
}
export type ValidateAddressQueryHookResult = ReturnType<typeof useValidateAddressQuery>;
export type ValidateAddressLazyQueryHookResult = ReturnType<typeof useValidateAddressLazyQuery>;
export type ValidateAddressSuspenseQueryHookResult = ReturnType<
	typeof useValidateAddressSuspenseQuery
>;
export type ValidateAddressQueryResult = Apollo.QueryResult<
	ValidateAddressQuery,
	ValidateAddressQueryVariables
>;
export const GetLocalizationDefaultsDocument = gql`
	query GetLocalizationDefaults($placeId: String!) {
		getLocalizationDefaults(placeId: $placeId) {
			countryCode
			currency
			measurementSystem
			timezone
		}
	}
`;

/**
 * __useGetLocalizationDefaultsQuery__
 *
 * To run a query within a React component, call `useGetLocalizationDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationDefaultsQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useGetLocalizationDefaultsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetLocalizationDefaultsQuery,
		GetLocalizationDefaultsQueryVariables
	> &
		({ variables: GetLocalizationDefaultsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetLocalizationDefaultsQuery, GetLocalizationDefaultsQueryVariables>(
		GetLocalizationDefaultsDocument,
		options
	);
}
export function useGetLocalizationDefaultsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetLocalizationDefaultsQuery,
		GetLocalizationDefaultsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetLocalizationDefaultsQuery, GetLocalizationDefaultsQueryVariables>(
		GetLocalizationDefaultsDocument,
		options
	);
}
// @ts-ignore
export function useGetLocalizationDefaultsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetLocalizationDefaultsQuery,
		GetLocalizationDefaultsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetLocalizationDefaultsQuery,
	GetLocalizationDefaultsQueryVariables
>;
export function useGetLocalizationDefaultsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationDefaultsQuery,
				GetLocalizationDefaultsQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetLocalizationDefaultsQuery | undefined,
	GetLocalizationDefaultsQueryVariables
>;
export function useGetLocalizationDefaultsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetLocalizationDefaultsQuery,
				GetLocalizationDefaultsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetLocalizationDefaultsQuery,
		GetLocalizationDefaultsQueryVariables
	>(GetLocalizationDefaultsDocument, options);
}
export type GetLocalizationDefaultsQueryHookResult = ReturnType<
	typeof useGetLocalizationDefaultsQuery
>;
export type GetLocalizationDefaultsLazyQueryHookResult = ReturnType<
	typeof useGetLocalizationDefaultsLazyQuery
>;
export type GetLocalizationDefaultsSuspenseQueryHookResult = ReturnType<
	typeof useGetLocalizationDefaultsSuspenseQuery
>;
export type GetLocalizationDefaultsQueryResult = Apollo.QueryResult<
	GetLocalizationDefaultsQuery,
	GetLocalizationDefaultsQueryVariables
>;
export const GenerateVatFromRegistrationDocument = gql`
	query GenerateVATFromRegistration(
		$countryCode: String!
		$registrationNumber: String!
		$registrationType: String!
	) {
		generateVATFromRegistration(
			countryCode: $countryCode
			registrationNumber: $registrationNumber
			registrationType: $registrationType
		)
	}
`;

/**
 * __useGenerateVatFromRegistrationQuery__
 *
 * To run a query within a React component, call `useGenerateVatFromRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateVatFromRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateVatFromRegistrationQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      registrationNumber: // value for 'registrationNumber'
 *      registrationType: // value for 'registrationType'
 *   },
 * });
 */
export function useGenerateVatFromRegistrationQuery(
	baseOptions: Apollo.QueryHookOptions<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	> &
		(
			| { variables: GenerateVatFromRegistrationQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>(GenerateVatFromRegistrationDocument, options);
}
export function useGenerateVatFromRegistrationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>(GenerateVatFromRegistrationDocument, options);
}
// @ts-ignore
export function useGenerateVatFromRegistrationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GenerateVatFromRegistrationQuery,
	GenerateVatFromRegistrationQueryVariables
>;
export function useGenerateVatFromRegistrationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GenerateVatFromRegistrationQuery,
				GenerateVatFromRegistrationQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GenerateVatFromRegistrationQuery | undefined,
	GenerateVatFromRegistrationQueryVariables
>;
export function useGenerateVatFromRegistrationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GenerateVatFromRegistrationQuery,
				GenerateVatFromRegistrationQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GenerateVatFromRegistrationQuery,
		GenerateVatFromRegistrationQueryVariables
	>(GenerateVatFromRegistrationDocument, options);
}
export type GenerateVatFromRegistrationQueryHookResult = ReturnType<
	typeof useGenerateVatFromRegistrationQuery
>;
export type GenerateVatFromRegistrationLazyQueryHookResult = ReturnType<
	typeof useGenerateVatFromRegistrationLazyQuery
>;
export type GenerateVatFromRegistrationSuspenseQueryHookResult = ReturnType<
	typeof useGenerateVatFromRegistrationSuspenseQuery
>;
export type GenerateVatFromRegistrationQueryResult = Apollo.QueryResult<
	GenerateVatFromRegistrationQuery,
	GenerateVatFromRegistrationQueryVariables
>;
export const GetTranslationsDocument = gql`
	query GetTranslations($language: String!, $keys: [String!]) {
		getTranslations(language: $language, keys: $keys) {
			key
			language
			content
			params
		}
	}
`;

/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *      language: // value for 'language'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useGetTranslationsQuery(
	baseOptions: Apollo.QueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables> &
		({ variables: GetTranslationsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(
		GetTranslationsDocument,
		options
	);
}
export function useGetTranslationsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(
		GetTranslationsDocument,
		options
	);
}
// @ts-ignore
export function useGetTranslationsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetTranslationsQuery,
		GetTranslationsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetTranslationsQuery, GetTranslationsQueryVariables>;
export function useGetTranslationsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetTranslationsQuery | undefined, GetTranslationsQueryVariables>;
export function useGetTranslationsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(
		GetTranslationsDocument,
		options
	);
}
export type GetTranslationsQueryHookResult = ReturnType<typeof useGetTranslationsQuery>;
export type GetTranslationsLazyQueryHookResult = ReturnType<typeof useGetTranslationsLazyQuery>;
export type GetTranslationsSuspenseQueryHookResult = ReturnType<
	typeof useGetTranslationsSuspenseQuery
>;
export type GetTranslationsQueryResult = Apollo.QueryResult<
	GetTranslationsQuery,
	GetTranslationsQueryVariables
>;
export const GetAllTranslationsDocument = gql`
	query GetAllTranslations(
		$language: String!
		$search: String
		$sortBy: String
		$sortOrder: String
	) {
		getAllTranslations(
			language: $language
			search: $search
			sortBy: $sortBy
			sortOrder: $sortOrder
		) {
			key
			language
			content
			params
		}
	}
`;

/**
 * __useGetAllTranslationsQuery__
 *
 * To run a query within a React component, call `useGetAllTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTranslationsQuery({
 *   variables: {
 *      language: // value for 'language'
 *      search: // value for 'search'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetAllTranslationsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllTranslationsQuery,
		GetAllTranslationsQueryVariables
	> &
		({ variables: GetAllTranslationsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllTranslationsQuery, GetAllTranslationsQueryVariables>(
		GetAllTranslationsDocument,
		options
	);
}
export function useGetAllTranslationsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllTranslationsQuery,
		GetAllTranslationsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllTranslationsQuery, GetAllTranslationsQueryVariables>(
		GetAllTranslationsDocument,
		options
	);
}
// @ts-ignore
export function useGetAllTranslationsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllTranslationsQuery,
		GetAllTranslationsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetAllTranslationsQuery, GetAllTranslationsQueryVariables>;
export function useGetAllTranslationsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllTranslationsQuery, GetAllTranslationsQueryVariables>
): Apollo.UseSuspenseQueryResult<
	GetAllTranslationsQuery | undefined,
	GetAllTranslationsQueryVariables
>;
export function useGetAllTranslationsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllTranslationsQuery, GetAllTranslationsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllTranslationsQuery, GetAllTranslationsQueryVariables>(
		GetAllTranslationsDocument,
		options
	);
}
export type GetAllTranslationsQueryHookResult = ReturnType<typeof useGetAllTranslationsQuery>;
export type GetAllTranslationsLazyQueryHookResult = ReturnType<
	typeof useGetAllTranslationsLazyQuery
>;
export type GetAllTranslationsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllTranslationsSuspenseQuery
>;
export type GetAllTranslationsQueryResult = Apollo.QueryResult<
	GetAllTranslationsQuery,
	GetAllTranslationsQueryVariables
>;
export const GetAllLoggingAuditLogDocument = gql`
	query GetAllLoggingAuditLog($input: GetAllLoggingAuditLogInput!) {
		getAllLoggingAuditLog(input: $input) {
			data {
				id
				action
				changes
				createdAt
				description
				organizationId
				resource
				resourceId
				serviceName
				status
				updatedAt
				userId
				metadata
			}
			pageInfo {
				currentPage
				hasNextPage
				hasPreviousPage
				totalCount
				totalPages
			}
		}
	}
`;

/**
 * __useGetAllLoggingAuditLogQuery__
 *
 * To run a query within a React component, call `useGetAllLoggingAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLoggingAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLoggingAuditLogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllLoggingAuditLogQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllLoggingAuditLogQuery,
		GetAllLoggingAuditLogQueryVariables
	> &
		({ variables: GetAllLoggingAuditLogQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllLoggingAuditLogQuery, GetAllLoggingAuditLogQueryVariables>(
		GetAllLoggingAuditLogDocument,
		options
	);
}
export function useGetAllLoggingAuditLogLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLoggingAuditLogQuery,
		GetAllLoggingAuditLogQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllLoggingAuditLogQuery, GetAllLoggingAuditLogQueryVariables>(
		GetAllLoggingAuditLogDocument,
		options
	);
}
// @ts-ignore
export function useGetAllLoggingAuditLogSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllLoggingAuditLogQuery,
		GetAllLoggingAuditLogQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetAllLoggingAuditLogQuery, GetAllLoggingAuditLogQueryVariables>;
export function useGetAllLoggingAuditLogSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLoggingAuditLogQuery,
				GetAllLoggingAuditLogQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllLoggingAuditLogQuery | undefined,
	GetAllLoggingAuditLogQueryVariables
>;
export function useGetAllLoggingAuditLogSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLoggingAuditLogQuery,
				GetAllLoggingAuditLogQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllLoggingAuditLogQuery, GetAllLoggingAuditLogQueryVariables>(
		GetAllLoggingAuditLogDocument,
		options
	);
}
export type GetAllLoggingAuditLogQueryHookResult = ReturnType<typeof useGetAllLoggingAuditLogQuery>;
export type GetAllLoggingAuditLogLazyQueryHookResult = ReturnType<
	typeof useGetAllLoggingAuditLogLazyQuery
>;
export type GetAllLoggingAuditLogSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLoggingAuditLogSuspenseQuery
>;
export type GetAllLoggingAuditLogQueryResult = Apollo.QueryResult<
	GetAllLoggingAuditLogQuery,
	GetAllLoggingAuditLogQueryVariables
>;
export const GetAllLoggingLoginLogDocument = gql`
	query GetAllLoggingLoginLog($input: GetAllLoggingLoginLogInput!) {
		getAllLoggingLoginLog(input: $input) {
			data {
				id
				browser
				createdAt
				failureReason
				ipAddress
				method
				os
				referenceId
				serviceId
				status
				updatedAt
				userAgent
				userId
				user {
					id
					email
					organizationUser {
						id
						firstName
						lastName
					}
				}
			}
			pageInfo {
				currentPage
				hasNextPage
				hasPreviousPage
				totalCount
				totalPages
			}
		}
	}
`;

/**
 * __useGetAllLoggingLoginLogQuery__
 *
 * To run a query within a React component, call `useGetAllLoggingLoginLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLoggingLoginLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLoggingLoginLogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllLoggingLoginLogQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllLoggingLoginLogQuery,
		GetAllLoggingLoginLogQueryVariables
	> &
		({ variables: GetAllLoggingLoginLogQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllLoggingLoginLogQuery, GetAllLoggingLoginLogQueryVariables>(
		GetAllLoggingLoginLogDocument,
		options
	);
}
export function useGetAllLoggingLoginLogLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllLoggingLoginLogQuery,
		GetAllLoggingLoginLogQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllLoggingLoginLogQuery, GetAllLoggingLoginLogQueryVariables>(
		GetAllLoggingLoginLogDocument,
		options
	);
}
// @ts-ignore
export function useGetAllLoggingLoginLogSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllLoggingLoginLogQuery,
		GetAllLoggingLoginLogQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetAllLoggingLoginLogQuery, GetAllLoggingLoginLogQueryVariables>;
export function useGetAllLoggingLoginLogSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLoggingLoginLogQuery,
				GetAllLoggingLoginLogQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllLoggingLoginLogQuery | undefined,
	GetAllLoggingLoginLogQueryVariables
>;
export function useGetAllLoggingLoginLogSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllLoggingLoginLogQuery,
				GetAllLoggingLoginLogQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllLoggingLoginLogQuery, GetAllLoggingLoginLogQueryVariables>(
		GetAllLoggingLoginLogDocument,
		options
	);
}
export type GetAllLoggingLoginLogQueryHookResult = ReturnType<typeof useGetAllLoggingLoginLogQuery>;
export type GetAllLoggingLoginLogLazyQueryHookResult = ReturnType<
	typeof useGetAllLoggingLoginLogLazyQuery
>;
export type GetAllLoggingLoginLogSuspenseQueryHookResult = ReturnType<
	typeof useGetAllLoggingLoginLogSuspenseQuery
>;
export type GetAllLoggingLoginLogQueryResult = Apollo.QueryResult<
	GetAllLoggingLoginLogQuery,
	GetAllLoggingLoginLogQueryVariables
>;
export const GetOrganizationSettingDocument = gql`
	query GetOrganizationSetting($organizationId: ID!) {
		getOrganizationSetting(organizationId: $organizationId) {
			id
			measurementSystem
			currency
			timezone
		}
	}
`;

/**
 * __useGetOrganizationSettingQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationSettingQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	> &
		({ variables: GetOrganizationSettingQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationSettingQuery, GetOrganizationSettingQueryVariables>(
		GetOrganizationSettingDocument,
		options
	);
}
export function useGetOrganizationSettingLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationSettingQuery, GetOrganizationSettingQueryVariables>(
		GetOrganizationSettingDocument,
		options
	);
}
// @ts-ignore
export function useGetOrganizationSettingSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetOrganizationSettingQuery, GetOrganizationSettingQueryVariables>;
export function useGetOrganizationSettingSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationSettingQuery,
				GetOrganizationSettingQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationSettingQuery | undefined,
	GetOrganizationSettingQueryVariables
>;
export function useGetOrganizationSettingSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationSettingQuery,
				GetOrganizationSettingQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationSettingQuery,
		GetOrganizationSettingQueryVariables
	>(GetOrganizationSettingDocument, options);
}
export type GetOrganizationSettingQueryHookResult = ReturnType<
	typeof useGetOrganizationSettingQuery
>;
export type GetOrganizationSettingLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationSettingLazyQuery
>;
export type GetOrganizationSettingSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationSettingSuspenseQuery
>;
export type GetOrganizationSettingQueryResult = Apollo.QueryResult<
	GetOrganizationSettingQuery,
	GetOrganizationSettingQueryVariables
>;
export const GetOrganizationApprovalAndMarginDocument = gql`
	query GetOrganizationApprovalAndMargin($organizationId: ID!) {
		getOrganizationApprovalAndMargin(organizationId: $organizationId) {
			organizationId
			defaultApproval
			defaultMargin
		}
	}
`;

/**
 * __useGetOrganizationApprovalAndMarginQuery__
 *
 * To run a query within a React component, call `useGetOrganizationApprovalAndMarginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationApprovalAndMarginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationApprovalAndMarginQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationApprovalAndMarginQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	> &
		(
			| { variables: GetOrganizationApprovalAndMarginQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>(GetOrganizationApprovalAndMarginDocument, options);
}
export function useGetOrganizationApprovalAndMarginLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>(GetOrganizationApprovalAndMarginDocument, options);
}
// @ts-ignore
export function useGetOrganizationApprovalAndMarginSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetOrganizationApprovalAndMarginQuery,
	GetOrganizationApprovalAndMarginQueryVariables
>;
export function useGetOrganizationApprovalAndMarginSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationApprovalAndMarginQuery,
				GetOrganizationApprovalAndMarginQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationApprovalAndMarginQuery | undefined,
	GetOrganizationApprovalAndMarginQueryVariables
>;
export function useGetOrganizationApprovalAndMarginSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationApprovalAndMarginQuery,
				GetOrganizationApprovalAndMarginQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationApprovalAndMarginQuery,
		GetOrganizationApprovalAndMarginQueryVariables
	>(GetOrganizationApprovalAndMarginDocument, options);
}
export type GetOrganizationApprovalAndMarginQueryHookResult = ReturnType<
	typeof useGetOrganizationApprovalAndMarginQuery
>;
export type GetOrganizationApprovalAndMarginLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationApprovalAndMarginLazyQuery
>;
export type GetOrganizationApprovalAndMarginSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationApprovalAndMarginSuspenseQuery
>;
export type GetOrganizationApprovalAndMarginQueryResult = Apollo.QueryResult<
	GetOrganizationApprovalAndMarginQuery,
	GetOrganizationApprovalAndMarginQueryVariables
>;
export const GetAllOrganizationUserDocument = gql`
	query GetAllOrganizationUser($input: GetAllOrganizationUserInput!) {
		getAllOrganizationUser(input: $input) {
			data {
				id
				firstName
				lastName
				jobPosition
				avatar
				createdAt
				updatedAt
				authenticationUser {
					id
					email
					role
					lockedAt
					lockReason
					lastActive
					isPremium
					premiumRequestedAt
					premiumApprovedAt
				}
				authorizationUserRoles {
					id
					userId
					authorizationRoleId
					authorizationRole {
						id
						name
						description
					}
				}
			}
			pageInfo {
				...PageInfoFragment
			}
			errors {
				...ResponseErrorFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
	${ResponseErrorFragmentFragmentDoc}
`;

/**
 * __useGetAllOrganizationUserQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	> &
		({ variables: GetAllOrganizationUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllOrganizationUserQuery, GetAllOrganizationUserQueryVariables>(
		GetAllOrganizationUserDocument,
		options
	);
}
export function useGetAllOrganizationUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllOrganizationUserQuery, GetAllOrganizationUserQueryVariables>(
		GetAllOrganizationUserDocument,
		options
	);
}
// @ts-ignore
export function useGetAllOrganizationUserSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetAllOrganizationUserQuery, GetAllOrganizationUserQueryVariables>;
export function useGetAllOrganizationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationUserQuery,
				GetAllOrganizationUserQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationUserQuery | undefined,
	GetAllOrganizationUserQueryVariables
>;
export function useGetAllOrganizationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationUserQuery,
				GetAllOrganizationUserQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationUserQuery,
		GetAllOrganizationUserQueryVariables
	>(GetAllOrganizationUserDocument, options);
}
export type GetAllOrganizationUserQueryHookResult = ReturnType<
	typeof useGetAllOrganizationUserQuery
>;
export type GetAllOrganizationUserLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationUserLazyQuery
>;
export type GetAllOrganizationUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationUserSuspenseQuery
>;
export type GetAllOrganizationUserQueryResult = Apollo.QueryResult<
	GetAllOrganizationUserQuery,
	GetAllOrganizationUserQueryVariables
>;
export const GetOrganizationUserDocument = gql`
	query GetOrganizationUser($userId: ID!) {
		getOrganizationUser(userId: $userId) {
			id
			firstName
			lastName
			jobPosition
			authenticationUser {
				id
				email
				role
			}
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetOrganizationUserQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOrganizationUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationUserQuery,
		GetOrganizationUserQueryVariables
	> &
		({ variables: GetOrganizationUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(
		GetOrganizationUserDocument,
		options
	);
}
export function useGetOrganizationUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationUserQuery,
		GetOrganizationUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(
		GetOrganizationUserDocument,
		options
	);
}
// @ts-ignore
export function useGetOrganizationUserSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationUserQuery,
		GetOrganizationUserQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>;
export function useGetOrganizationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserQuery,
				GetOrganizationUserQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationUserQuery | undefined,
	GetOrganizationUserQueryVariables
>;
export function useGetOrganizationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserQuery,
				GetOrganizationUserQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(
		GetOrganizationUserDocument,
		options
	);
}
export type GetOrganizationUserQueryHookResult = ReturnType<typeof useGetOrganizationUserQuery>;
export type GetOrganizationUserLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationUserLazyQuery
>;
export type GetOrganizationUserSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationUserSuspenseQuery
>;
export type GetOrganizationUserQueryResult = Apollo.QueryResult<
	GetOrganizationUserQuery,
	GetOrganizationUserQueryVariables
>;
export const GetOrganizationDocument = gql`
	query GetOrganization($id: ID!) {
		getOrganization(id: $id) {
			id
			name
			logo
			websiteUrl
			industry
			createdAt
			updatedAt
			addresses {
				id
				addressLine1
				addressLine2
				addressType
				city
				countryCode
				postalCode
				stateCode
				isPrimary
				name
				googlePlaceId
				latitude
				longitude
			}
		}
	}
`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(
	baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> &
		({ variables: GetOrganizationQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
		GetOrganizationDocument,
		options
	);
}
export function useGetOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
		GetOrganizationDocument,
		options
	);
}
// @ts-ignore
export function useGetOrganizationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationQuery,
		GetOrganizationQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export function useGetOrganizationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
): Apollo.UseSuspenseQueryResult<GetOrganizationQuery | undefined, GetOrganizationQueryVariables>;
export function useGetOrganizationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
		GetOrganizationDocument,
		options
	);
}
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationSuspenseQuery
>;
export type GetOrganizationQueryResult = Apollo.QueryResult<
	GetOrganizationQuery,
	GetOrganizationQueryVariables
>;
export const GetAllOrganizationDocument = gql`
	query GetAllOrganization($input: GetAllOrganizationInput!) {
		getAllOrganization(input: $input) {
			data {
				id
				name
				logo
				websiteUrl
				industry
				createdAt
				updatedAt
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationQuery,
		GetAllOrganizationQueryVariables
	> &
		({ variables: GetAllOrganizationQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>(
		GetAllOrganizationDocument,
		options
	);
}
export function useGetAllOrganizationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationQuery,
		GetAllOrganizationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>(
		GetAllOrganizationDocument,
		options
	);
}
// @ts-ignore
export function useGetAllOrganizationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllOrganizationQuery,
		GetAllOrganizationQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>;
export function useGetAllOrganizationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationQuery | undefined,
	GetAllOrganizationQueryVariables
>;
export function useGetAllOrganizationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllOrganizationQuery, GetAllOrganizationQueryVariables>(
		GetAllOrganizationDocument,
		options
	);
}
export type GetAllOrganizationQueryHookResult = ReturnType<typeof useGetAllOrganizationQuery>;
export type GetAllOrganizationLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationLazyQuery
>;
export type GetAllOrganizationSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationSuspenseQuery
>;
export type GetAllOrganizationQueryResult = Apollo.QueryResult<
	GetAllOrganizationQuery,
	GetAllOrganizationQueryVariables
>;
export const GetOrganizationWithSettingsDocument = gql`
	query GetOrganizationWithSettings($organizationId: ID!) {
		getOrganization(id: $organizationId) {
			id
			name
			logo
			websiteUrl
			industry
			createdAt
			updatedAt
			organizationSetting {
				id
				measurementSystem
				currency
				timezone
			}
			addresses {
				id
				addressLine1
				addressLine2
				addressType
				city
				countryCode
				postalCode
				stateCode
				isPrimary
				name
				googlePlaceId
				latitude
				longitude
			}
		}
	}
`;

/**
 * __useGetOrganizationWithSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationWithSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationWithSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationWithSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationWithSettingsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	> &
		(
			| { variables: GetOrganizationWithSettingsQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	>(GetOrganizationWithSettingsDocument, options);
}
export function useGetOrganizationWithSettingsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	>(GetOrganizationWithSettingsDocument, options);
}
// @ts-ignore
export function useGetOrganizationWithSettingsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetOrganizationWithSettingsQuery,
	GetOrganizationWithSettingsQueryVariables
>;
export function useGetOrganizationWithSettingsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationWithSettingsQuery,
				GetOrganizationWithSettingsQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationWithSettingsQuery | undefined,
	GetOrganizationWithSettingsQueryVariables
>;
export function useGetOrganizationWithSettingsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationWithSettingsQuery,
				GetOrganizationWithSettingsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationWithSettingsQuery,
		GetOrganizationWithSettingsQueryVariables
	>(GetOrganizationWithSettingsDocument, options);
}
export type GetOrganizationWithSettingsQueryHookResult = ReturnType<
	typeof useGetOrganizationWithSettingsQuery
>;
export type GetOrganizationWithSettingsLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationWithSettingsLazyQuery
>;
export type GetOrganizationWithSettingsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationWithSettingsSuspenseQuery
>;
export type GetOrganizationWithSettingsQueryResult = Apollo.QueryResult<
	GetOrganizationWithSettingsQuery,
	GetOrganizationWithSettingsQueryVariables
>;
export const GetOrganizationAddressesDocument = gql`
	query GetOrganizationAddresses($organizationId: ID!) {
		getOrganizationAddresses(organizationId: $organizationId) {
			id
			name
			addressLine1
			addressLine2
			city
			stateCode
			postalCode
			countryCode
			addressType
			isPrimary
		}
	}
`;

/**
 * __useGetOrganizationAddressesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAddressesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationAddressesQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	> &
		({ variables: GetOrganizationAddressesQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>(
		GetOrganizationAddressesDocument,
		options
	);
}
export function useGetOrganizationAddressesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>(GetOrganizationAddressesDocument, options);
}
// @ts-ignore
export function useGetOrganizationAddressesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetOrganizationAddressesQuery,
	GetOrganizationAddressesQueryVariables
>;
export function useGetOrganizationAddressesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationAddressesQuery,
				GetOrganizationAddressesQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationAddressesQuery | undefined,
	GetOrganizationAddressesQueryVariables
>;
export function useGetOrganizationAddressesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationAddressesQuery,
				GetOrganizationAddressesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationAddressesQuery,
		GetOrganizationAddressesQueryVariables
	>(GetOrganizationAddressesDocument, options);
}
export type GetOrganizationAddressesQueryHookResult = ReturnType<
	typeof useGetOrganizationAddressesQuery
>;
export type GetOrganizationAddressesLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationAddressesLazyQuery
>;
export type GetOrganizationAddressesSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationAddressesSuspenseQuery
>;
export type GetOrganizationAddressesQueryResult = Apollo.QueryResult<
	GetOrganizationAddressesQuery,
	GetOrganizationAddressesQueryVariables
>;
export const GetOrganizationUserAvatarDownloadUrlDocument = gql`
	query GetOrganizationUserAvatarDownloadUrl($input: GetDownloadUrlInput!) {
		getOrganizationUserAvatarDownloadUrl(input: $input) {
			success
			message
			downloadUrl
			expiresAt
			errors {
				message
				field
				code
			}
		}
	}
`;

/**
 * __useGetOrganizationUserAvatarDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserAvatarDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserAvatarDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserAvatarDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganizationUserAvatarDownloadUrlQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	> &
		(
			| { variables: GetOrganizationUserAvatarDownloadUrlQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	>(GetOrganizationUserAvatarDownloadUrlDocument, options);
}
export function useGetOrganizationUserAvatarDownloadUrlLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	>(GetOrganizationUserAvatarDownloadUrlDocument, options);
}
// @ts-ignore
export function useGetOrganizationUserAvatarDownloadUrlSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetOrganizationUserAvatarDownloadUrlQuery,
	GetOrganizationUserAvatarDownloadUrlQueryVariables
>;
export function useGetOrganizationUserAvatarDownloadUrlSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserAvatarDownloadUrlQuery,
				GetOrganizationUserAvatarDownloadUrlQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationUserAvatarDownloadUrlQuery | undefined,
	GetOrganizationUserAvatarDownloadUrlQueryVariables
>;
export function useGetOrganizationUserAvatarDownloadUrlSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserAvatarDownloadUrlQuery,
				GetOrganizationUserAvatarDownloadUrlQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationUserAvatarDownloadUrlQuery,
		GetOrganizationUserAvatarDownloadUrlQueryVariables
	>(GetOrganizationUserAvatarDownloadUrlDocument, options);
}
export type GetOrganizationUserAvatarDownloadUrlQueryHookResult = ReturnType<
	typeof useGetOrganizationUserAvatarDownloadUrlQuery
>;
export type GetOrganizationUserAvatarDownloadUrlLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationUserAvatarDownloadUrlLazyQuery
>;
export type GetOrganizationUserAvatarDownloadUrlSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationUserAvatarDownloadUrlSuspenseQuery
>;
export type GetOrganizationUserAvatarDownloadUrlQueryResult = Apollo.QueryResult<
	GetOrganizationUserAvatarDownloadUrlQuery,
	GetOrganizationUserAvatarDownloadUrlQueryVariables
>;
export const GetOrganizationUserDetailsDocument = gql`
	query GetOrganizationUserDetails($userId: ID!) {
		getOrganizationUser(userId: $userId) {
			id
			firstName
			lastName
			jobPosition
			avatar
			createdAt
			updatedAt
			organizationId
			userId
			roles
			authenticationUser {
				id
				email
				language
				role
				mfaEnabled
				mfaMethod
				lockReason
				lockedAt
				createdAt
				updatedAt
			}
			organization {
				id
				name
				industry
				websiteUrl
				logo
			}
			authorizationUserRoles {
				id
				authorizationRoleId
				createdAt
				authorizationRole {
					id
					name
					description
					scope
				}
			}
		}
	}
`;

/**
 * __useGetOrganizationUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOrganizationUserDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	> &
		(
			| { variables: GetOrganizationUserDetailsQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	>(GetOrganizationUserDetailsDocument, options);
}
export function useGetOrganizationUserDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	>(GetOrganizationUserDetailsDocument, options);
}
// @ts-ignore
export function useGetOrganizationUserDetailsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetOrganizationUserDetailsQuery,
	GetOrganizationUserDetailsQueryVariables
>;
export function useGetOrganizationUserDetailsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserDetailsQuery,
				GetOrganizationUserDetailsQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationUserDetailsQuery | undefined,
	GetOrganizationUserDetailsQueryVariables
>;
export function useGetOrganizationUserDetailsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationUserDetailsQuery,
				GetOrganizationUserDetailsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationUserDetailsQuery,
		GetOrganizationUserDetailsQueryVariables
	>(GetOrganizationUserDetailsDocument, options);
}
export type GetOrganizationUserDetailsQueryHookResult = ReturnType<
	typeof useGetOrganizationUserDetailsQuery
>;
export type GetOrganizationUserDetailsLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationUserDetailsLazyQuery
>;
export type GetOrganizationUserDetailsSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationUserDetailsSuspenseQuery
>;
export type GetOrganizationUserDetailsQueryResult = Apollo.QueryResult<
	GetOrganizationUserDetailsQuery,
	GetOrganizationUserDetailsQueryVariables
>;
export const UpdateOrganizationUserDocument = gql`
	mutation UpdateOrganizationUser($input: OrganizationUserUpdateInput!) {
		updateOrganizationUser(input: $input) {
			success
			message
			messageKey
		}
	}
`;
export type UpdateOrganizationUserMutationFn = Apollo.MutationFunction<
	UpdateOrganizationUserMutation,
	UpdateOrganizationUserMutationVariables
>;

/**
 * __useUpdateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserMutation, { data, loading, error }] = useUpdateOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationUserMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateOrganizationUserMutation,
		UpdateOrganizationUserMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateOrganizationUserMutation,
		UpdateOrganizationUserMutationVariables
	>(UpdateOrganizationUserDocument, options);
}
export type UpdateOrganizationUserMutationHookResult = ReturnType<
	typeof useUpdateOrganizationUserMutation
>;
export type UpdateOrganizationUserMutationResult =
	Apollo.MutationResult<UpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<
	UpdateOrganizationUserMutation,
	UpdateOrganizationUserMutationVariables
>;
export const GetUserAuditLogsDocument = gql`
	query GetUserAuditLogs($input: GetAllLoggingAuditLogInput!) {
		getAllLoggingAuditLog(input: $input) {
			data {
				id
				action
				resource
				resourceId
				description
				status
				serviceName
				changes
				metadata
				createdAt
				userId
				organizationId
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetUserAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetUserAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAuditLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserAuditLogsQuery(
	baseOptions: Apollo.QueryHookOptions<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables> &
		({ variables: GetUserAuditLogsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>(
		GetUserAuditLogsDocument,
		options
	);
}
export function useGetUserAuditLogsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>(
		GetUserAuditLogsDocument,
		options
	);
}
// @ts-ignore
export function useGetUserAuditLogsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetUserAuditLogsQuery,
		GetUserAuditLogsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>;
export function useGetUserAuditLogsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetUserAuditLogsQuery | undefined, GetUserAuditLogsQueryVariables>;
export function useGetUserAuditLogsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetUserAuditLogsQuery, GetUserAuditLogsQueryVariables>(
		GetUserAuditLogsDocument,
		options
	);
}
export type GetUserAuditLogsQueryHookResult = ReturnType<typeof useGetUserAuditLogsQuery>;
export type GetUserAuditLogsLazyQueryHookResult = ReturnType<typeof useGetUserAuditLogsLazyQuery>;
export type GetUserAuditLogsSuspenseQueryHookResult = ReturnType<
	typeof useGetUserAuditLogsSuspenseQuery
>;
export type GetUserAuditLogsQueryResult = Apollo.QueryResult<
	GetUserAuditLogsQuery,
	GetUserAuditLogsQueryVariables
>;
export const GetUserLoginLogsDocument = gql`
	query GetUserLoginLogs($input: GetAllLoggingLoginLogInput!) {
		getAllLoggingLoginLog(input: $input) {
			data {
				id
				method
				status
				failureReason
				ipAddress
				userAgent
				browser
				os
				createdAt
				userId
				referenceId
				serviceId
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetUserLoginLogsQuery__
 *
 * To run a query within a React component, call `useGetUserLoginLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLoginLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLoginLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserLoginLogsQuery(
	baseOptions: Apollo.QueryHookOptions<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables> &
		({ variables: GetUserLoginLogsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>(
		GetUserLoginLogsDocument,
		options
	);
}
export function useGetUserLoginLogsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>(
		GetUserLoginLogsDocument,
		options
	);
}
// @ts-ignore
export function useGetUserLoginLogsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetUserLoginLogsQuery,
		GetUserLoginLogsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>;
export function useGetUserLoginLogsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetUserLoginLogsQuery | undefined, GetUserLoginLogsQueryVariables>;
export function useGetUserLoginLogsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetUserLoginLogsQuery, GetUserLoginLogsQueryVariables>(
		GetUserLoginLogsDocument,
		options
	);
}
export type GetUserLoginLogsQueryHookResult = ReturnType<typeof useGetUserLoginLogsQuery>;
export type GetUserLoginLogsLazyQueryHookResult = ReturnType<typeof useGetUserLoginLogsLazyQuery>;
export type GetUserLoginLogsSuspenseQueryHookResult = ReturnType<
	typeof useGetUserLoginLogsSuspenseQuery
>;
export type GetUserLoginLogsQueryResult = Apollo.QueryResult<
	GetUserLoginLogsQuery,
	GetUserLoginLogsQueryVariables
>;
export const GetUserDepartmentsDocument = gql`
	query GetUserDepartments($organizationUserId: ID!) {
		getAllOrganizationDepartmentUser(
			input: {
				organizationUserId: $organizationUserId
				pagination: { currentPage: 1, limit: 100 }
			}
		) {
			data {
				id
				role
				title
				department {
					id
					name
					description
					level
				}
			}
		}
	}
`;

/**
 * __useGetUserDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetUserDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDepartmentsQuery({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *   },
 * });
 */
export function useGetUserDepartmentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetUserDepartmentsQuery,
		GetUserDepartmentsQueryVariables
	> &
		({ variables: GetUserDepartmentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetUserDepartmentsQuery, GetUserDepartmentsQueryVariables>(
		GetUserDepartmentsDocument,
		options
	);
}
export function useGetUserDepartmentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetUserDepartmentsQuery,
		GetUserDepartmentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetUserDepartmentsQuery, GetUserDepartmentsQueryVariables>(
		GetUserDepartmentsDocument,
		options
	);
}
// @ts-ignore
export function useGetUserDepartmentsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetUserDepartmentsQuery,
		GetUserDepartmentsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetUserDepartmentsQuery, GetUserDepartmentsQueryVariables>;
export function useGetUserDepartmentsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserDepartmentsQuery, GetUserDepartmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<
	GetUserDepartmentsQuery | undefined,
	GetUserDepartmentsQueryVariables
>;
export function useGetUserDepartmentsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserDepartmentsQuery, GetUserDepartmentsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetUserDepartmentsQuery, GetUserDepartmentsQueryVariables>(
		GetUserDepartmentsDocument,
		options
	);
}
export type GetUserDepartmentsQueryHookResult = ReturnType<typeof useGetUserDepartmentsQuery>;
export type GetUserDepartmentsLazyQueryHookResult = ReturnType<
	typeof useGetUserDepartmentsLazyQuery
>;
export type GetUserDepartmentsSuspenseQueryHookResult = ReturnType<
	typeof useGetUserDepartmentsSuspenseQuery
>;
export type GetUserDepartmentsQueryResult = Apollo.QueryResult<
	GetUserDepartmentsQuery,
	GetUserDepartmentsQueryVariables
>;
export const GetUserTeamsDocument = gql`
	query GetUserTeams($organizationUserId: ID!) {
		getAllOrganizationTeamUser(
			input: {
				organizationUserId: $organizationUserId
				pagination: { currentPage: 1, limit: 100 }
			}
		) {
			data {
				id
				role
				title
				team {
					id
					name
					description
					department {
						id
						name
					}
				}
			}
		}
	}
`;

/**
 * __useGetUserTeamsQuery__
 *
 * To run a query within a React component, call `useGetUserTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTeamsQuery({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *   },
 * });
 */
export function useGetUserTeamsQuery(
	baseOptions: Apollo.QueryHookOptions<GetUserTeamsQuery, GetUserTeamsQueryVariables> &
		({ variables: GetUserTeamsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetUserTeamsQuery, GetUserTeamsQueryVariables>(
		GetUserTeamsDocument,
		options
	);
}
export function useGetUserTeamsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetUserTeamsQuery, GetUserTeamsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetUserTeamsQuery, GetUserTeamsQueryVariables>(
		GetUserTeamsDocument,
		options
	);
}
// @ts-ignore
export function useGetUserTeamsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserTeamsQuery, GetUserTeamsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetUserTeamsQuery, GetUserTeamsQueryVariables>;
export function useGetUserTeamsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserTeamsQuery, GetUserTeamsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetUserTeamsQuery | undefined, GetUserTeamsQueryVariables>;
export function useGetUserTeamsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetUserTeamsQuery, GetUserTeamsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetUserTeamsQuery, GetUserTeamsQueryVariables>(
		GetUserTeamsDocument,
		options
	);
}
export type GetUserTeamsQueryHookResult = ReturnType<typeof useGetUserTeamsQuery>;
export type GetUserTeamsLazyQueryHookResult = ReturnType<typeof useGetUserTeamsLazyQuery>;
export type GetUserTeamsSuspenseQueryHookResult = ReturnType<typeof useGetUserTeamsSuspenseQuery>;
export type GetUserTeamsQueryResult = Apollo.QueryResult<
	GetUserTeamsQuery,
	GetUserTeamsQueryVariables
>;
export const GetAllOrganizationDepartmentsDocument = gql`
	query GetAllOrganizationDepartments($input: GetAllOrganizationDepartmentInput!) {
		getAllOrganizationDepartment(input: $input) {
			data {
				id
				createdAt
				updatedAt
				name
				description
				level
				organizationId
				parentDepartmentId
				parentDepartment {
					id
					name
				}
				organization {
					id
					name
				}
				subDepartments {
					id
					name
					level
				}
				teams {
					id
					name
					description
				}
				users {
					id
					role
					title
					organizationUser {
						id
						firstName
						lastName
						jobPosition
						authenticationUser {
							email
						}
					}
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllOrganizationDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationDepartmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationDepartmentsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationDepartmentsQuery,
		GetAllOrganizationDepartmentsQueryVariables
	> &
		(
			| { variables: GetAllOrganizationDepartmentsQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllOrganizationDepartmentsQuery,
		GetAllOrganizationDepartmentsQueryVariables
	>(GetAllOrganizationDepartmentsDocument, options);
}
export function useGetAllOrganizationDepartmentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationDepartmentsQuery,
		GetAllOrganizationDepartmentsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllOrganizationDepartmentsQuery,
		GetAllOrganizationDepartmentsQueryVariables
	>(GetAllOrganizationDepartmentsDocument, options);
}
// @ts-ignore
export function useGetAllOrganizationDepartmentsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllOrganizationDepartmentsQuery,
		GetAllOrganizationDepartmentsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationDepartmentsQuery,
	GetAllOrganizationDepartmentsQueryVariables
>;
export function useGetAllOrganizationDepartmentsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationDepartmentsQuery,
				GetAllOrganizationDepartmentsQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationDepartmentsQuery | undefined,
	GetAllOrganizationDepartmentsQueryVariables
>;
export function useGetAllOrganizationDepartmentsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationDepartmentsQuery,
				GetAllOrganizationDepartmentsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationDepartmentsQuery,
		GetAllOrganizationDepartmentsQueryVariables
	>(GetAllOrganizationDepartmentsDocument, options);
}
export type GetAllOrganizationDepartmentsQueryHookResult = ReturnType<
	typeof useGetAllOrganizationDepartmentsQuery
>;
export type GetAllOrganizationDepartmentsLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationDepartmentsLazyQuery
>;
export type GetAllOrganizationDepartmentsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationDepartmentsSuspenseQuery
>;
export type GetAllOrganizationDepartmentsQueryResult = Apollo.QueryResult<
	GetAllOrganizationDepartmentsQuery,
	GetAllOrganizationDepartmentsQueryVariables
>;
export const GetOrganizationDepartmentDocument = gql`
	query GetOrganizationDepartment($id: ID!) {
		getOrganizationDepartment(id: $id) {
			id
			createdAt
			updatedAt
			name
			description
			level
			organizationId
			parentDepartmentId
			parentDepartment {
				id
				name
			}
			organization {
				id
				name
			}
			subDepartments {
				id
				name
				level
			}
			teams {
				id
				name
				description
			}
			users {
				id
				role
				title
				organizationUser {
					id
					firstName
					lastName
					jobPosition
					authenticationUser {
						email
					}
				}
			}
		}
	}
`;

/**
 * __useGetOrganizationDepartmentQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDepartmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationDepartmentQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationDepartmentQuery,
		GetOrganizationDepartmentQueryVariables
	> &
		({ variables: GetOrganizationDepartmentQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationDepartmentQuery, GetOrganizationDepartmentQueryVariables>(
		GetOrganizationDepartmentDocument,
		options
	);
}
export function useGetOrganizationDepartmentLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationDepartmentQuery,
		GetOrganizationDepartmentQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationDepartmentQuery,
		GetOrganizationDepartmentQueryVariables
	>(GetOrganizationDepartmentDocument, options);
}
// @ts-ignore
export function useGetOrganizationDepartmentSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationDepartmentQuery,
		GetOrganizationDepartmentQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetOrganizationDepartmentQuery,
	GetOrganizationDepartmentQueryVariables
>;
export function useGetOrganizationDepartmentSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationDepartmentQuery,
				GetOrganizationDepartmentQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationDepartmentQuery | undefined,
	GetOrganizationDepartmentQueryVariables
>;
export function useGetOrganizationDepartmentSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationDepartmentQuery,
				GetOrganizationDepartmentQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationDepartmentQuery,
		GetOrganizationDepartmentQueryVariables
	>(GetOrganizationDepartmentDocument, options);
}
export type GetOrganizationDepartmentQueryHookResult = ReturnType<
	typeof useGetOrganizationDepartmentQuery
>;
export type GetOrganizationDepartmentLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationDepartmentLazyQuery
>;
export type GetOrganizationDepartmentSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationDepartmentSuspenseQuery
>;
export type GetOrganizationDepartmentQueryResult = Apollo.QueryResult<
	GetOrganizationDepartmentQuery,
	GetOrganizationDepartmentQueryVariables
>;
export const GetOrganizationDepartmentHierarchyDocument = gql`
	query GetOrganizationDepartmentHierarchy($organizationId: ID!) {
		getOrganizationDepartmentHierarchy(organizationId: $organizationId) {
			id
			name
			description
			level
			parentDepartmentId
			subDepartments {
				id
				name
				description
				level
				parentDepartmentId
			}
		}
	}
`;

/**
 * __useGetOrganizationDepartmentHierarchyQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDepartmentHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDepartmentHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDepartmentHierarchyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationDepartmentHierarchyQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationDepartmentHierarchyQuery,
		GetOrganizationDepartmentHierarchyQueryVariables
	> &
		(
			| { variables: GetOrganizationDepartmentHierarchyQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetOrganizationDepartmentHierarchyQuery,
		GetOrganizationDepartmentHierarchyQueryVariables
	>(GetOrganizationDepartmentHierarchyDocument, options);
}
export function useGetOrganizationDepartmentHierarchyLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationDepartmentHierarchyQuery,
		GetOrganizationDepartmentHierarchyQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetOrganizationDepartmentHierarchyQuery,
		GetOrganizationDepartmentHierarchyQueryVariables
	>(GetOrganizationDepartmentHierarchyDocument, options);
}
// @ts-ignore
export function useGetOrganizationDepartmentHierarchySuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationDepartmentHierarchyQuery,
		GetOrganizationDepartmentHierarchyQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetOrganizationDepartmentHierarchyQuery,
	GetOrganizationDepartmentHierarchyQueryVariables
>;
export function useGetOrganizationDepartmentHierarchySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationDepartmentHierarchyQuery,
				GetOrganizationDepartmentHierarchyQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationDepartmentHierarchyQuery | undefined,
	GetOrganizationDepartmentHierarchyQueryVariables
>;
export function useGetOrganizationDepartmentHierarchySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationDepartmentHierarchyQuery,
				GetOrganizationDepartmentHierarchyQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetOrganizationDepartmentHierarchyQuery,
		GetOrganizationDepartmentHierarchyQueryVariables
	>(GetOrganizationDepartmentHierarchyDocument, options);
}
export type GetOrganizationDepartmentHierarchyQueryHookResult = ReturnType<
	typeof useGetOrganizationDepartmentHierarchyQuery
>;
export type GetOrganizationDepartmentHierarchyLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationDepartmentHierarchyLazyQuery
>;
export type GetOrganizationDepartmentHierarchySuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationDepartmentHierarchySuspenseQuery
>;
export type GetOrganizationDepartmentHierarchyQueryResult = Apollo.QueryResult<
	GetOrganizationDepartmentHierarchyQuery,
	GetOrganizationDepartmentHierarchyQueryVariables
>;
export const GetAllOrganizationDepartmentUsersDocument = gql`
	query GetAllOrganizationDepartmentUsers($input: GetAllOrganizationDepartmentUserInput!) {
		getAllOrganizationDepartmentUser(input: $input) {
			data {
				id
				role
				title
				departmentId
				organizationUserId
				department {
					id
					name
				}
				organizationUser {
					id
					firstName
					lastName
					jobPosition
					authenticationUser {
						email
					}
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllOrganizationDepartmentUsersQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationDepartmentUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationDepartmentUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationDepartmentUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationDepartmentUsersQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationDepartmentUsersQuery,
		GetAllOrganizationDepartmentUsersQueryVariables
	> &
		(
			| { variables: GetAllOrganizationDepartmentUsersQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllOrganizationDepartmentUsersQuery,
		GetAllOrganizationDepartmentUsersQueryVariables
	>(GetAllOrganizationDepartmentUsersDocument, options);
}
export function useGetAllOrganizationDepartmentUsersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationDepartmentUsersQuery,
		GetAllOrganizationDepartmentUsersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllOrganizationDepartmentUsersQuery,
		GetAllOrganizationDepartmentUsersQueryVariables
	>(GetAllOrganizationDepartmentUsersDocument, options);
}
// @ts-ignore
export function useGetAllOrganizationDepartmentUsersSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllOrganizationDepartmentUsersQuery,
		GetAllOrganizationDepartmentUsersQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationDepartmentUsersQuery,
	GetAllOrganizationDepartmentUsersQueryVariables
>;
export function useGetAllOrganizationDepartmentUsersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationDepartmentUsersQuery,
				GetAllOrganizationDepartmentUsersQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationDepartmentUsersQuery | undefined,
	GetAllOrganizationDepartmentUsersQueryVariables
>;
export function useGetAllOrganizationDepartmentUsersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationDepartmentUsersQuery,
				GetAllOrganizationDepartmentUsersQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationDepartmentUsersQuery,
		GetAllOrganizationDepartmentUsersQueryVariables
	>(GetAllOrganizationDepartmentUsersDocument, options);
}
export type GetAllOrganizationDepartmentUsersQueryHookResult = ReturnType<
	typeof useGetAllOrganizationDepartmentUsersQuery
>;
export type GetAllOrganizationDepartmentUsersLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationDepartmentUsersLazyQuery
>;
export type GetAllOrganizationDepartmentUsersSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationDepartmentUsersSuspenseQuery
>;
export type GetAllOrganizationDepartmentUsersQueryResult = Apollo.QueryResult<
	GetAllOrganizationDepartmentUsersQuery,
	GetAllOrganizationDepartmentUsersQueryVariables
>;
export const GetDepartmentLeadersDocument = gql`
	query GetDepartmentLeaders($departmentId: ID!) {
		getDepartmentLeaders(departmentId: $departmentId) {
			id
			role
			title
			organizationUser {
				id
				firstName
				lastName
				jobPosition
				authenticationUser {
					email
				}
			}
		}
	}
`;

/**
 * __useGetDepartmentLeadersQuery__
 *
 * To run a query within a React component, call `useGetDepartmentLeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentLeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentLeadersQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useGetDepartmentLeadersQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetDepartmentLeadersQuery,
		GetDepartmentLeadersQueryVariables
	> &
		({ variables: GetDepartmentLeadersQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetDepartmentLeadersQuery, GetDepartmentLeadersQueryVariables>(
		GetDepartmentLeadersDocument,
		options
	);
}
export function useGetDepartmentLeadersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetDepartmentLeadersQuery,
		GetDepartmentLeadersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetDepartmentLeadersQuery, GetDepartmentLeadersQueryVariables>(
		GetDepartmentLeadersDocument,
		options
	);
}
// @ts-ignore
export function useGetDepartmentLeadersSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetDepartmentLeadersQuery,
		GetDepartmentLeadersQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetDepartmentLeadersQuery, GetDepartmentLeadersQueryVariables>;
export function useGetDepartmentLeadersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetDepartmentLeadersQuery,
				GetDepartmentLeadersQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetDepartmentLeadersQuery | undefined,
	GetDepartmentLeadersQueryVariables
>;
export function useGetDepartmentLeadersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetDepartmentLeadersQuery,
				GetDepartmentLeadersQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetDepartmentLeadersQuery, GetDepartmentLeadersQueryVariables>(
		GetDepartmentLeadersDocument,
		options
	);
}
export type GetDepartmentLeadersQueryHookResult = ReturnType<typeof useGetDepartmentLeadersQuery>;
export type GetDepartmentLeadersLazyQueryHookResult = ReturnType<
	typeof useGetDepartmentLeadersLazyQuery
>;
export type GetDepartmentLeadersSuspenseQueryHookResult = ReturnType<
	typeof useGetDepartmentLeadersSuspenseQuery
>;
export type GetDepartmentLeadersQueryResult = Apollo.QueryResult<
	GetDepartmentLeadersQuery,
	GetDepartmentLeadersQueryVariables
>;
export const GetAllOrganizationTeamsDocument = gql`
	query GetAllOrganizationTeams($input: GetAllOrganizationTeamInput!) {
		getAllOrganizationTeam(input: $input) {
			data {
				id
				createdAt
				updatedAt
				name
				description
				organizationId
				departmentId
				department {
					id
					name
					level
				}
				organization {
					id
					name
				}
				users {
					id
					role
					title
					organizationUser {
						id
						firstName
						lastName
						jobPosition
						authenticationUser {
							email
						}
					}
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllOrganizationTeamsQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationTeamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationTeamsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationTeamsQuery,
		GetAllOrganizationTeamsQueryVariables
	> &
		({ variables: GetAllOrganizationTeamsQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllOrganizationTeamsQuery, GetAllOrganizationTeamsQueryVariables>(
		GetAllOrganizationTeamsDocument,
		options
	);
}
export function useGetAllOrganizationTeamsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationTeamsQuery,
		GetAllOrganizationTeamsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllOrganizationTeamsQuery, GetAllOrganizationTeamsQueryVariables>(
		GetAllOrganizationTeamsDocument,
		options
	);
}
// @ts-ignore
export function useGetAllOrganizationTeamsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllOrganizationTeamsQuery,
		GetAllOrganizationTeamsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationTeamsQuery,
	GetAllOrganizationTeamsQueryVariables
>;
export function useGetAllOrganizationTeamsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationTeamsQuery,
				GetAllOrganizationTeamsQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationTeamsQuery | undefined,
	GetAllOrganizationTeamsQueryVariables
>;
export function useGetAllOrganizationTeamsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationTeamsQuery,
				GetAllOrganizationTeamsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationTeamsQuery,
		GetAllOrganizationTeamsQueryVariables
	>(GetAllOrganizationTeamsDocument, options);
}
export type GetAllOrganizationTeamsQueryHookResult = ReturnType<
	typeof useGetAllOrganizationTeamsQuery
>;
export type GetAllOrganizationTeamsLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationTeamsLazyQuery
>;
export type GetAllOrganizationTeamsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationTeamsSuspenseQuery
>;
export type GetAllOrganizationTeamsQueryResult = Apollo.QueryResult<
	GetAllOrganizationTeamsQuery,
	GetAllOrganizationTeamsQueryVariables
>;
export const GetOrganizationTeamDocument = gql`
	query GetOrganizationTeam($id: ID!) {
		getOrganizationTeam(id: $id) {
			id
			createdAt
			updatedAt
			name
			description
			organizationId
			departmentId
			department {
				id
				name
				level
			}
			organization {
				id
				name
			}
			users {
				id
				role
				title
				organizationUser {
					id
					firstName
					lastName
					jobPosition
					authenticationUser {
						email
					}
				}
			}
		}
	}
`;

/**
 * __useGetOrganizationTeamQuery__
 *
 * To run a query within a React component, call `useGetOrganizationTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationTeamQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetOrganizationTeamQuery,
		GetOrganizationTeamQueryVariables
	> &
		({ variables: GetOrganizationTeamQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetOrganizationTeamQuery, GetOrganizationTeamQueryVariables>(
		GetOrganizationTeamDocument,
		options
	);
}
export function useGetOrganizationTeamLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetOrganizationTeamQuery,
		GetOrganizationTeamQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetOrganizationTeamQuery, GetOrganizationTeamQueryVariables>(
		GetOrganizationTeamDocument,
		options
	);
}
// @ts-ignore
export function useGetOrganizationTeamSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetOrganizationTeamQuery,
		GetOrganizationTeamQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetOrganizationTeamQuery, GetOrganizationTeamQueryVariables>;
export function useGetOrganizationTeamSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationTeamQuery,
				GetOrganizationTeamQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetOrganizationTeamQuery | undefined,
	GetOrganizationTeamQueryVariables
>;
export function useGetOrganizationTeamSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetOrganizationTeamQuery,
				GetOrganizationTeamQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetOrganizationTeamQuery, GetOrganizationTeamQueryVariables>(
		GetOrganizationTeamDocument,
		options
	);
}
export type GetOrganizationTeamQueryHookResult = ReturnType<typeof useGetOrganizationTeamQuery>;
export type GetOrganizationTeamLazyQueryHookResult = ReturnType<
	typeof useGetOrganizationTeamLazyQuery
>;
export type GetOrganizationTeamSuspenseQueryHookResult = ReturnType<
	typeof useGetOrganizationTeamSuspenseQuery
>;
export type GetOrganizationTeamQueryResult = Apollo.QueryResult<
	GetOrganizationTeamQuery,
	GetOrganizationTeamQueryVariables
>;
export const GetAllOrganizationTeamUsersDocument = gql`
	query GetAllOrganizationTeamUsers($input: GetAllOrganizationTeamUserInput!) {
		getAllOrganizationTeamUser(input: $input) {
			data {
				id
				role
				title
				teamId
				organizationUserId
				team {
					id
					name
					department {
						id
						name
					}
				}
				organizationUser {
					id
					firstName
					lastName
					jobPosition
					authenticationUser {
						email
					}
				}
			}
			pageInfo {
				currentPage
				totalPages
				totalCount
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

/**
 * __useGetAllOrganizationTeamUsersQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationTeamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationTeamUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationTeamUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllOrganizationTeamUsersQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllOrganizationTeamUsersQuery,
		GetAllOrganizationTeamUsersQueryVariables
	> &
		(
			| { variables: GetAllOrganizationTeamUsersQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllOrganizationTeamUsersQuery,
		GetAllOrganizationTeamUsersQueryVariables
	>(GetAllOrganizationTeamUsersDocument, options);
}
export function useGetAllOrganizationTeamUsersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllOrganizationTeamUsersQuery,
		GetAllOrganizationTeamUsersQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllOrganizationTeamUsersQuery,
		GetAllOrganizationTeamUsersQueryVariables
	>(GetAllOrganizationTeamUsersDocument, options);
}
// @ts-ignore
export function useGetAllOrganizationTeamUsersSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllOrganizationTeamUsersQuery,
		GetAllOrganizationTeamUsersQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationTeamUsersQuery,
	GetAllOrganizationTeamUsersQueryVariables
>;
export function useGetAllOrganizationTeamUsersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationTeamUsersQuery,
				GetAllOrganizationTeamUsersQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllOrganizationTeamUsersQuery | undefined,
	GetAllOrganizationTeamUsersQueryVariables
>;
export function useGetAllOrganizationTeamUsersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllOrganizationTeamUsersQuery,
				GetAllOrganizationTeamUsersQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllOrganizationTeamUsersQuery,
		GetAllOrganizationTeamUsersQueryVariables
	>(GetAllOrganizationTeamUsersDocument, options);
}
export type GetAllOrganizationTeamUsersQueryHookResult = ReturnType<
	typeof useGetAllOrganizationTeamUsersQuery
>;
export type GetAllOrganizationTeamUsersLazyQueryHookResult = ReturnType<
	typeof useGetAllOrganizationTeamUsersLazyQuery
>;
export type GetAllOrganizationTeamUsersSuspenseQueryHookResult = ReturnType<
	typeof useGetAllOrganizationTeamUsersSuspenseQuery
>;
export type GetAllOrganizationTeamUsersQueryResult = Apollo.QueryResult<
	GetAllOrganizationTeamUsersQuery,
	GetAllOrganizationTeamUsersQueryVariables
>;
export const GetTeamLeadersDocument = gql`
	query GetTeamLeaders($teamId: ID!) {
		getTeamLeaders(teamId: $teamId) {
			id
			role
			title
			organizationUser {
				id
				firstName
				lastName
				jobPosition
				authenticationUser {
					email
				}
			}
		}
	}
`;

/**
 * __useGetTeamLeadersQuery__
 *
 * To run a query within a React component, call `useGetTeamLeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamLeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamLeadersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamLeadersQuery(
	baseOptions: Apollo.QueryHookOptions<GetTeamLeadersQuery, GetTeamLeadersQueryVariables> &
		({ variables: GetTeamLeadersQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetTeamLeadersQuery, GetTeamLeadersQueryVariables>(
		GetTeamLeadersDocument,
		options
	);
}
export function useGetTeamLeadersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetTeamLeadersQuery, GetTeamLeadersQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetTeamLeadersQuery, GetTeamLeadersQueryVariables>(
		GetTeamLeadersDocument,
		options
	);
}
// @ts-ignore
export function useGetTeamLeadersSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamLeadersQuery, GetTeamLeadersQueryVariables>
): Apollo.UseSuspenseQueryResult<GetTeamLeadersQuery, GetTeamLeadersQueryVariables>;
export function useGetTeamLeadersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetTeamLeadersQuery, GetTeamLeadersQueryVariables>
): Apollo.UseSuspenseQueryResult<GetTeamLeadersQuery | undefined, GetTeamLeadersQueryVariables>;
export function useGetTeamLeadersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetTeamLeadersQuery, GetTeamLeadersQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetTeamLeadersQuery, GetTeamLeadersQueryVariables>(
		GetTeamLeadersDocument,
		options
	);
}
export type GetTeamLeadersQueryHookResult = ReturnType<typeof useGetTeamLeadersQuery>;
export type GetTeamLeadersLazyQueryHookResult = ReturnType<typeof useGetTeamLeadersLazyQuery>;
export type GetTeamLeadersSuspenseQueryHookResult = ReturnType<
	typeof useGetTeamLeadersSuspenseQuery
>;
export type GetTeamLeadersQueryResult = Apollo.QueryResult<
	GetTeamLeadersQuery,
	GetTeamLeadersQueryVariables
>;
export const GetSupportedLanguagesDocument = gql`
	query GetSupportedLanguages {
		getSupportedLanguages {
			code
			name
			nativeName
		}
	}
`;

/**
 * __useGetSupportedLanguagesQuery__
 *
 * To run a query within a React component, call `useGetSupportedLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportedLanguagesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetSupportedLanguagesQuery,
		GetSupportedLanguagesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>(
		GetSupportedLanguagesDocument,
		options
	);
}
export function useGetSupportedLanguagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSupportedLanguagesQuery,
		GetSupportedLanguagesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>(
		GetSupportedLanguagesDocument,
		options
	);
}
// @ts-ignore
export function useGetSupportedLanguagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetSupportedLanguagesQuery,
		GetSupportedLanguagesQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>;
export function useGetSupportedLanguagesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetSupportedLanguagesQuery,
				GetSupportedLanguagesQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetSupportedLanguagesQuery | undefined,
	GetSupportedLanguagesQueryVariables
>;
export function useGetSupportedLanguagesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetSupportedLanguagesQuery,
				GetSupportedLanguagesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>(
		GetSupportedLanguagesDocument,
		options
	);
}
export type GetSupportedLanguagesQueryHookResult = ReturnType<typeof useGetSupportedLanguagesQuery>;
export type GetSupportedLanguagesLazyQueryHookResult = ReturnType<
	typeof useGetSupportedLanguagesLazyQuery
>;
export type GetSupportedLanguagesSuspenseQueryHookResult = ReturnType<
	typeof useGetSupportedLanguagesSuspenseQuery
>;
export type GetSupportedLanguagesQueryResult = Apollo.QueryResult<
	GetSupportedLanguagesQuery,
	GetSupportedLanguagesQueryVariables
>;
export const GetSystemSettingsDocument = gql`
	query GetSystemSettings {
		getSystemSettings {
			id
			createdAt
			updatedAt
		}
	}
`;

/**
 * __useGetSystemSettingsQuery__
 *
 * To run a query within a React component, call `useGetSystemSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSystemSettingsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
		GetSystemSettingsDocument,
		options
	);
}
export function useGetSystemSettingsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSystemSettingsQuery,
		GetSystemSettingsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
		GetSystemSettingsDocument,
		options
	);
}
// @ts-ignore
export function useGetSystemSettingsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetSystemSettingsQuery,
		GetSystemSettingsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>;
export function useGetSystemSettingsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>
): Apollo.UseSuspenseQueryResult<
	GetSystemSettingsQuery | undefined,
	GetSystemSettingsQueryVariables
>;
export function useGetSystemSettingsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(
		GetSystemSettingsDocument,
		options
	);
}
export type GetSystemSettingsQueryHookResult = ReturnType<typeof useGetSystemSettingsQuery>;
export type GetSystemSettingsLazyQueryHookResult = ReturnType<typeof useGetSystemSettingsLazyQuery>;
export type GetSystemSettingsSuspenseQueryHookResult = ReturnType<
	typeof useGetSystemSettingsSuspenseQuery
>;
export type GetSystemSettingsQueryResult = Apollo.QueryResult<
	GetSystemSettingsQuery,
	GetSystemSettingsQueryVariables
>;
export const GetAllUsersDocument = gql`
	query GetAllUsers($input: GetAllUserInput!) {
		getAllUsers(input: $input) {
			data {
				id
				userId
				firstName
				lastName
				createdAt
				updatedAt
				authenticationUser {
					id
					email
					role
					language
					lastActive
					isPremium
					isMigrated
					status
					premiumRequestedAt
					premiumApprovedAt
					mfaBypassedAt
				}
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllUsersQuery(
	baseOptions: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables> &
		({ variables: GetAllUsersQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(
		GetAllUsersDocument,
		options
	);
}
export function useGetAllUsersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(
		GetAllUsersDocument,
		options
	);
}
// @ts-ignore
export function useGetAllUsersSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export function useGetAllUsersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAllUsersQuery | undefined, GetAllUsersQueryVariables>;
export function useGetAllUsersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(
		GetAllUsersDocument,
		options
	);
}
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllUsersSuspenseQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<
	GetAllUsersQuery,
	GetAllUsersQueryVariables
>;
export const GetAllUserAuthenticationUserDocument = gql`
	query GetAllUserAuthenticationUser($input: GetAllUserAuthenticationUserInput!) {
		getAllUserAuthenticationUser(input: $input) {
			data {
				id
				email
				role
				lastActive
				createdAt
				isPremium
				premiumRequestedAt
				premiumApprovedAt
				user {
					id
					firstName
					lastName
				}
			}
			pageInfo {
				...PageInfoFragment
			}
		}
	}
	${PageInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllUserAuthenticationUserQuery__
 *
 * To run a query within a React component, call `useGetAllUserAuthenticationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserAuthenticationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserAuthenticationUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllUserAuthenticationUserQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetAllUserAuthenticationUserQuery,
		GetAllUserAuthenticationUserQueryVariables
	> &
		(
			| { variables: GetAllUserAuthenticationUserQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllUserAuthenticationUserQuery,
		GetAllUserAuthenticationUserQueryVariables
	>(GetAllUserAuthenticationUserDocument, options);
}
export function useGetAllUserAuthenticationUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllUserAuthenticationUserQuery,
		GetAllUserAuthenticationUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllUserAuthenticationUserQuery,
		GetAllUserAuthenticationUserQueryVariables
	>(GetAllUserAuthenticationUserDocument, options);
}
// @ts-ignore
export function useGetAllUserAuthenticationUserSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllUserAuthenticationUserQuery,
		GetAllUserAuthenticationUserQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllUserAuthenticationUserQuery,
	GetAllUserAuthenticationUserQueryVariables
>;
export function useGetAllUserAuthenticationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllUserAuthenticationUserQuery,
				GetAllUserAuthenticationUserQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllUserAuthenticationUserQuery | undefined,
	GetAllUserAuthenticationUserQueryVariables
>;
export function useGetAllUserAuthenticationUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllUserAuthenticationUserQuery,
				GetAllUserAuthenticationUserQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllUserAuthenticationUserQuery,
		GetAllUserAuthenticationUserQueryVariables
	>(GetAllUserAuthenticationUserDocument, options);
}
export type GetAllUserAuthenticationUserQueryHookResult = ReturnType<
	typeof useGetAllUserAuthenticationUserQuery
>;
export type GetAllUserAuthenticationUserLazyQueryHookResult = ReturnType<
	typeof useGetAllUserAuthenticationUserLazyQuery
>;
export type GetAllUserAuthenticationUserSuspenseQueryHookResult = ReturnType<
	typeof useGetAllUserAuthenticationUserSuspenseQuery
>;
export type GetAllUserAuthenticationUserQueryResult = Apollo.QueryResult<
	GetAllUserAuthenticationUserQuery,
	GetAllUserAuthenticationUserQueryVariables
>;
export const GetAllWellBeingSurveyQuestionsDocument = gql`
	query GetAllWellBeingSurveyQuestions {
		getAllWellBeingSurveyQuestionsWithTranslations {
			id
			questionKey
			sortOrder
			translations {
				language
				text
			}
		}
	}
`;

/**
 * __useGetAllWellBeingSurveyQuestionsQuery__
 *
 * To run a query within a React component, call `useGetAllWellBeingSurveyQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWellBeingSurveyQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWellBeingSurveyQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllWellBeingSurveyQuestionsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllWellBeingSurveyQuestionsQuery,
		GetAllWellBeingSurveyQuestionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetAllWellBeingSurveyQuestionsQuery,
		GetAllWellBeingSurveyQuestionsQueryVariables
	>(GetAllWellBeingSurveyQuestionsDocument, options);
}
export function useGetAllWellBeingSurveyQuestionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllWellBeingSurveyQuestionsQuery,
		GetAllWellBeingSurveyQuestionsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllWellBeingSurveyQuestionsQuery,
		GetAllWellBeingSurveyQuestionsQueryVariables
	>(GetAllWellBeingSurveyQuestionsDocument, options);
}
// @ts-ignore
export function useGetAllWellBeingSurveyQuestionsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllWellBeingSurveyQuestionsQuery,
		GetAllWellBeingSurveyQuestionsQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllWellBeingSurveyQuestionsQuery,
	GetAllWellBeingSurveyQuestionsQueryVariables
>;
export function useGetAllWellBeingSurveyQuestionsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllWellBeingSurveyQuestionsQuery,
				GetAllWellBeingSurveyQuestionsQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllWellBeingSurveyQuestionsQuery | undefined,
	GetAllWellBeingSurveyQuestionsQueryVariables
>;
export function useGetAllWellBeingSurveyQuestionsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllWellBeingSurveyQuestionsQuery,
				GetAllWellBeingSurveyQuestionsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllWellBeingSurveyQuestionsQuery,
		GetAllWellBeingSurveyQuestionsQueryVariables
	>(GetAllWellBeingSurveyQuestionsDocument, options);
}
export type GetAllWellBeingSurveyQuestionsQueryHookResult = ReturnType<
	typeof useGetAllWellBeingSurveyQuestionsQuery
>;
export type GetAllWellBeingSurveyQuestionsLazyQueryHookResult = ReturnType<
	typeof useGetAllWellBeingSurveyQuestionsLazyQuery
>;
export type GetAllWellBeingSurveyQuestionsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllWellBeingSurveyQuestionsSuspenseQuery
>;
export type GetAllWellBeingSurveyQuestionsQueryResult = Apollo.QueryResult<
	GetAllWellBeingSurveyQuestionsQuery,
	GetAllWellBeingSurveyQuestionsQueryVariables
>;
export const GetAllWorkoutCategoriesDocument = gql`
	query GetAllWorkoutCategories {
		getAllWorkoutCategories {
			id
			name
			color
			headerColor
			cardColor
			headerSvg
			illustrationSvg
			translations {
				language
				name
			}
			isActive
		}
	}
`;

/**
 * __useGetAllWorkoutCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllWorkoutCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWorkoutCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWorkoutCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllWorkoutCategoriesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllWorkoutCategoriesQuery,
		GetAllWorkoutCategoriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllWorkoutCategoriesQuery, GetAllWorkoutCategoriesQueryVariables>(
		GetAllWorkoutCategoriesDocument,
		options
	);
}
export function useGetAllWorkoutCategoriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllWorkoutCategoriesQuery,
		GetAllWorkoutCategoriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllWorkoutCategoriesQuery, GetAllWorkoutCategoriesQueryVariables>(
		GetAllWorkoutCategoriesDocument,
		options
	);
}
// @ts-ignore
export function useGetAllWorkoutCategoriesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GetAllWorkoutCategoriesQuery,
		GetAllWorkoutCategoriesQueryVariables
	>
): Apollo.UseSuspenseQueryResult<
	GetAllWorkoutCategoriesQuery,
	GetAllWorkoutCategoriesQueryVariables
>;
export function useGetAllWorkoutCategoriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllWorkoutCategoriesQuery,
				GetAllWorkoutCategoriesQueryVariables
		  >
): Apollo.UseSuspenseQueryResult<
	GetAllWorkoutCategoriesQuery | undefined,
	GetAllWorkoutCategoriesQueryVariables
>;
export function useGetAllWorkoutCategoriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllWorkoutCategoriesQuery,
				GetAllWorkoutCategoriesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllWorkoutCategoriesQuery,
		GetAllWorkoutCategoriesQueryVariables
	>(GetAllWorkoutCategoriesDocument, options);
}
export type GetAllWorkoutCategoriesQueryHookResult = ReturnType<
	typeof useGetAllWorkoutCategoriesQuery
>;
export type GetAllWorkoutCategoriesLazyQueryHookResult = ReturnType<
	typeof useGetAllWorkoutCategoriesLazyQuery
>;
export type GetAllWorkoutCategoriesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllWorkoutCategoriesSuspenseQuery
>;
export type GetAllWorkoutCategoriesQueryResult = Apollo.QueryResult<
	GetAllWorkoutCategoriesQuery,
	GetAllWorkoutCategoriesQueryVariables
>;
export const GetAllWorkoutsDocument = gql`
	query GetAllWorkouts($categoryId: ID) {
		getAllWorkouts(categoryId: $categoryId) {
			id
			name
			categoryId
			sortOrder
			type
			category {
				id
				name
			}
			intensity
			frequency
			frequencyPeriod
			durationMin
			durationMax
			isPremium
			why
			about
			instructions
			thankYouMessage
			reflectionMessage
			translations {
				language
				name
				why
				about
				instructions
				thankYouMessage
				reflectionMessage
			}
			isActive
			createdAt
			updatedAt
			exercises {
				id
				name
				description
				sortOrder
				groupId
				durationMin
				durationMax
				tips
				translations {
					language
					name
					description
					tips
				}
				typeData {
					... on ReflectionInputData {
						inputs {
							title
							placeholder
							translations {
								language
								title
								placeholder
							}
						}
					}
					... on AudioData {
						url
						duration
						fileId
						mediaUrls {
							language
							url
							fileId
						}
					}
					... on VideoData {
						url
						duration
						fileId
						mediaUrls {
							language
							url
							fileId
						}
					}
					... on BreathingData {
						inhale
						inhaleHold
						exhale
						exhaleHold
						mediaUrl
						instructions
						mediaUrls {
							language
							url
							fileId
						}
					}
					... on ImageUploadData {
						minImages
						maxImages
					}
				}
			}
		}
	}
`;

/**
 * __useGetAllWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetAllWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWorkoutsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetAllWorkoutsQuery(
	baseOptions?: Apollo.QueryHookOptions<GetAllWorkoutsQuery, GetAllWorkoutsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllWorkoutsQuery, GetAllWorkoutsQueryVariables>(
		GetAllWorkoutsDocument,
		options
	);
}
export function useGetAllWorkoutsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetAllWorkoutsQuery, GetAllWorkoutsQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetAllWorkoutsQuery, GetAllWorkoutsQueryVariables>(
		GetAllWorkoutsDocument,
		options
	);
}
// @ts-ignore
export function useGetAllWorkoutsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllWorkoutsQuery, GetAllWorkoutsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAllWorkoutsQuery, GetAllWorkoutsQueryVariables>;
export function useGetAllWorkoutsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllWorkoutsQuery, GetAllWorkoutsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetAllWorkoutsQuery | undefined, GetAllWorkoutsQueryVariables>;
export function useGetAllWorkoutsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetAllWorkoutsQuery, GetAllWorkoutsQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetAllWorkoutsQuery, GetAllWorkoutsQueryVariables>(
		GetAllWorkoutsDocument,
		options
	);
}
export type GetAllWorkoutsQueryHookResult = ReturnType<typeof useGetAllWorkoutsQuery>;
export type GetAllWorkoutsLazyQueryHookResult = ReturnType<typeof useGetAllWorkoutsLazyQuery>;
export type GetAllWorkoutsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllWorkoutsSuspenseQuery
>;
export type GetAllWorkoutsQueryResult = Apollo.QueryResult<
	GetAllWorkoutsQuery,
	GetAllWorkoutsQueryVariables
>;
export const GetWorkoutDocument = gql`
	query GetWorkout($id: ID!) {
		getWorkout(id: $id) {
			id
			name
			categoryId
			type
			category {
				id
				name
			}
			intensity
			frequency
			frequencyPeriod
			durationMin
			durationMax
			isPremium
			why
			about
			instructions
			thankYouMessage
			reflectionMessage
			translations {
				language
				name
				why
				about
				instructions
				thankYouMessage
				reflectionMessage
			}
			isActive
			createdAt
			updatedAt
			exercises {
				id
				name
				description
				sortOrder
				groupId
				durationMin
				durationMax
				tips
				translations {
					language
					name
					description
					tips
				}
				typeData {
					... on ReflectionInputData {
						inputs {
							title
							placeholder
							translations {
								language
								title
								placeholder
							}
						}
					}
					... on AudioData {
						url
						duration
						fileId
						mediaUrls {
							language
							url
							fileId
						}
					}
					... on VideoData {
						url
						duration
						fileId
						mediaUrls {
							language
							url
							fileId
						}
					}
					... on BreathingData {
						inhale
						inhaleHold
						exhale
						exhaleHold
						mediaUrl
						instructions
						mediaUrls {
							language
							url
							fileId
						}
					}
					... on ImageUploadData {
						minImages
						maxImages
					}
				}
			}
		}
	}
`;

/**
 * __useGetWorkoutQuery__
 *
 * To run a query within a React component, call `useGetWorkoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkoutQuery(
	baseOptions: Apollo.QueryHookOptions<GetWorkoutQuery, GetWorkoutQueryVariables> &
		({ variables: GetWorkoutQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetWorkoutQuery, GetWorkoutQueryVariables>(GetWorkoutDocument, options);
}
export function useGetWorkoutLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetWorkoutQuery, GetWorkoutQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetWorkoutQuery, GetWorkoutQueryVariables>(
		GetWorkoutDocument,
		options
	);
}
// @ts-ignore
export function useGetWorkoutSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkoutQuery, GetWorkoutQueryVariables>
): Apollo.UseSuspenseQueryResult<GetWorkoutQuery, GetWorkoutQueryVariables>;
export function useGetWorkoutSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetWorkoutQuery, GetWorkoutQueryVariables>
): Apollo.UseSuspenseQueryResult<GetWorkoutQuery | undefined, GetWorkoutQueryVariables>;
export function useGetWorkoutSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetWorkoutQuery, GetWorkoutQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetWorkoutQuery, GetWorkoutQueryVariables>(
		GetWorkoutDocument,
		options
	);
}
export type GetWorkoutQueryHookResult = ReturnType<typeof useGetWorkoutQuery>;
export type GetWorkoutLazyQueryHookResult = ReturnType<typeof useGetWorkoutLazyQuery>;
export type GetWorkoutSuspenseQueryHookResult = ReturnType<typeof useGetWorkoutSuspenseQuery>;
export type GetWorkoutQueryResult = Apollo.QueryResult<GetWorkoutQuery, GetWorkoutQueryVariables>;
